var Tl = Object.defineProperty;
var xl = (r, t, e) => t in r ? Tl(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var o = (r, t, e) => (xl(r, typeof t != "symbol" ? t + "" : t, e), e);
var F = /* @__PURE__ */ ((r) => (r.GET = "GET", r.POST = "POST", r.PUT = "PUT", r.DELETE = "DELETE", r.PATCH = "PATCH", r))(F || {});
function ti(r) {
  this._maxSize = r, this.clear();
}
ti.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
ti.prototype.get = function(r) {
  return this._values[r];
};
ti.prototype.set = function(r, t) {
  return this._size >= this._maxSize && this.clear(), r in this._values || this._size++, this._values[r] = t;
};
var Dl = /[^.^\]^[]+|(?=\[\]|\.\.)/g, Pn = /^\d+$/, Rl = /^\d/, Nl = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, Pl = /^\s*(['"]?)(.*?)(\1)\s*$/, Ha = 512, pn = new ti(Ha), mn = new ti(Ha), fn = new ti(Ha), Kt = {
  Cache: ti,
  split: ma,
  normalizePath: oa,
  setter: function(r) {
    var t = oa(r);
    return mn.get(r) || mn.set(r, function(i, a) {
      for (var n = 0, l = t.length, u = i; n < l - 1; ) {
        var h = t[n];
        if (h === "__proto__" || h === "constructor" || h === "prototype")
          return i;
        u = u[t[n++]];
      }
      u[t[n]] = a;
    });
  },
  getter: function(r, t) {
    var e = oa(r);
    return fn.get(r) || fn.set(r, function(a) {
      for (var n = 0, l = e.length; n < l; )
        if (a != null || !t)
          a = a[e[n++]];
        else
          return;
      return a;
    });
  },
  join: function(r) {
    return r.reduce(function(t, e) {
      return t + (Ga(e) || Pn.test(e) ? "[" + e + "]" : (t ? "." : "") + e);
    }, "");
  },
  forEach: function(r, t, e) {
    Ml(Array.isArray(r) ? r : ma(r), t, e);
  }
};
function oa(r) {
  return pn.get(r) || pn.set(
    r,
    ma(r).map(function(t) {
      return t.replace(Pl, "$2");
    })
  );
}
function ma(r) {
  return r.match(Dl) || [""];
}
function Ml(r, t, e) {
  var i = r.length, a, n, l, u;
  for (n = 0; n < i; n++)
    a = r[n], a && (jl(a) && (a = '"' + a + '"'), u = Ga(a), l = !u && /^\d+$/.test(a), t.call(e, a, u, l, n, r));
}
function Ga(r) {
  return typeof r == "string" && r && ["'", '"'].indexOf(r.charAt(0)) !== -1;
}
function Ll(r) {
  return r.match(Rl) && !r.match(Pn);
}
function kl(r) {
  return Nl.test(r);
}
function jl(r) {
  return !Ga(r) && (Ll(r) || kl(r));
}
const ql = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, gr = (r) => r.match(ql) || [], vr = (r) => r[0].toUpperCase() + r.slice(1), Wa = (r, t) => gr(r).join(t).toLowerCase(), Mn = (r) => gr(r).reduce(
  (t, e) => `${t}${t ? e[0].toUpperCase() + e.slice(1).toLowerCase() : e.toLowerCase()}`,
  ""
), Ul = (r) => vr(Mn(r)), $l = (r) => Wa(r, "_"), Bl = (r) => Wa(r, "-"), Vl = (r) => vr(Wa(r, " ")), Hl = (r) => gr(r).map(vr).join(" ");
var ua = {
  words: gr,
  upperFirst: vr,
  camelCase: Mn,
  pascalCase: Ul,
  snakeCase: $l,
  kebabCase: Bl,
  sentenceCase: Vl,
  titleCase: Hl
}, bs = {}, Gl = {
  get exports() {
    return bs;
  },
  set exports(r) {
    bs = r;
  }
};
Gl.exports = function(r) {
  return Ln(Wl(r), r);
};
bs.array = Ln;
function Ln(r, t) {
  var e = r.length, i = new Array(e), a = {}, n = e, l = zl(t), u = Kl(r);
  for (t.forEach(function(c) {
    if (!u.has(c[0]) || !u.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); n--; )
    a[n] || h(r[n], n, /* @__PURE__ */ new Set());
  return i;
  function h(c, p, m) {
    if (m.has(c)) {
      var b;
      try {
        b = ", node was:" + JSON.stringify(c);
      } catch {
        b = "";
      }
      throw new Error("Cyclic dependency" + b);
    }
    if (!u.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!a[p]) {
      a[p] = !0;
      var v = l.get(c) || /* @__PURE__ */ new Set();
      if (v = Array.from(v), p = v.length) {
        m.add(c);
        do {
          var g = v[--p];
          h(g, u.get(g), m);
        } while (p);
        m.delete(c);
      }
      i[--e] = c;
    }
  }
}
function Wl(r) {
  for (var t = /* @__PURE__ */ new Set(), e = 0, i = r.length; e < i; e++) {
    var a = r[e];
    t.add(a[0]), t.add(a[1]);
  }
  return Array.from(t);
}
function zl(r) {
  for (var t = /* @__PURE__ */ new Map(), e = 0, i = r.length; e < i; e++) {
    var a = r[e];
    t.has(a[0]) || t.set(a[0], /* @__PURE__ */ new Set()), t.has(a[1]) || t.set(a[1], /* @__PURE__ */ new Set()), t.get(a[0]).add(a[1]);
  }
  return t;
}
function Kl(r) {
  for (var t = /* @__PURE__ */ new Map(), e = 0, i = r.length; e < i; e++)
    t.set(r[e], e);
  return t;
}
const Yl = Object.prototype.toString, Ql = Error.prototype.toString, Jl = RegExp.prototype.toString, Zl = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", Xl = /^Symbol\((.*)\)(.*)$/;
function _l(r) {
  return r != +r ? "NaN" : r === 0 && 1 / r < 0 ? "-0" : "" + r;
}
function bn(r, t = !1) {
  if (r == null || r === !0 || r === !1)
    return "" + r;
  const e = typeof r;
  if (e === "number")
    return _l(r);
  if (e === "string")
    return t ? `"${r}"` : r;
  if (e === "function")
    return "[Function " + (r.name || "anonymous") + "]";
  if (e === "symbol")
    return Zl.call(r).replace(Xl, "Symbol($1)");
  const i = Yl.call(r).slice(8, -1);
  return i === "Date" ? isNaN(r.getTime()) ? "" + r : r.toISOString(r) : i === "Error" || r instanceof Error ? "[" + Ql.call(r) + "]" : i === "RegExp" ? Jl.call(r) : null;
}
function Yt(r, t) {
  let e = bn(r, t);
  return e !== null ? e : JSON.stringify(r, function(i, a) {
    let n = bn(this[i], t);
    return n !== null ? n : a;
  }, 2);
}
function kn(r) {
  return r == null ? [] : [].concat(r);
}
let eo = /\$\{\s*(\w+)\s*\}/g;
class Se extends Error {
  static formatError(t, e) {
    const i = e.label || e.path || "this";
    return i !== e.path && (e = Object.assign({}, e, {
      path: i
    })), typeof t == "string" ? t.replace(eo, (a, n) => Yt(e[n])) : typeof t == "function" ? t(e) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, e, i, a) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = e, this.path = i, this.type = a, this.errors = [], this.inner = [], kn(t).forEach((n) => {
      Se.isError(n) ? (this.errors.push(...n.errors), this.inner = this.inner.concat(n.inner.length ? n.inner : n)) : this.errors.push(n);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, Se);
  }
}
let ht = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: r,
    type: t,
    value: e,
    originalValue: i
  }) => {
    const a = i != null && i !== e ? ` (cast from the value \`${Yt(i, !0)}\`).` : ".";
    return t !== "mixed" ? `${r} must be a \`${t}\` type, but the final value was: \`${Yt(e, !0)}\`` + a : `${r} must match the configured type. The validated value was: \`${Yt(e, !0)}\`` + a;
  }
}, ze = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, yt = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, fa = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, ba = {
  isValue: "${path} field must be ${value}"
}, ga = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, os = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: ht,
  string: ze,
  number: yt,
  date: fa,
  object: ga,
  array: os,
  boolean: ba
});
const Er = (r) => r && r.__isYupSchema__;
class gs {
  static fromOptions(t, e) {
    if (!e.then && !e.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: i,
      then: a,
      otherwise: n
    } = e, l = typeof i == "function" ? i : (...u) => u.every((h) => h === i);
    return new gs(t, (u, h) => {
      var c;
      let p = l(...u) ? a : n;
      return (c = p == null ? void 0 : p(h)) != null ? c : h;
    });
  }
  constructor(t, e) {
    this.fn = void 0, this.refs = t, this.refs = t, this.fn = e;
  }
  resolve(t, e) {
    let i = this.refs.map((n) => (
      // TODO: ? operator here?
      n.getValue(e == null ? void 0 : e.value, e == null ? void 0 : e.parent, e == null ? void 0 : e.context)
    )), a = this.fn(i, t, e);
    if (a === void 0 || // @ts-ignore this can be base
    a === t)
      return t;
    if (!Er(a))
      throw new TypeError("conditions must return a schema object");
    return a.resolve(e);
  }
}
const as = {
  context: "$",
  value: "."
};
class ii {
  constructor(t, e = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string")
      throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === as.context, this.isValue = this.key[0] === as.value, this.isSibling = !this.isContext && !this.isValue;
    let i = this.isContext ? as.context : this.isValue ? as.value : "";
    this.path = this.key.slice(i.length), this.getter = this.path && Kt.getter(this.path, !0), this.map = e.map;
  }
  getValue(t, e, i) {
    let a = this.isContext ? i : this.isValue ? t : e;
    return this.getter && (a = this.getter(a || {})), this.map && (a = this.map(a)), a;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, e) {
    return this.getValue(t, e == null ? void 0 : e.parent, e == null ? void 0 : e.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
ii.prototype.__isYupRef = !0;
const Qe = (r) => r == null;
function ai(r) {
  function t({
    value: e,
    path: i = "",
    options: a,
    originalValue: n,
    schema: l
  }, u, h) {
    const {
      name: c,
      test: p,
      params: m,
      message: b,
      skipAbsent: v
    } = r;
    let {
      parent: g,
      context: w,
      abortEarly: O = l.spec.abortEarly
    } = a;
    function C(B) {
      return ii.isRef(B) ? B.getValue(e, g, w) : B;
    }
    function D(B = {}) {
      const Ae = Object.assign({
        value: e,
        originalValue: n,
        label: l.spec.label,
        path: B.path || i,
        spec: l.spec
      }, m, B.params);
      for (const Ze of Object.keys(Ae))
        Ae[Ze] = C(Ae[Ze]);
      const Je = new Se(Se.formatError(B.message || b, Ae), e, Ae.path, B.type || c);
      return Je.params = Ae, Je;
    }
    const M = O ? u : h;
    let $ = {
      path: i,
      parent: g,
      type: c,
      from: a.from,
      createError: D,
      resolve: C,
      options: a,
      originalValue: n,
      schema: l
    };
    const Z = (B) => {
      Se.isError(B) ? M(B) : B ? h(null) : M(D());
    }, te = (B) => {
      Se.isError(B) ? M(B) : u(B);
    }, oe = v && Qe(e);
    if (!a.sync) {
      try {
        Promise.resolve(oe ? !0 : p.call($, e, $)).then(Z, te);
      } catch (B) {
        te(B);
      }
      return;
    }
    let me;
    try {
      var Pe;
      if (me = oe ? !0 : p.call($, e, $), typeof ((Pe = me) == null ? void 0 : Pe.then) == "function")
        throw new Error(`Validation test of type: "${$.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch (B) {
      te(B);
      return;
    }
    Z(me);
  }
  return t.OPTIONS = r, t;
}
function jn(r, t, e, i = e) {
  let a, n, l;
  return t ? (Kt.forEach(t, (u, h, c) => {
    let p = h ? u.slice(1, u.length - 1) : u;
    r = r.resolve({
      context: i,
      parent: a,
      value: e
    });
    let m = r.type === "tuple", b = c ? parseInt(p, 10) : 0;
    if (r.innerType || m) {
      if (m && !c)
        throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${l}" must contain an index to the tuple element, e.g. "${l}[0]"`);
      if (e && b >= e.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${u}, in the path: ${t}. because there is no value at that index. `);
      a = e, e = e && e[b], r = m ? r.spec.types[b] : r.innerType;
    }
    if (!c) {
      if (!r.fields || !r.fields[p])
        throw new Error(`The schema does not contain the path: ${t}. (failed at: ${l} which is a type: "${r.type}")`);
      a = e, e = e && e[p], r = r.fields[p];
    }
    n = p, l = h ? "[" + u + "]" : "." + u;
  }), {
    schema: r,
    parent: a,
    parentPath: n
  }) : {
    parent: a,
    parentPath: t,
    schema: r
  };
}
function to(r, t, e, i) {
  return jn(r, t, e, i).schema;
}
class vs extends Set {
  describe() {
    const t = [];
    for (const e of this.values())
      t.push(ii.isRef(e) ? e.describe() : e);
    return t;
  }
  resolveAll(t) {
    let e = [];
    for (const i of this.values())
      e.push(t(i));
    return e;
  }
  clone() {
    return new vs(this.values());
  }
  merge(t, e) {
    const i = this.clone();
    return t.forEach((a) => i.add(a)), e.forEach((a) => i.delete(a)), i;
  }
}
function ci(r, t = /* @__PURE__ */ new Map()) {
  if (Er(r) || !r || typeof r != "object")
    return r;
  if (t.has(r))
    return t.get(r);
  let e;
  if (r instanceof Date)
    e = new Date(r.getTime()), t.set(r, e);
  else if (r instanceof RegExp)
    e = new RegExp(r), t.set(r, e);
  else if (Array.isArray(r)) {
    e = new Array(r.length), t.set(r, e);
    for (let i = 0; i < r.length; i++)
      e[i] = ci(r[i], t);
  } else if (r instanceof Map) {
    e = /* @__PURE__ */ new Map(), t.set(r, e);
    for (const [i, a] of r.entries())
      e.set(i, ci(a, t));
  } else if (r instanceof Set) {
    e = /* @__PURE__ */ new Set(), t.set(r, e);
    for (const i of r)
      e.add(ci(i, t));
  } else if (r instanceof Object) {
    e = {}, t.set(r, e);
    for (const [i, a] of Object.entries(r))
      e[i] = ci(a, t);
  } else
    throw Error(`Unable to clone ${r}`);
  return e;
}
class Oe {
  constructor(t) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new vs(), this._blacklist = new vs(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(ht.notType);
    }), this.type = t.type, this._typeCheck = t.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, t == null ? void 0 : t.spec), this.withMutation((e) => {
      e.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const e = Object.create(Object.getPrototypeOf(this));
    return e.type = this.type, e._typeCheck = this._typeCheck, e._whitelist = this._whitelist.clone(), e._blacklist = this._blacklist.clone(), e.internalTests = Object.assign({}, this.internalTests), e.exclusiveTests = Object.assign({}, this.exclusiveTests), e.deps = [...this.deps], e.conditions = [...this.conditions], e.tests = [...this.tests], e.transforms = [...this.transforms], e.spec = ci(Object.assign({}, this.spec, t)), e;
  }
  label(t) {
    let e = this.clone();
    return e.spec.label = t, e;
  }
  meta(...t) {
    if (t.length === 0)
      return this.spec.meta;
    let e = this.clone();
    return e.spec.meta = Object.assign(e.spec.meta || {}, t[0]), e;
  }
  withMutation(t) {
    let e = this._mutate;
    this._mutate = !0;
    let i = t(this);
    return this._mutate = e, i;
  }
  concat(t) {
    if (!t || t === this)
      return this;
    if (t.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let e = this, i = t.clone();
    const a = Object.assign({}, e.spec, i.spec);
    return i.spec = a, i.internalTests = Object.assign({}, e.internalTests, i.internalTests), i._whitelist = e._whitelist.merge(t._whitelist, t._blacklist), i._blacklist = e._blacklist.merge(t._blacklist, t._whitelist), i.tests = e.tests, i.exclusiveTests = e.exclusiveTests, i.withMutation((n) => {
      t.tests.forEach((l) => {
        n.test(l.OPTIONS);
      });
    }), i.transforms = [...e.transforms, ...i.transforms], i;
  }
  isType(t) {
    return t == null ? !!(this.spec.nullable && t === null || this.spec.optional && t === void 0) : this._typeCheck(t);
  }
  resolve(t) {
    let e = this;
    if (e.conditions.length) {
      let i = e.conditions;
      e = e.clone(), e.conditions = [], e = i.reduce((a, n) => n.resolve(a, t), e), e = e.resolve(t);
    }
    return e;
  }
  resolveOptions(t) {
    var e, i, a;
    return Object.assign({}, t, {
      from: t.from || [],
      strict: (e = t.strict) != null ? e : this.spec.strict,
      abortEarly: (i = t.abortEarly) != null ? i : this.spec.abortEarly,
      recursive: (a = t.recursive) != null ? a : this.spec.recursive
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(t, e = {}) {
    let i = this.resolve(Object.assign({
      value: t
    }, e)), a = e.assert === "ignore-optionality", n = i._cast(t, e);
    if (e.assert !== !1 && !i.isType(n)) {
      if (a && Qe(n))
        return n;
      let l = Yt(t), u = Yt(n);
      throw new TypeError(`The value of ${e.path || "field"} could not be cast to a value that satisfies the schema type: "${i.type}". 

attempted value: ${l} 
` + (u !== l ? `result of cast: ${u}` : ""));
    }
    return n;
  }
  _cast(t, e) {
    let i = t === void 0 ? t : this.transforms.reduce((a, n) => n.call(this, a, t, this), t);
    return i === void 0 && (i = this.getDefault(e)), i;
  }
  _validate(t, e = {}, i, a) {
    let {
      path: n,
      originalValue: l = t,
      strict: u = this.spec.strict
    } = e, h = t;
    u || (h = this._cast(h, Object.assign({
      assert: !1
    }, e)));
    let c = [];
    for (let p of Object.values(this.internalTests))
      p && c.push(p);
    this.runTests({
      path: n,
      value: h,
      originalValue: l,
      options: e,
      tests: c
    }, i, (p) => {
      if (p.length)
        return a(p, h);
      this.runTests({
        path: n,
        value: h,
        originalValue: l,
        options: e,
        tests: this.tests
      }, i, a);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(t, e, i) {
    let a = !1, {
      tests: n,
      value: l,
      originalValue: u,
      path: h,
      options: c
    } = t, p = (w) => {
      a || (a = !0, e(w, l));
    }, m = (w) => {
      a || (a = !0, i(w, l));
    }, b = n.length, v = [];
    if (!b)
      return m([]);
    let g = {
      value: l,
      originalValue: u,
      path: h,
      options: c,
      schema: this
    };
    for (let w = 0; w < n.length; w++) {
      const O = n[w];
      O(g, p, function(D) {
        D && (v = v.concat(D)), --b <= 0 && m(v);
      });
    }
  }
  asNestedTest({
    key: t,
    index: e,
    parent: i,
    parentPath: a,
    originalParent: n,
    options: l
  }) {
    const u = t ?? e;
    if (u == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const h = typeof u == "number";
    let c = i[u];
    const p = Object.assign({}, l, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: i,
      value: c,
      originalValue: n[u],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [h ? "index" : "key"]: u,
      path: h || u.includes(".") ? `${a || ""}[${c ? u : `"${u}"`}]` : (a ? `${a}.` : "") + t
    });
    return (m, b, v) => this.resolve(p)._validate(c, p, b, v);
  }
  validate(t, e) {
    let i = this.resolve(Object.assign({}, e, {
      value: t
    }));
    return new Promise((a, n) => i._validate(t, e, (l, u) => {
      Se.isError(l) && (l.value = u), n(l);
    }, (l, u) => {
      l.length ? n(new Se(l, u)) : a(u);
    }));
  }
  validateSync(t, e) {
    let i = this.resolve(Object.assign({}, e, {
      value: t
    })), a;
    return i._validate(t, Object.assign({}, e, {
      sync: !0
    }), (n, l) => {
      throw Se.isError(n) && (n.value = l), n;
    }, (n, l) => {
      if (n.length)
        throw new Se(n, t);
      a = l;
    }), a;
  }
  isValid(t, e) {
    return this.validate(t, e).then(() => !0, (i) => {
      if (Se.isError(i))
        return !1;
      throw i;
    });
  }
  isValidSync(t, e) {
    try {
      return this.validateSync(t, e), !0;
    } catch (i) {
      if (Se.isError(i))
        return !1;
      throw i;
    }
  }
  _getDefault(t) {
    let e = this.spec.default;
    return e == null ? e : typeof e == "function" ? e.call(this, t) : ci(e);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault(t);
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    return this.clone({
      strict: t
    });
  }
  nullability(t, e) {
    const i = this.clone({
      nullable: t
    });
    return i.internalTests.nullable = ai({
      message: e,
      name: "nullable",
      test(a) {
        return a === null ? this.schema.spec.nullable : !0;
      }
    }), i;
  }
  optionality(t, e) {
    const i = this.clone({
      optional: t
    });
    return i.internalTests.optionality = ai({
      message: e,
      name: "optionality",
      test(a) {
        return a === void 0 ? this.schema.spec.optional : !0;
      }
    }), i;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(t = ht.defined) {
    return this.optionality(!1, t);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(t = ht.notNull) {
    return this.nullability(!1, t);
  }
  required(t = ht.required) {
    return this.clone().withMutation((e) => e.nonNullable(t).defined(t));
  }
  notRequired() {
    return this.clone().withMutation((t) => t.nullable().optional());
  }
  transform(t) {
    let e = this.clone();
    return e.transforms.push(t), e;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let e;
    if (t.length === 1 ? typeof t[0] == "function" ? e = {
      test: t[0]
    } : e = t[0] : t.length === 2 ? e = {
      name: t[0],
      test: t[1]
    } : e = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, e.message === void 0 && (e.message = ht.default), typeof e.test != "function")
      throw new TypeError("`test` is a required parameters");
    let i = this.clone(), a = ai(e), n = e.exclusive || e.name && i.exclusiveTests[e.name] === !0;
    if (e.exclusive && !e.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return e.name && (i.exclusiveTests[e.name] = !!e.exclusive), i.tests = i.tests.filter((l) => !(l.OPTIONS.name === e.name && (n || l.OPTIONS.test === a.OPTIONS.test))), i.tests.push(a), i;
  }
  when(t, e) {
    !Array.isArray(t) && typeof t != "string" && (e = t, t = ".");
    let i = this.clone(), a = kn(t).map((n) => new ii(n));
    return a.forEach((n) => {
      n.isSibling && i.deps.push(n.key);
    }), i.conditions.push(typeof e == "function" ? new gs(a, e) : gs.fromOptions(a, e)), i;
  }
  typeError(t) {
    let e = this.clone();
    return e.internalTests.typeError = ai({
      message: t,
      name: "typeError",
      skipAbsent: !0,
      test(i) {
        return this.schema._typeCheck(i) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), e;
  }
  oneOf(t, e = ht.oneOf) {
    let i = this.clone();
    return t.forEach((a) => {
      i._whitelist.add(a), i._blacklist.delete(a);
    }), i.internalTests.whiteList = ai({
      message: e,
      name: "oneOf",
      skipAbsent: !0,
      test(a) {
        let n = this.schema._whitelist, l = n.resolveAll(this.resolve);
        return l.includes(a) ? !0 : this.createError({
          params: {
            values: Array.from(n).join(", "),
            resolved: l
          }
        });
      }
    }), i;
  }
  notOneOf(t, e = ht.notOneOf) {
    let i = this.clone();
    return t.forEach((a) => {
      i._blacklist.add(a), i._whitelist.delete(a);
    }), i.internalTests.blacklist = ai({
      message: e,
      name: "notOneOf",
      test(a) {
        let n = this.schema._blacklist, l = n.resolveAll(this.resolve);
        return l.includes(a) ? this.createError({
          params: {
            values: Array.from(n).join(", "),
            resolved: l
          }
        }) : !0;
      }
    }), i;
  }
  strip(t = !0) {
    let e = this.clone();
    return e.spec.strip = t, e;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(t) {
    const e = (t ? this.resolve(t) : this).clone(), {
      label: i,
      meta: a,
      optional: n,
      nullable: l
    } = e.spec;
    return {
      meta: a,
      label: i,
      optional: n,
      nullable: l,
      default: e.getDefault(t),
      type: e.type,
      oneOf: e._whitelist.describe(),
      notOneOf: e._blacklist.describe(),
      tests: e.tests.map((h) => ({
        name: h.OPTIONS.name,
        params: h.OPTIONS.params
      })).filter((h, c, p) => p.findIndex((m) => m.name === h.name) === c)
    };
  }
}
Oe.prototype.__isYupSchema__ = !0;
for (const r of ["validate", "validateSync"])
  Oe.prototype[`${r}At`] = function(t, e, i = {}) {
    const {
      parent: a,
      parentPath: n,
      schema: l
    } = jn(this, t, e, i.context);
    return l[r](a && a[n], Object.assign({}, i, {
      parent: a,
      path: t
    }));
  };
for (const r of ["equals", "is"])
  Oe.prototype[r] = Oe.prototype.oneOf;
for (const r of ["not", "nope"])
  Oe.prototype[r] = Oe.prototype.notOneOf;
const io = () => !0;
function ut(r) {
  return new qn(r);
}
class qn extends Oe {
  constructor(t) {
    super(typeof t == "function" ? {
      type: "mixed",
      check: t
    } : Object.assign({
      type: "mixed",
      check: io
    }, t));
  }
}
ut.prototype = qn.prototype;
function y() {
  return new Un();
}
class Un extends Oe {
  constructor() {
    super({
      type: "boolean",
      check(t) {
        return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
      }
    }), this.withMutation(() => {
      this.transform((t, e, i) => {
        if (i.spec.coerce && !i.isType(t)) {
          if (/^(true|1)$/i.test(String(t)))
            return !0;
          if (/^(false|0)$/i.test(String(t)))
            return !1;
        }
        return t;
      });
    });
  }
  isTrue(t = ba.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(e) {
        return Qe(e) || e === !0;
      }
    });
  }
  isFalse(t = ba.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(e) {
        return Qe(e) || e === !1;
      }
    });
  }
  default(t) {
    return super.default(t);
  }
  defined(t) {
    return super.defined(t);
  }
  optional() {
    return super.optional();
  }
  required(t) {
    return super.required(t);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(t) {
    return super.nonNullable(t);
  }
  strip(t) {
    return super.strip(t);
  }
}
y.prototype = Un.prototype;
let so = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), ro = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), ao = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, no = (r) => Qe(r) || r === r.trim(), lo = {}.toString();
function d() {
  return new $n();
}
class $n extends Oe {
  constructor() {
    super({
      type: "string",
      check(t) {
        return t instanceof String && (t = t.valueOf()), typeof t == "string";
      }
    }), this.withMutation(() => {
      this.transform((t, e, i) => {
        if (!i.spec.coerce || i.isType(t) || Array.isArray(t))
          return t;
        const a = t != null && t.toString ? t.toString() : t;
        return a === lo ? t : a;
      });
    });
  }
  required(t) {
    return super.required(t).withMutation((e) => e.test({
      message: t || ht.required,
      name: "required",
      skipAbsent: !0,
      test: (i) => !!i.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((t) => (t.tests = t.tests.filter((e) => e.OPTIONS.name !== "required"), t));
  }
  length(t, e = ze.length) {
    return this.test({
      message: e,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      skipAbsent: !0,
      test(i) {
        return i.length === this.resolve(t);
      }
    });
  }
  min(t, e = ze.min) {
    return this.test({
      message: e,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(i) {
        return i.length >= this.resolve(t);
      }
    });
  }
  max(t, e = ze.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: e,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(i) {
        return i.length <= this.resolve(t);
      }
    });
  }
  matches(t, e) {
    let i = !1, a, n;
    return e && (typeof e == "object" ? {
      excludeEmptyString: i = !1,
      message: a,
      name: n
    } = e : a = e), this.test({
      name: n || "matches",
      message: a || ze.matches,
      params: {
        regex: t
      },
      skipAbsent: !0,
      test: (l) => l === "" && i || l.search(t) !== -1
    });
  }
  email(t = ze.email) {
    return this.matches(so, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = ze.url) {
    return this.matches(ro, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = ze.uuid) {
    return this.matches(ao, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = ze.trim) {
    return this.transform((e) => e != null ? e.trim() : e).test({
      message: t,
      name: "trim",
      test: no
    });
  }
  lowercase(t = ze.lowercase) {
    return this.transform((e) => Qe(e) ? e : e.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (e) => Qe(e) || e === e.toLowerCase()
    });
  }
  uppercase(t = ze.uppercase) {
    return this.transform((e) => Qe(e) ? e : e.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (e) => Qe(e) || e === e.toUpperCase()
    });
  }
}
d.prototype = $n.prototype;
let oo = (r) => r != +r;
function _() {
  return new Bn();
}
class Bn extends Oe {
  constructor() {
    super({
      type: "number",
      check(t) {
        return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !oo(t);
      }
    }), this.withMutation(() => {
      this.transform((t, e, i) => {
        if (!i.spec.coerce)
          return t;
        let a = t;
        if (typeof a == "string") {
          if (a = a.replace(/\s/g, ""), a === "")
            return NaN;
          a = +a;
        }
        return i.isType(a) || a === null ? a : parseFloat(a);
      });
    });
  }
  min(t, e = yt.min) {
    return this.test({
      message: e,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(i) {
        return i >= this.resolve(t);
      }
    });
  }
  max(t, e = yt.max) {
    return this.test({
      message: e,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(i) {
        return i <= this.resolve(t);
      }
    });
  }
  lessThan(t, e = yt.lessThan) {
    return this.test({
      message: e,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      skipAbsent: !0,
      test(i) {
        return i < this.resolve(t);
      }
    });
  }
  moreThan(t, e = yt.moreThan) {
    return this.test({
      message: e,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      skipAbsent: !0,
      test(i) {
        return i > this.resolve(t);
      }
    });
  }
  positive(t = yt.positive) {
    return this.moreThan(0, t);
  }
  negative(t = yt.negative) {
    return this.lessThan(0, t);
  }
  integer(t = yt.integer) {
    return this.test({
      name: "integer",
      message: t,
      skipAbsent: !0,
      test: (e) => Number.isInteger(e)
    });
  }
  truncate() {
    return this.transform((t) => Qe(t) ? t : t | 0);
  }
  round(t) {
    var e;
    let i = ["ceil", "floor", "round", "trunc"];
    if (t = ((e = t) == null ? void 0 : e.toLowerCase()) || "round", t === "trunc")
      return this.truncate();
    if (i.indexOf(t.toLowerCase()) === -1)
      throw new TypeError("Only valid options for round() are: " + i.join(", "));
    return this.transform((a) => Qe(a) ? a : Math[t](a));
  }
}
_.prototype = Bn.prototype;
var uo = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function co(r) {
  var t = [1, 4, 5, 6, 7, 10, 11], e = 0, i, a;
  if (a = uo.exec(r)) {
    for (var n = 0, l; l = t[n]; ++n)
      a[l] = +a[l] || 0;
    a[2] = (+a[2] || 1) - 1, a[3] = +a[3] || 1, a[7] = a[7] ? String(a[7]).substr(0, 3) : 0, (a[8] === void 0 || a[8] === "") && (a[9] === void 0 || a[9] === "") ? i = +new Date(a[1], a[2], a[3], a[4], a[5], a[6], a[7]) : (a[8] !== "Z" && a[9] !== void 0 && (e = a[10] * 60 + a[11], a[9] === "+" && (e = 0 - e)), i = Date.UTC(a[1], a[2], a[3], a[4], a[5] + e, a[6], a[7]));
  } else
    i = Date.parse ? Date.parse(r) : NaN;
  return i;
}
let Vn = new Date(""), ho = (r) => Object.prototype.toString.call(r) === "[object Date]";
function U() {
  return new Zi();
}
class Zi extends Oe {
  constructor() {
    super({
      type: "date",
      check(t) {
        return ho(t) && !isNaN(t.getTime());
      }
    }), this.withMutation(() => {
      this.transform((t, e, i) => !i.spec.coerce || i.isType(t) || t === null ? t : (t = co(t), isNaN(t) ? Zi.INVALID_DATE : new Date(t)));
    });
  }
  prepareParam(t, e) {
    let i;
    if (ii.isRef(t))
      i = t;
    else {
      let a = this.cast(t);
      if (!this._typeCheck(a))
        throw new TypeError(`\`${e}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = a;
    }
    return i;
  }
  min(t, e = fa.min) {
    let i = this.prepareParam(t, "min");
    return this.test({
      message: e,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(a) {
        return a >= this.resolve(i);
      }
    });
  }
  max(t, e = fa.max) {
    let i = this.prepareParam(t, "max");
    return this.test({
      message: e,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(a) {
        return a <= this.resolve(i);
      }
    });
  }
}
Zi.INVALID_DATE = Vn;
U.prototype = Zi.prototype;
U.INVALID_DATE = Vn;
function po(r, t = []) {
  let e = [], i = /* @__PURE__ */ new Set(), a = new Set(t.map(([l, u]) => `${l}-${u}`));
  function n(l, u) {
    let h = Kt.split(l)[0];
    i.add(h), a.has(`${u}-${h}`) || e.push([u, h]);
  }
  for (const l of Object.keys(r)) {
    let u = r[l];
    i.add(l), ii.isRef(u) && u.isSibling ? n(u.path, l) : Er(u) && "deps" in u && u.deps.forEach((h) => n(h, l));
  }
  return bs.array(Array.from(i), e).reverse();
}
function gn(r, t) {
  let e = 1 / 0;
  return r.some((i, a) => {
    var n;
    if ((n = t.path) != null && n.includes(i))
      return e = a, !0;
  }), e;
}
function Hn(r) {
  return (t, e) => gn(r, t) - gn(r, e);
}
const Gn = (r, t, e) => {
  if (typeof r != "string")
    return r;
  let i = r;
  try {
    i = JSON.parse(r);
  } catch {
  }
  return e.isType(i) ? i : r;
};
function us(r) {
  if ("fields" in r) {
    const t = {};
    for (const [e, i] of Object.entries(r.fields))
      t[e] = us(i);
    return r.setFields(t);
  }
  if (r.type === "array") {
    const t = r.optional();
    return t.innerType && (t.innerType = us(t.innerType)), t;
  }
  return r.type === "tuple" ? r.optional().clone({
    types: r.spec.types.map(us)
  }) : "optional" in r ? r.optional() : r;
}
const mo = (r, t) => {
  const e = [...Kt.normalizePath(t)];
  if (e.length === 1)
    return e[0] in r;
  let i = e.pop(), a = Kt.getter(Kt.join(e), !0)(r);
  return !!(a && i in a);
};
let vn = (r) => Object.prototype.toString.call(r) === "[object Object]";
function fo(r, t) {
  let e = Object.keys(r.fields);
  return Object.keys(t).filter((i) => e.indexOf(i) === -1);
}
const bo = Hn([]);
function f(r) {
  return new Wn(r);
}
class Wn extends Oe {
  constructor(t) {
    super({
      type: "object",
      check(e) {
        return vn(e) || typeof e == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = bo, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      t && this.shape(t);
    });
  }
  _cast(t, e = {}) {
    var i;
    let a = super._cast(t, e);
    if (a === void 0)
      return this.getDefault(e);
    if (!this._typeCheck(a))
      return a;
    let n = this.fields, l = (i = e.stripUnknown) != null ? i : this.spec.noUnknown, u = [].concat(this._nodes, Object.keys(a).filter((m) => !this._nodes.includes(m))), h = {}, c = Object.assign({}, e, {
      parent: h,
      __validating: e.__validating || !1
    }), p = !1;
    for (const m of u) {
      let b = n[m], v = m in a;
      if (b) {
        let g, w = a[m];
        c.path = (e.path ? `${e.path}.` : "") + m, b = b.resolve({
          value: w,
          context: e.context,
          parent: h
        });
        let O = b instanceof Oe ? b.spec : void 0, C = O == null ? void 0 : O.strict;
        if (O != null && O.strip) {
          p = p || m in a;
          continue;
        }
        g = !e.__validating || !C ? (
          // TODO: use _cast, this is double resolving
          b.cast(a[m], c)
        ) : a[m], g !== void 0 && (h[m] = g);
      } else
        v && !l && (h[m] = a[m]);
      (v !== m in h || h[m] !== a[m]) && (p = !0);
    }
    return p ? h : a;
  }
  _validate(t, e = {}, i, a) {
    let {
      from: n = [],
      originalValue: l = t,
      recursive: u = this.spec.recursive
    } = e;
    e.from = [{
      schema: this,
      value: l
    }, ...n], e.__validating = !0, e.originalValue = l, super._validate(t, e, i, (h, c) => {
      if (!u || !vn(c)) {
        a(h, c);
        return;
      }
      l = l || c;
      let p = [];
      for (let m of this._nodes) {
        let b = this.fields[m];
        !b || ii.isRef(b) || p.push(b.asNestedTest({
          options: e,
          key: m,
          parent: c,
          parentPath: e.path,
          originalParent: l
        }));
      }
      this.runTests({
        tests: p,
        value: c,
        originalValue: l,
        options: e
      }, i, (m) => {
        a(m.sort(this._sortErrors).concat(h), c);
      });
    });
  }
  clone(t) {
    const e = super.clone(t);
    return e.fields = Object.assign({}, this.fields), e._nodes = this._nodes, e._excludedEdges = this._excludedEdges, e._sortErrors = this._sortErrors, e;
  }
  concat(t) {
    let e = super.concat(t), i = e.fields;
    for (let [a, n] of Object.entries(this.fields)) {
      const l = i[a];
      i[a] = l === void 0 ? n : l;
    }
    return e.withMutation((a) => (
      // XXX: excludes here is wrong
      a.setFields(i, [...this._excludedEdges, ...t._excludedEdges])
    ));
  }
  _getDefault(t) {
    if ("default" in this.spec)
      return super._getDefault(t);
    if (!this._nodes.length)
      return;
    let e = {};
    return this._nodes.forEach((i) => {
      var a;
      const n = this.fields[i];
      let l = t;
      (a = l) != null && a.value && (l = Object.assign({}, l, {
        parent: l.value,
        value: l.value[i]
      })), e[i] = n && "getDefault" in n ? n.getDefault(l) : void 0;
    }), e;
  }
  setFields(t, e) {
    let i = this.clone();
    return i.fields = t, i._nodes = po(t, e), i._sortErrors = Hn(Object.keys(t)), e && (i._excludedEdges = e), i;
  }
  shape(t, e = []) {
    return this.clone().withMutation((i) => {
      let a = i._excludedEdges;
      return e.length && (Array.isArray(e[0]) || (e = [e]), a = [...i._excludedEdges, ...e]), i.setFields(Object.assign(i.fields, t), a);
    });
  }
  partial() {
    const t = {};
    for (const [e, i] of Object.entries(this.fields))
      t[e] = "optional" in i && i.optional instanceof Function ? i.optional() : i;
    return this.setFields(t);
  }
  deepPartial() {
    return us(this);
  }
  pick(t) {
    const e = {};
    for (const i of t)
      this.fields[i] && (e[i] = this.fields[i]);
    return this.setFields(e);
  }
  omit(t) {
    const e = Object.assign({}, this.fields);
    for (const i of t)
      delete e[i];
    return this.setFields(e);
  }
  from(t, e, i) {
    let a = Kt.getter(t, !0);
    return this.transform((n) => {
      if (!n)
        return n;
      let l = n;
      return mo(n, t) && (l = Object.assign({}, n), i || delete l[t], l[e] = a(n)), l;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(Gn);
  }
  noUnknown(t = !0, e = ga.noUnknown) {
    typeof t != "boolean" && (e = t, t = !0);
    let i = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: e,
      test(a) {
        if (a == null)
          return !0;
        const n = fo(this.schema, a);
        return !t || n.length === 0 || this.createError({
          params: {
            unknown: n.join(", ")
          }
        });
      }
    });
    return i.spec.noUnknown = t, i;
  }
  unknown(t = !0, e = ga.noUnknown) {
    return this.noUnknown(!t, e);
  }
  transformKeys(t) {
    return this.transform((e) => {
      if (!e)
        return e;
      const i = {};
      for (const a of Object.keys(e))
        i[t(a)] = e[a];
      return i;
    });
  }
  camelCase() {
    return this.transformKeys(ua.camelCase);
  }
  snakeCase() {
    return this.transformKeys(ua.snakeCase);
  }
  constantCase() {
    return this.transformKeys((t) => ua.snakeCase(t).toUpperCase());
  }
  describe(t) {
    let e = super.describe(t);
    e.fields = {};
    for (const [a, n] of Object.entries(this.fields)) {
      var i;
      let l = t;
      (i = l) != null && i.value && (l = Object.assign({}, l, {
        parent: l.value,
        value: l.value[a]
      })), e.fields[a] = n.describe(l);
    }
    return e;
  }
}
f.prototype = Wn.prototype;
function R(r) {
  return new zn(r);
}
class zn extends Oe {
  constructor(t) {
    super({
      type: "array",
      spec: {
        types: t
      },
      check(e) {
        return Array.isArray(e);
      }
    }), this.innerType = void 0, this.innerType = t;
  }
  _cast(t, e) {
    const i = super._cast(t, e);
    if (!this._typeCheck(i) || !this.innerType)
      return i;
    let a = !1;
    const n = i.map((l, u) => {
      const h = this.innerType.cast(l, Object.assign({}, e, {
        path: `${e.path || ""}[${u}]`
      }));
      return h !== l && (a = !0), h;
    });
    return a ? n : i;
  }
  _validate(t, e = {}, i, a) {
    var n;
    let l = this.innerType, u = (n = e.recursive) != null ? n : this.spec.recursive;
    e.originalValue != null && e.originalValue, super._validate(t, e, i, (h, c) => {
      var p;
      if (!u || !l || !this._typeCheck(c)) {
        a(h, c);
        return;
      }
      let m = new Array(c.length);
      for (let v = 0; v < c.length; v++) {
        var b;
        m[v] = l.asNestedTest({
          options: e,
          index: v,
          parent: c,
          parentPath: e.path,
          originalParent: (b = e.originalValue) != null ? b : t
        });
      }
      this.runTests({
        value: c,
        tests: m,
        originalValue: (p = e.originalValue) != null ? p : t,
        options: e
      }, i, (v) => a(v.concat(h), c));
    });
  }
  clone(t) {
    const e = super.clone(t);
    return e.innerType = this.innerType, e;
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(Gn);
  }
  concat(t) {
    let e = super.concat(t);
    return e.innerType = this.innerType, t.innerType && (e.innerType = e.innerType ? (
      // @ts-expect-error Lazy doesn't have concat and will break
      e.innerType.concat(t.innerType)
    ) : t.innerType), e;
  }
  of(t) {
    let e = this.clone();
    if (!Er(t))
      throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + Yt(t));
    return e.innerType = t, e.spec = Object.assign({}, e.spec, {
      types: t
    }), e;
  }
  length(t, e = os.length) {
    return this.test({
      message: e,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      skipAbsent: !0,
      test(i) {
        return i.length === this.resolve(t);
      }
    });
  }
  min(t, e) {
    return e = e || os.min, this.test({
      message: e,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      // FIXME(ts): Array<typeof T>
      test(i) {
        return i.length >= this.resolve(t);
      }
    });
  }
  max(t, e) {
    return e = e || os.max, this.test({
      message: e,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(i) {
        return i.length <= this.resolve(t);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((t, e) => this._typeCheck(t) ? t : e == null ? [] : [].concat(e));
  }
  compact(t) {
    let e = t ? (i, a, n) => !t(i, a, n) : (i) => !!i;
    return this.transform((i) => i != null ? i.filter(e) : i);
  }
  describe(t) {
    let e = super.describe(t);
    if (this.innerType) {
      var i;
      let a = t;
      (i = a) != null && i.value && (a = Object.assign({}, a, {
        parent: a.value,
        value: a.value[0]
      })), e.innerType = this.innerType.describe(a);
    }
    return e;
  }
}
R.prototype = zn.prototype;
class S {
  async parseRequest(t) {
    return t;
  }
  async parseResponse(t) {
    return t;
  }
  getValidationSchemaForField(t) {
    return to(this.validationSchema, t);
  }
  async validate() {
    return this.validationSchema.validateSync(this);
  }
  get validationError() {
    try {
      this.validationSchema.validateSync(this);
    } catch (t) {
      if (t instanceof Se)
        return t.message;
    }
    return null;
  }
  get isValid() {
    return this.validationSchema.isValidSync(this);
  }
  get requestMethod() {
    return F.POST;
  }
  get contentType() {
    return this.requestMethod === F.PATCH ? "application/merge-patch+json" : "application/ld+json";
  }
}
class Xi {
  get isValid() {
    return this.schemaConfig.isValidSync(this);
  }
  get validationError() {
    try {
      this.schemaConfig.validateSync(this);
    } catch (t) {
      if (t instanceof Se)
        return t.message;
    }
    return null;
  }
}
class I extends Xi {
  constructor(t) {
    super(), this.value = t;
  }
  equals(t) {
    return typeof t == "string" || typeof t == "number" || typeof t == "boolean" ? this.value === t : t instanceof I ? this.value === t.value : !1;
  }
  toString() {
    return String(this.value);
  }
}
let si = class Kn extends I {
  get schemaConfig() {
    return Kn.validationSchema;
  }
  static get validationSchema() {
    return d().trim().email();
  }
};
class wr extends I {
  get schemaConfig() {
    return wr.validationSchema;
  }
  static get validationSchema() {
    return d().min(4).max(255);
  }
}
class go extends S {
  constructor(t, e) {
    super(), this.email = t, this.password = e;
  }
  get validationSchema() {
    return f({
      email: si.validationSchema.required(),
      password: wr.validationSchema.required()
    });
  }
  get requestPath() {
    return "/token";
  }
  async parseResponse(t) {
    return {
      accessToken: t.token,
      refreshToken: t.refresh_token
    };
  }
}
class vo extends S {
  constructor(t) {
    super(), this.refresh_token = t;
  }
  get validationSchema() {
    return f({ refresh_token: d().required() });
  }
  get requestPath() {
    return "/refresh_token";
  }
  async parseResponse(t) {
    return {
      accessToken: t.token,
      refreshToken: t.refresh_token
    };
  }
}
function Yn(r, t) {
  return function() {
    return r.apply(t, arguments);
  };
}
const { toString: Qn } = Object.prototype, { getPrototypeOf: za } = Object, Ka = ((r) => (t) => {
  const e = Qn.call(t);
  return r[e] || (r[e] = e.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ft = (r) => (r = r.toLowerCase(), (t) => Ka(t) === r), Sr = (r) => (t) => typeof t === r, { isArray: Fi } = Array, Hi = Sr("undefined");
function Eo(r) {
  return r !== null && !Hi(r) && r.constructor !== null && !Hi(r.constructor) && Nt(r.constructor.isBuffer) && r.constructor.isBuffer(r);
}
const Jn = Ft("ArrayBuffer");
function wo(r) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(r) : t = r && r.buffer && Jn(r.buffer), t;
}
const So = Sr("string"), Nt = Sr("function"), Zn = Sr("number"), Ya = (r) => r !== null && typeof r == "object", Fo = (r) => r === !0 || r === !1, ds = (r) => {
  if (Ka(r) !== "object")
    return !1;
  const t = za(r);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in r) && !(Symbol.iterator in r);
}, Ao = Ft("Date"), yo = Ft("File"), Oo = Ft("Blob"), Co = Ft("FileList"), Io = (r) => Ya(r) && Nt(r.pipe), To = (r) => {
  const t = "[object FormData]";
  return r && (typeof FormData == "function" && r instanceof FormData || Qn.call(r) === t || Nt(r.toString) && r.toString() === t);
}, xo = Ft("URLSearchParams"), Do = (r) => r.trim ? r.trim() : r.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function _i(r, t, { allOwnKeys: e = !1 } = {}) {
  if (r === null || typeof r > "u")
    return;
  let i, a;
  if (typeof r != "object" && (r = [r]), Fi(r))
    for (i = 0, a = r.length; i < a; i++)
      t.call(null, r[i], i, r);
  else {
    const n = e ? Object.getOwnPropertyNames(r) : Object.keys(r), l = n.length;
    let u;
    for (i = 0; i < l; i++)
      u = n[i], t.call(null, r[u], u, r);
  }
}
function Xn(r, t) {
  t = t.toLowerCase();
  const e = Object.keys(r);
  let i = e.length, a;
  for (; i-- > 0; )
    if (a = e[i], t === a.toLowerCase())
      return a;
  return null;
}
const _n = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), el = (r) => !Hi(r) && r !== _n;
function va() {
  const { caseless: r } = el(this) && this || {}, t = {}, e = (i, a) => {
    const n = r && Xn(t, a) || a;
    ds(t[n]) && ds(i) ? t[n] = va(t[n], i) : ds(i) ? t[n] = va({}, i) : Fi(i) ? t[n] = i.slice() : t[n] = i;
  };
  for (let i = 0, a = arguments.length; i < a; i++)
    arguments[i] && _i(arguments[i], e);
  return t;
}
const Ro = (r, t, e, { allOwnKeys: i } = {}) => (_i(t, (a, n) => {
  e && Nt(a) ? r[n] = Yn(a, e) : r[n] = a;
}, { allOwnKeys: i }), r), No = (r) => (r.charCodeAt(0) === 65279 && (r = r.slice(1)), r), Po = (r, t, e, i) => {
  r.prototype = Object.create(t.prototype, i), r.prototype.constructor = r, Object.defineProperty(r, "super", {
    value: t.prototype
  }), e && Object.assign(r.prototype, e);
}, Mo = (r, t, e, i) => {
  let a, n, l;
  const u = {};
  if (t = t || {}, r == null)
    return t;
  do {
    for (a = Object.getOwnPropertyNames(r), n = a.length; n-- > 0; )
      l = a[n], (!i || i(l, r, t)) && !u[l] && (t[l] = r[l], u[l] = !0);
    r = e !== !1 && za(r);
  } while (r && (!e || e(r, t)) && r !== Object.prototype);
  return t;
}, Lo = (r, t, e) => {
  r = String(r), (e === void 0 || e > r.length) && (e = r.length), e -= t.length;
  const i = r.indexOf(t, e);
  return i !== -1 && i === e;
}, ko = (r) => {
  if (!r)
    return null;
  if (Fi(r))
    return r;
  let t = r.length;
  if (!Zn(t))
    return null;
  const e = new Array(t);
  for (; t-- > 0; )
    e[t] = r[t];
  return e;
}, jo = ((r) => (t) => r && t instanceof r)(typeof Uint8Array < "u" && za(Uint8Array)), qo = (r, t) => {
  const i = (r && r[Symbol.iterator]).call(r);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const n = a.value;
    t.call(r, n[0], n[1]);
  }
}, Uo = (r, t) => {
  let e;
  const i = [];
  for (; (e = r.exec(t)) !== null; )
    i.push(e);
  return i;
}, $o = Ft("HTMLFormElement"), Bo = (r) => r.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(e, i, a) {
    return i.toUpperCase() + a;
  }
), En = (({ hasOwnProperty: r }) => (t, e) => r.call(t, e))(Object.prototype), Vo = Ft("RegExp"), tl = (r, t) => {
  const e = Object.getOwnPropertyDescriptors(r), i = {};
  _i(e, (a, n) => {
    t(a, n, r) !== !1 && (i[n] = a);
  }), Object.defineProperties(r, i);
}, Ho = (r) => {
  tl(r, (t, e) => {
    if (Nt(r) && ["arguments", "caller", "callee"].indexOf(e) !== -1)
      return !1;
    const i = r[e];
    if (Nt(i)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + e + "'");
      });
    }
  });
}, Go = (r, t) => {
  const e = {}, i = (a) => {
    a.forEach((n) => {
      e[n] = !0;
    });
  };
  return Fi(r) ? i(r) : i(String(r).split(t)), e;
}, Wo = () => {
}, zo = (r, t) => (r = +r, Number.isFinite(r) ? r : t), da = "abcdefghijklmnopqrstuvwxyz", wn = "0123456789", il = {
  DIGIT: wn,
  ALPHA: da,
  ALPHA_DIGIT: da + da.toUpperCase() + wn
}, Ko = (r = 16, t = il.ALPHA_DIGIT) => {
  let e = "";
  const { length: i } = t;
  for (; r--; )
    e += t[Math.random() * i | 0];
  return e;
};
function Yo(r) {
  return !!(r && Nt(r.append) && r[Symbol.toStringTag] === "FormData" && r[Symbol.iterator]);
}
const Qo = (r) => {
  const t = new Array(10), e = (i, a) => {
    if (Ya(i)) {
      if (t.indexOf(i) >= 0)
        return;
      if (!("toJSON" in i)) {
        t[a] = i;
        const n = Fi(i) ? [] : {};
        return _i(i, (l, u) => {
          const h = e(l, a + 1);
          !Hi(h) && (n[u] = h);
        }), t[a] = void 0, n;
      }
    }
    return i;
  };
  return e(r, 0);
}, E = {
  isArray: Fi,
  isArrayBuffer: Jn,
  isBuffer: Eo,
  isFormData: To,
  isArrayBufferView: wo,
  isString: So,
  isNumber: Zn,
  isBoolean: Fo,
  isObject: Ya,
  isPlainObject: ds,
  isUndefined: Hi,
  isDate: Ao,
  isFile: yo,
  isBlob: Oo,
  isRegExp: Vo,
  isFunction: Nt,
  isStream: Io,
  isURLSearchParams: xo,
  isTypedArray: jo,
  isFileList: Co,
  forEach: _i,
  merge: va,
  extend: Ro,
  trim: Do,
  stripBOM: No,
  inherits: Po,
  toFlatObject: Mo,
  kindOf: Ka,
  kindOfTest: Ft,
  endsWith: Lo,
  toArray: ko,
  forEachEntry: qo,
  matchAll: Uo,
  isHTMLForm: $o,
  hasOwnProperty: En,
  hasOwnProp: En,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: tl,
  freezeMethods: Ho,
  toObjectSet: Go,
  toCamelCase: Bo,
  noop: Wo,
  toFiniteNumber: zo,
  findKey: Xn,
  global: _n,
  isContextDefined: el,
  ALPHABET: il,
  generateString: Ko,
  isSpecCompliantForm: Yo,
  toJSONObject: Qo
};
function L(r, t, e, i, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = r, this.name = "AxiosError", t && (this.code = t), e && (this.config = e), i && (this.request = i), a && (this.response = a);
}
E.inherits(L, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: E.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const sl = L.prototype, rl = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((r) => {
  rl[r] = { value: r };
});
Object.defineProperties(L, rl);
Object.defineProperty(sl, "isAxiosError", { value: !0 });
L.from = (r, t, e, i, a, n) => {
  const l = Object.create(sl);
  return E.toFlatObject(r, l, function(h) {
    return h !== Error.prototype;
  }, (u) => u !== "isAxiosError"), L.call(l, r.message, t, e, i, a), l.cause = r, l.name = r.name, n && Object.assign(l, n), l;
};
const Jo = null;
function Ea(r) {
  return E.isPlainObject(r) || E.isArray(r);
}
function al(r) {
  return E.endsWith(r, "[]") ? r.slice(0, -2) : r;
}
function Sn(r, t, e) {
  return r ? r.concat(t).map(function(a, n) {
    return a = al(a), !e && n ? "[" + a + "]" : a;
  }).join(e ? "." : "") : t;
}
function Zo(r) {
  return E.isArray(r) && !r.some(Ea);
}
const Xo = E.toFlatObject(E, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Fr(r, t, e) {
  if (!E.isObject(r))
    throw new TypeError("target must be an object");
  t = t || new FormData(), e = E.toFlatObject(e, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(w, O) {
    return !E.isUndefined(O[w]);
  });
  const i = e.metaTokens, a = e.visitor || p, n = e.dots, l = e.indexes, h = (e.Blob || typeof Blob < "u" && Blob) && E.isSpecCompliantForm(t);
  if (!E.isFunction(a))
    throw new TypeError("visitor must be a function");
  function c(g) {
    if (g === null)
      return "";
    if (E.isDate(g))
      return g.toISOString();
    if (!h && E.isBlob(g))
      throw new L("Blob is not supported. Use a Buffer instead.");
    return E.isArrayBuffer(g) || E.isTypedArray(g) ? h && typeof Blob == "function" ? new Blob([g]) : Buffer.from(g) : g;
  }
  function p(g, w, O) {
    let C = g;
    if (g && !O && typeof g == "object") {
      if (E.endsWith(w, "{}"))
        w = i ? w : w.slice(0, -2), g = JSON.stringify(g);
      else if (E.isArray(g) && Zo(g) || (E.isFileList(g) || E.endsWith(w, "[]")) && (C = E.toArray(g)))
        return w = al(w), C.forEach(function(M, $) {
          !(E.isUndefined(M) || M === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            l === !0 ? Sn([w], $, n) : l === null ? w : w + "[]",
            c(M)
          );
        }), !1;
    }
    return Ea(g) ? !0 : (t.append(Sn(O, w, n), c(g)), !1);
  }
  const m = [], b = Object.assign(Xo, {
    defaultVisitor: p,
    convertValue: c,
    isVisitable: Ea
  });
  function v(g, w) {
    if (!E.isUndefined(g)) {
      if (m.indexOf(g) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      m.push(g), E.forEach(g, function(C, D) {
        (!(E.isUndefined(C) || C === null) && a.call(
          t,
          C,
          E.isString(D) ? D.trim() : D,
          w,
          b
        )) === !0 && v(C, w ? w.concat(D) : [D]);
      }), m.pop();
    }
  }
  if (!E.isObject(r))
    throw new TypeError("data must be an object");
  return v(r), t;
}
function Fn(r) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(r).replace(/[!'()~]|%20|%00/g, function(i) {
    return t[i];
  });
}
function Qa(r, t) {
  this._pairs = [], r && Fr(r, this, t);
}
const nl = Qa.prototype;
nl.append = function(t, e) {
  this._pairs.push([t, e]);
};
nl.toString = function(t) {
  const e = t ? function(i) {
    return t.call(this, i, Fn);
  } : Fn;
  return this._pairs.map(function(a) {
    return e(a[0]) + "=" + e(a[1]);
  }, "").join("&");
};
function _o(r) {
  return encodeURIComponent(r).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function ll(r, t, e) {
  if (!t)
    return r;
  const i = e && e.encode || _o, a = e && e.serialize;
  let n;
  if (a ? n = a(t, e) : n = E.isURLSearchParams(t) ? t.toString() : new Qa(t, e).toString(i), n) {
    const l = r.indexOf("#");
    l !== -1 && (r = r.slice(0, l)), r += (r.indexOf("?") === -1 ? "?" : "&") + n;
  }
  return r;
}
class eu {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, e, i) {
    return this.handlers.push({
      fulfilled: t,
      rejected: e,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    E.forEach(this.handlers, function(i) {
      i !== null && t(i);
    });
  }
}
const An = eu, ol = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, tu = typeof URLSearchParams < "u" ? URLSearchParams : Qa, iu = typeof FormData < "u" ? FormData : null, su = typeof Blob < "u" ? Blob : null, ru = (() => {
  let r;
  return typeof navigator < "u" && ((r = navigator.product) === "ReactNative" || r === "NativeScript" || r === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), au = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), lt = {
  isBrowser: !0,
  classes: {
    URLSearchParams: tu,
    FormData: iu,
    Blob: su
  },
  isStandardBrowserEnv: ru,
  isStandardBrowserWebWorkerEnv: au,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function nu(r, t) {
  return Fr(r, new lt.classes.URLSearchParams(), Object.assign({
    visitor: function(e, i, a, n) {
      return lt.isNode && E.isBuffer(e) ? (this.append(i, e.toString("base64")), !1) : n.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function lu(r) {
  return E.matchAll(/\w+|\[(\w*)]/g, r).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function ou(r) {
  const t = {}, e = Object.keys(r);
  let i;
  const a = e.length;
  let n;
  for (i = 0; i < a; i++)
    n = e[i], t[n] = r[n];
  return t;
}
function ul(r) {
  function t(e, i, a, n) {
    let l = e[n++];
    const u = Number.isFinite(+l), h = n >= e.length;
    return l = !l && E.isArray(a) ? a.length : l, h ? (E.hasOwnProp(a, l) ? a[l] = [a[l], i] : a[l] = i, !u) : ((!a[l] || !E.isObject(a[l])) && (a[l] = []), t(e, i, a[l], n) && E.isArray(a[l]) && (a[l] = ou(a[l])), !u);
  }
  if (E.isFormData(r) && E.isFunction(r.entries)) {
    const e = {};
    return E.forEachEntry(r, (i, a) => {
      t(lu(i), a, e, 0);
    }), e;
  }
  return null;
}
const uu = {
  "Content-Type": void 0
};
function du(r, t, e) {
  if (E.isString(r))
    try {
      return (t || JSON.parse)(r), E.trim(r);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (e || JSON.stringify)(r);
}
const Ar = {
  transitional: ol,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, e) {
    const i = e.getContentType() || "", a = i.indexOf("application/json") > -1, n = E.isObject(t);
    if (n && E.isHTMLForm(t) && (t = new FormData(t)), E.isFormData(t))
      return a && a ? JSON.stringify(ul(t)) : t;
    if (E.isArrayBuffer(t) || E.isBuffer(t) || E.isStream(t) || E.isFile(t) || E.isBlob(t))
      return t;
    if (E.isArrayBufferView(t))
      return t.buffer;
    if (E.isURLSearchParams(t))
      return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let u;
    if (n) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return nu(t, this.formSerializer).toString();
      if ((u = E.isFileList(t)) || i.indexOf("multipart/form-data") > -1) {
        const h = this.env && this.env.FormData;
        return Fr(
          u ? { "files[]": t } : t,
          h && new h(),
          this.formSerializer
        );
      }
    }
    return n || a ? (e.setContentType("application/json", !1), du(t)) : t;
  }],
  transformResponse: [function(t) {
    const e = this.transitional || Ar.transitional, i = e && e.forcedJSONParsing, a = this.responseType === "json";
    if (t && E.isString(t) && (i && !this.responseType || a)) {
      const l = !(e && e.silentJSONParsing) && a;
      try {
        return JSON.parse(t);
      } catch (u) {
        if (l)
          throw u.name === "SyntaxError" ? L.from(u, L.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: lt.classes.FormData,
    Blob: lt.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
E.forEach(["delete", "get", "head"], function(t) {
  Ar.headers[t] = {};
});
E.forEach(["post", "put", "patch"], function(t) {
  Ar.headers[t] = E.merge(uu);
});
const Ja = Ar, cu = E.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), hu = (r) => {
  const t = {};
  let e, i, a;
  return r && r.split(`
`).forEach(function(l) {
    a = l.indexOf(":"), e = l.substring(0, a).trim().toLowerCase(), i = l.substring(a + 1).trim(), !(!e || t[e] && cu[e]) && (e === "set-cookie" ? t[e] ? t[e].push(i) : t[e] = [i] : t[e] = t[e] ? t[e] + ", " + i : i);
  }), t;
}, yn = Symbol("internals");
function Di(r) {
  return r && String(r).trim().toLowerCase();
}
function cs(r) {
  return r === !1 || r == null ? r : E.isArray(r) ? r.map(cs) : String(r);
}
function pu(r) {
  const t = /* @__PURE__ */ Object.create(null), e = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = e.exec(r); )
    t[i[1]] = i[2];
  return t;
}
function mu(r) {
  return /^[-_a-zA-Z]+$/.test(r.trim());
}
function ca(r, t, e, i, a) {
  if (E.isFunction(i))
    return i.call(this, t, e);
  if (a && (t = e), !!E.isString(t)) {
    if (E.isString(i))
      return t.indexOf(i) !== -1;
    if (E.isRegExp(i))
      return i.test(t);
  }
}
function fu(r) {
  return r.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, e, i) => e.toUpperCase() + i);
}
function bu(r, t) {
  const e = E.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(r, i + e, {
      value: function(a, n, l) {
        return this[i].call(this, t, a, n, l);
      },
      configurable: !0
    });
  });
}
class yr {
  constructor(t) {
    t && this.set(t);
  }
  set(t, e, i) {
    const a = this;
    function n(u, h, c) {
      const p = Di(h);
      if (!p)
        throw new Error("header name must be a non-empty string");
      const m = E.findKey(a, p);
      (!m || a[m] === void 0 || c === !0 || c === void 0 && a[m] !== !1) && (a[m || h] = cs(u));
    }
    const l = (u, h) => E.forEach(u, (c, p) => n(c, p, h));
    return E.isPlainObject(t) || t instanceof this.constructor ? l(t, e) : E.isString(t) && (t = t.trim()) && !mu(t) ? l(hu(t), e) : t != null && n(e, t, i), this;
  }
  get(t, e) {
    if (t = Di(t), t) {
      const i = E.findKey(this, t);
      if (i) {
        const a = this[i];
        if (!e)
          return a;
        if (e === !0)
          return pu(a);
        if (E.isFunction(e))
          return e.call(this, a, i);
        if (E.isRegExp(e))
          return e.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, e) {
    if (t = Di(t), t) {
      const i = E.findKey(this, t);
      return !!(i && this[i] !== void 0 && (!e || ca(this, this[i], i, e)));
    }
    return !1;
  }
  delete(t, e) {
    const i = this;
    let a = !1;
    function n(l) {
      if (l = Di(l), l) {
        const u = E.findKey(i, l);
        u && (!e || ca(i, i[u], u, e)) && (delete i[u], a = !0);
      }
    }
    return E.isArray(t) ? t.forEach(n) : n(t), a;
  }
  clear(t) {
    const e = Object.keys(this);
    let i = e.length, a = !1;
    for (; i--; ) {
      const n = e[i];
      (!t || ca(this, this[n], n, t, !0)) && (delete this[n], a = !0);
    }
    return a;
  }
  normalize(t) {
    const e = this, i = {};
    return E.forEach(this, (a, n) => {
      const l = E.findKey(i, n);
      if (l) {
        e[l] = cs(a), delete e[n];
        return;
      }
      const u = t ? fu(n) : String(n).trim();
      u !== n && delete e[n], e[u] = cs(a), i[u] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const e = /* @__PURE__ */ Object.create(null);
    return E.forEach(this, (i, a) => {
      i != null && i !== !1 && (e[a] = t && E.isArray(i) ? i.join(", ") : i);
    }), e;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, e]) => t + ": " + e).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...e) {
    const i = new this(t);
    return e.forEach((a) => i.set(a)), i;
  }
  static accessor(t) {
    const i = (this[yn] = this[yn] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function n(l) {
      const u = Di(l);
      i[u] || (bu(a, l), i[u] = !0);
    }
    return E.isArray(t) ? t.forEach(n) : n(t), this;
  }
}
yr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
E.freezeMethods(yr.prototype);
E.freezeMethods(yr);
const Et = yr;
function ha(r, t) {
  const e = this || Ja, i = t || e, a = Et.from(i.headers);
  let n = i.data;
  return E.forEach(r, function(u) {
    n = u.call(e, n, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), n;
}
function dl(r) {
  return !!(r && r.__CANCEL__);
}
function es(r, t, e) {
  L.call(this, r ?? "canceled", L.ERR_CANCELED, t, e), this.name = "CanceledError";
}
E.inherits(es, L, {
  __CANCEL__: !0
});
function gu(r, t, e) {
  const i = e.config.validateStatus;
  !e.status || !i || i(e.status) ? r(e) : t(new L(
    "Request failed with status code " + e.status,
    [L.ERR_BAD_REQUEST, L.ERR_BAD_RESPONSE][Math.floor(e.status / 100) - 4],
    e.config,
    e.request,
    e
  ));
}
const vu = lt.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(e, i, a, n, l, u) {
        const h = [];
        h.push(e + "=" + encodeURIComponent(i)), E.isNumber(a) && h.push("expires=" + new Date(a).toGMTString()), E.isString(n) && h.push("path=" + n), E.isString(l) && h.push("domain=" + l), u === !0 && h.push("secure"), document.cookie = h.join("; ");
      },
      read: function(e) {
        const i = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
        return i ? decodeURIComponent(i[3]) : null;
      },
      remove: function(e) {
        this.write(e, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function Eu(r) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(r);
}
function wu(r, t) {
  return t ? r.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : r;
}
function cl(r, t) {
  return r && !Eu(t) ? wu(r, t) : t;
}
const Su = lt.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), e = document.createElement("a");
    let i;
    function a(n) {
      let l = n;
      return t && (e.setAttribute("href", l), l = e.href), e.setAttribute("href", l), {
        href: e.href,
        protocol: e.protocol ? e.protocol.replace(/:$/, "") : "",
        host: e.host,
        search: e.search ? e.search.replace(/^\?/, "") : "",
        hash: e.hash ? e.hash.replace(/^#/, "") : "",
        hostname: e.hostname,
        port: e.port,
        pathname: e.pathname.charAt(0) === "/" ? e.pathname : "/" + e.pathname
      };
    }
    return i = a(window.location.href), function(l) {
      const u = E.isString(l) ? a(l) : l;
      return u.protocol === i.protocol && u.host === i.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function Fu(r) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(r);
  return t && t[1] || "";
}
function Au(r, t) {
  r = r || 10;
  const e = new Array(r), i = new Array(r);
  let a = 0, n = 0, l;
  return t = t !== void 0 ? t : 1e3, function(h) {
    const c = Date.now(), p = i[n];
    l || (l = c), e[a] = h, i[a] = c;
    let m = n, b = 0;
    for (; m !== a; )
      b += e[m++], m = m % r;
    if (a = (a + 1) % r, a === n && (n = (n + 1) % r), c - l < t)
      return;
    const v = p && c - p;
    return v ? Math.round(b * 1e3 / v) : void 0;
  };
}
function On(r, t) {
  let e = 0;
  const i = Au(50, 250);
  return (a) => {
    const n = a.loaded, l = a.lengthComputable ? a.total : void 0, u = n - e, h = i(u), c = n <= l;
    e = n;
    const p = {
      loaded: n,
      total: l,
      progress: l ? n / l : void 0,
      bytes: u,
      rate: h || void 0,
      estimated: h && l && c ? (l - n) / h : void 0,
      event: a
    };
    p[t ? "download" : "upload"] = !0, r(p);
  };
}
const yu = typeof XMLHttpRequest < "u", Ou = yu && function(r) {
  return new Promise(function(e, i) {
    let a = r.data;
    const n = Et.from(r.headers).normalize(), l = r.responseType;
    let u;
    function h() {
      r.cancelToken && r.cancelToken.unsubscribe(u), r.signal && r.signal.removeEventListener("abort", u);
    }
    E.isFormData(a) && (lt.isStandardBrowserEnv || lt.isStandardBrowserWebWorkerEnv) && n.setContentType(!1);
    let c = new XMLHttpRequest();
    if (r.auth) {
      const v = r.auth.username || "", g = r.auth.password ? unescape(encodeURIComponent(r.auth.password)) : "";
      n.set("Authorization", "Basic " + btoa(v + ":" + g));
    }
    const p = cl(r.baseURL, r.url);
    c.open(r.method.toUpperCase(), ll(p, r.params, r.paramsSerializer), !0), c.timeout = r.timeout;
    function m() {
      if (!c)
        return;
      const v = Et.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), w = {
        data: !l || l === "text" || l === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: v,
        config: r,
        request: c
      };
      gu(function(C) {
        e(C), h();
      }, function(C) {
        i(C), h();
      }, w), c = null;
    }
    if ("onloadend" in c ? c.onloadend = m : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(m);
    }, c.onabort = function() {
      c && (i(new L("Request aborted", L.ECONNABORTED, r, c)), c = null);
    }, c.onerror = function() {
      i(new L("Network Error", L.ERR_NETWORK, r, c)), c = null;
    }, c.ontimeout = function() {
      let g = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const w = r.transitional || ol;
      r.timeoutErrorMessage && (g = r.timeoutErrorMessage), i(new L(
        g,
        w.clarifyTimeoutError ? L.ETIMEDOUT : L.ECONNABORTED,
        r,
        c
      )), c = null;
    }, lt.isStandardBrowserEnv) {
      const v = (r.withCredentials || Su(p)) && r.xsrfCookieName && vu.read(r.xsrfCookieName);
      v && n.set(r.xsrfHeaderName, v);
    }
    a === void 0 && n.setContentType(null), "setRequestHeader" in c && E.forEach(n.toJSON(), function(g, w) {
      c.setRequestHeader(w, g);
    }), E.isUndefined(r.withCredentials) || (c.withCredentials = !!r.withCredentials), l && l !== "json" && (c.responseType = r.responseType), typeof r.onDownloadProgress == "function" && c.addEventListener("progress", On(r.onDownloadProgress, !0)), typeof r.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", On(r.onUploadProgress)), (r.cancelToken || r.signal) && (u = (v) => {
      c && (i(!v || v.type ? new es(null, r, c) : v), c.abort(), c = null);
    }, r.cancelToken && r.cancelToken.subscribe(u), r.signal && (r.signal.aborted ? u() : r.signal.addEventListener("abort", u)));
    const b = Fu(p);
    if (b && lt.protocols.indexOf(b) === -1) {
      i(new L("Unsupported protocol " + b + ":", L.ERR_BAD_REQUEST, r));
      return;
    }
    c.send(a || null);
  });
}, hs = {
  http: Jo,
  xhr: Ou
};
E.forEach(hs, (r, t) => {
  if (r) {
    try {
      Object.defineProperty(r, "name", { value: t });
    } catch {
    }
    Object.defineProperty(r, "adapterName", { value: t });
  }
});
const Cu = {
  getAdapter: (r) => {
    r = E.isArray(r) ? r : [r];
    const { length: t } = r;
    let e, i;
    for (let a = 0; a < t && (e = r[a], !(i = E.isString(e) ? hs[e.toLowerCase()] : e)); a++)
      ;
    if (!i)
      throw i === !1 ? new L(
        `Adapter ${e} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        E.hasOwnProp(hs, e) ? `Adapter '${e}' is not available in the build` : `Unknown adapter '${e}'`
      );
    if (!E.isFunction(i))
      throw new TypeError("adapter is not a function");
    return i;
  },
  adapters: hs
};
function pa(r) {
  if (r.cancelToken && r.cancelToken.throwIfRequested(), r.signal && r.signal.aborted)
    throw new es(null, r);
}
function Cn(r) {
  return pa(r), r.headers = Et.from(r.headers), r.data = ha.call(
    r,
    r.transformRequest
  ), ["post", "put", "patch"].indexOf(r.method) !== -1 && r.headers.setContentType("application/x-www-form-urlencoded", !1), Cu.getAdapter(r.adapter || Ja.adapter)(r).then(function(i) {
    return pa(r), i.data = ha.call(
      r,
      r.transformResponse,
      i
    ), i.headers = Et.from(i.headers), i;
  }, function(i) {
    return dl(i) || (pa(r), i && i.response && (i.response.data = ha.call(
      r,
      r.transformResponse,
      i.response
    ), i.response.headers = Et.from(i.response.headers))), Promise.reject(i);
  });
}
const In = (r) => r instanceof Et ? r.toJSON() : r;
function gi(r, t) {
  t = t || {};
  const e = {};
  function i(c, p, m) {
    return E.isPlainObject(c) && E.isPlainObject(p) ? E.merge.call({ caseless: m }, c, p) : E.isPlainObject(p) ? E.merge({}, p) : E.isArray(p) ? p.slice() : p;
  }
  function a(c, p, m) {
    if (E.isUndefined(p)) {
      if (!E.isUndefined(c))
        return i(void 0, c, m);
    } else
      return i(c, p, m);
  }
  function n(c, p) {
    if (!E.isUndefined(p))
      return i(void 0, p);
  }
  function l(c, p) {
    if (E.isUndefined(p)) {
      if (!E.isUndefined(c))
        return i(void 0, c);
    } else
      return i(void 0, p);
  }
  function u(c, p, m) {
    if (m in t)
      return i(c, p);
    if (m in r)
      return i(void 0, c);
  }
  const h = {
    url: n,
    method: n,
    data: n,
    baseURL: l,
    transformRequest: l,
    transformResponse: l,
    paramsSerializer: l,
    timeout: l,
    timeoutMessage: l,
    withCredentials: l,
    adapter: l,
    responseType: l,
    xsrfCookieName: l,
    xsrfHeaderName: l,
    onUploadProgress: l,
    onDownloadProgress: l,
    decompress: l,
    maxContentLength: l,
    maxBodyLength: l,
    beforeRedirect: l,
    transport: l,
    httpAgent: l,
    httpsAgent: l,
    cancelToken: l,
    socketPath: l,
    responseEncoding: l,
    validateStatus: u,
    headers: (c, p) => a(In(c), In(p), !0)
  };
  return E.forEach(Object.keys(r).concat(Object.keys(t)), function(p) {
    const m = h[p] || a, b = m(r[p], t[p], p);
    E.isUndefined(b) && m !== u || (e[p] = b);
  }), e;
}
const hl = "1.3.4", Za = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((r, t) => {
  Za[r] = function(i) {
    return typeof i === r || "a" + (t < 1 ? "n " : " ") + r;
  };
});
const Tn = {};
Za.transitional = function(t, e, i) {
  function a(n, l) {
    return "[Axios v" + hl + "] Transitional option '" + n + "'" + l + (i ? ". " + i : "");
  }
  return (n, l, u) => {
    if (t === !1)
      throw new L(
        a(l, " has been removed" + (e ? " in " + e : "")),
        L.ERR_DEPRECATED
      );
    return e && !Tn[l] && (Tn[l] = !0, console.warn(
      a(
        l,
        " has been deprecated since v" + e + " and will be removed in the near future"
      )
    )), t ? t(n, l, u) : !0;
  };
};
function Iu(r, t, e) {
  if (typeof r != "object")
    throw new L("options must be an object", L.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(r);
  let a = i.length;
  for (; a-- > 0; ) {
    const n = i[a], l = t[n];
    if (l) {
      const u = r[n], h = u === void 0 || l(u, n, r);
      if (h !== !0)
        throw new L("option " + n + " must be " + h, L.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (e !== !0)
      throw new L("Unknown option " + n, L.ERR_BAD_OPTION);
  }
}
const wa = {
  assertOptions: Iu,
  validators: Za
}, At = wa.validators;
class Es {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new An(),
      response: new An()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, e) {
    typeof t == "string" ? (e = e || {}, e.url = t) : e = t || {}, e = gi(this.defaults, e);
    const { transitional: i, paramsSerializer: a, headers: n } = e;
    i !== void 0 && wa.assertOptions(i, {
      silentJSONParsing: At.transitional(At.boolean),
      forcedJSONParsing: At.transitional(At.boolean),
      clarifyTimeoutError: At.transitional(At.boolean)
    }, !1), a !== void 0 && wa.assertOptions(a, {
      encode: At.function,
      serialize: At.function
    }, !0), e.method = (e.method || this.defaults.method || "get").toLowerCase();
    let l;
    l = n && E.merge(
      n.common,
      n[e.method]
    ), l && E.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (g) => {
        delete n[g];
      }
    ), e.headers = Et.concat(l, n);
    const u = [];
    let h = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(e) === !1 || (h = h && w.synchronous, u.unshift(w.fulfilled, w.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(w) {
      c.push(w.fulfilled, w.rejected);
    });
    let p, m = 0, b;
    if (!h) {
      const g = [Cn.bind(this), void 0];
      for (g.unshift.apply(g, u), g.push.apply(g, c), b = g.length, p = Promise.resolve(e); m < b; )
        p = p.then(g[m++], g[m++]);
      return p;
    }
    b = u.length;
    let v = e;
    for (m = 0; m < b; ) {
      const g = u[m++], w = u[m++];
      try {
        v = g(v);
      } catch (O) {
        w.call(this, O);
        break;
      }
    }
    try {
      p = Cn.call(this, v);
    } catch (g) {
      return Promise.reject(g);
    }
    for (m = 0, b = c.length; m < b; )
      p = p.then(c[m++], c[m++]);
    return p;
  }
  getUri(t) {
    t = gi(this.defaults, t);
    const e = cl(t.baseURL, t.url);
    return ll(e, t.params, t.paramsSerializer);
  }
}
E.forEach(["delete", "get", "head", "options"], function(t) {
  Es.prototype[t] = function(e, i) {
    return this.request(gi(i || {}, {
      method: t,
      url: e,
      data: (i || {}).data
    }));
  };
});
E.forEach(["post", "put", "patch"], function(t) {
  function e(i) {
    return function(n, l, u) {
      return this.request(gi(u || {}, {
        method: t,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: n,
        data: l
      }));
    };
  }
  Es.prototype[t] = e(), Es.prototype[t + "Form"] = e(!0);
});
const ps = Es;
class Xa {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let e;
    this.promise = new Promise(function(n) {
      e = n;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners)
        return;
      let n = i._listeners.length;
      for (; n-- > 0; )
        i._listeners[n](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let n;
      const l = new Promise((u) => {
        i.subscribe(u), n = u;
      }).then(a);
      return l.cancel = function() {
        i.unsubscribe(n);
      }, l;
    }, t(function(n, l, u) {
      i.reason || (i.reason = new es(n, l, u), e(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const e = this._listeners.indexOf(t);
    e !== -1 && this._listeners.splice(e, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Xa(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
}
const Tu = Xa;
function xu(r) {
  return function(e) {
    return r.apply(null, e);
  };
}
function Du(r) {
  return E.isObject(r) && r.isAxiosError === !0;
}
const Sa = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Sa).forEach(([r, t]) => {
  Sa[t] = r;
});
const Ru = Sa;
function pl(r) {
  const t = new ps(r), e = Yn(ps.prototype.request, t);
  return E.extend(e, ps.prototype, t, { allOwnKeys: !0 }), E.extend(e, t, null, { allOwnKeys: !0 }), e.create = function(a) {
    return pl(gi(r, a));
  }, e;
}
const re = pl(Ja);
re.Axios = ps;
re.CanceledError = es;
re.CancelToken = Tu;
re.isCancel = dl;
re.VERSION = hl;
re.toFormData = Fr;
re.AxiosError = L;
re.Cancel = re.CanceledError;
re.all = function(t) {
  return Promise.all(t);
};
re.spread = xu;
re.isAxiosError = Du;
re.mergeConfig = gi;
re.AxiosHeaders = Et;
re.formToJSON = (r) => ul(E.isHTMLForm(r) ? new FormData(r) : r);
re.HttpStatusCode = Ru;
re.default = re;
const Nu = re;
new TextEncoder();
const ml = new TextDecoder(), Pu = (r) => {
  const t = atob(r), e = new Uint8Array(t.length);
  for (let i = 0; i < t.length; i++)
    e[i] = t.charCodeAt(i);
  return e;
}, Mu = (r) => {
  let t = r;
  t instanceof Uint8Array && (t = ml.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return Pu(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
};
class Lu extends Error {
  static get code() {
    return "ERR_JOSE_GENERIC";
  }
  constructor(t) {
    var e;
    super(t), this.code = "ERR_JOSE_GENERIC", this.name = this.constructor.name, (e = Error.captureStackTrace) === null || e === void 0 || e.call(Error, this, this.constructor);
  }
}
class Lt extends Lu {
  constructor() {
    super(...arguments), this.code = "ERR_JWT_INVALID";
  }
  static get code() {
    return "ERR_JWT_INVALID";
  }
}
function ku(r) {
  return typeof r == "object" && r !== null;
}
function ju(r) {
  if (!ku(r) || Object.prototype.toString.call(r) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(r) === null)
    return !0;
  let t = r;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(r) === t;
}
const qu = Mu;
function Uu(r) {
  if (typeof r != "string")
    throw new Lt("JWTs must use Compact JWS serialization, JWT must be a string");
  const { 1: t, length: e } = r.split(".");
  if (e === 5)
    throw new Lt("Only JWTs using Compact JWS serialization can be decoded");
  if (e !== 3)
    throw new Lt("Invalid JWT");
  if (!t)
    throw new Lt("JWTs must contain a payload");
  let i;
  try {
    i = qu(t);
  } catch {
    throw new Lt("Failed to base64url decode the payload");
  }
  let a;
  try {
    a = JSON.parse(ml.decode(i));
  } catch {
    throw new Lt("Failed to parse the decoded payload as JSON");
  }
  if (!ju(a))
    throw new Lt("Invalid JWT Claims Set");
  return a;
}
let ns;
const $u = new Uint8Array(16);
function Bu() {
  if (!ns && (ns = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !ns))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ns($u);
}
const ue = [];
for (let r = 0; r < 256; ++r)
  ue.push((r + 256).toString(16).slice(1));
function Vu(r, t = 0) {
  return (ue[r[t + 0]] + ue[r[t + 1]] + ue[r[t + 2]] + ue[r[t + 3]] + "-" + ue[r[t + 4]] + ue[r[t + 5]] + "-" + ue[r[t + 6]] + ue[r[t + 7]] + "-" + ue[r[t + 8]] + ue[r[t + 9]] + "-" + ue[r[t + 10]] + ue[r[t + 11]] + ue[r[t + 12]] + ue[r[t + 13]] + ue[r[t + 14]] + ue[r[t + 15]]).toLowerCase();
}
const Hu = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), xn = {
  randomUUID: Hu
};
function Gu(r, t, e) {
  if (xn.randomUUID && !t && !r)
    return xn.randomUUID();
  r = r || {};
  const i = r.random || (r.rng || Bu)();
  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, t) {
    e = e || 0;
    for (let a = 0; a < 16; ++a)
      t[e + a] = i[a];
    return t;
  }
  return Vu(i);
}
class A extends I {
  get id() {
    return this.value;
  }
  static generate() {
    return new this(
      Gu()
    );
  }
  equals(t) {
    return t instanceof A ? this.value === t.value : !1;
  }
  get schemaConfig() {
    return A.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().required() });
  }
}
class se extends A {
}
class pe extends A {
}
class N {
  static createInstance(t, e) {
    const i = new t();
    return typeof i.fromObject == "function" ? i.fromObject(e) : (Object.entries(e).forEach(([a, n]) => {
      a in i && (i[a] = n);
    }), i);
  }
  static parseField(t, e) {
    return t == null ? null : e ? Array.isArray(t) ? t.map((i) => N.parseField(i, e)) : "fromObject" in e && typeof e.fromObject == "function" ? e.fromObject(t) : new e((t == null ? void 0 : t.value) ?? t) : t;
  }
}
class s extends N {
  constructor() {
    super(...arguments);
    o(this, "subResources", {});
  }
  equals(e) {
    return e instanceof s ? this.id.equals(e.id) : !1;
  }
}
class wt extends Xi {
  constructor(t, e, i, a, n, l, u) {
    super(), this.street = t, this.number = e, this.numberSuffix = i, this.postalCode = a, this.city = n, this.region = l, this.country = u;
  }
  toString() {
    return this.fullAddress;
  }
  equals(t) {
    return t instanceof wt ? this.street === t.street && this.number === t.number && this.numberSuffix === t.numberSuffix && this.postalCode === t.postalCode && this.city === t.city && this.region === t.region && this.country === t.country : !1;
  }
  get schemaConfig() {
    return wt.validationSchema;
  }
  static get validationSchema() {
    return f({
      street: d().trim().nullable(),
      number: d().trim().nullable(),
      numberSuffix: d().trim().nullable(),
      postalCode: d().trim().nullable(),
      city: d().trim().nullable(),
      region: d().trim().nullable(),
      country: d().trim().nullable()
    });
  }
  get fullStreet() {
    var i;
    const t = [], e = ((i = this.street) == null ? void 0 : i.trim()) ?? "";
    return e !== "" && t.push(e), t.push(this.fullNumber.trim()), t.filter((a) => !!a).join(" ");
  }
  get fullNumber() {
    var i, a;
    const t = ((i = this.number) == null ? void 0 : i.trim()) ?? "", e = ((a = this.numberSuffix) == null ? void 0 : a.trim()) ?? "";
    return t !== "" && e !== "" ? `${t}-${e}` : t !== "" ? t : e !== "" ? e : "";
  }
  get fullAddress() {
    var a, n;
    const t = [
      this.fullStreet
    ], e = ((a = this.postalCode) == null ? void 0 : a.trim()) ?? "";
    e !== "" && t.push(e);
    const i = ((n = this.city) == null ? void 0 : n.trim()) ?? "";
    return i !== null && t.push(i), t.filter((l) => !!l).join(", ");
  }
  static fromObject(t) {
    return new wt(
      s.parseField(t.street),
      s.parseField(t.number),
      s.parseField(t.numberSuffix),
      s.parseField(t.postalCode),
      s.parseField(t.city),
      s.parseField(t.region),
      s.parseField(t.country)
    );
  }
}
class vi extends I {
  get schemaConfig() {
    return vi.validationSchema;
  }
  static get validationSchema() {
    return d().matches(/^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0\)\([0-9]{9}$|[0-9\-\s]{10}$/).trim();
  }
}
class ve extends A {
}
const Me = class extends I {
  get isKeyVueType() {
    return !this.isWinckType;
  }
  get isWinckType() {
    switch (this.value) {
      case Me.WINCK.value:
        return !0;
      default:
        return !1;
    }
  }
  get schemaConfig() {
    return Me.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      Me.DEFAULT,
      Me.SMART_MARKETING,
      Me.WINCK
    ];
  }
  static get keyVueValues() {
    return Me.values.filter((t) => t.isKeyVueType);
  }
  static get winckValues() {
    return Me.values.filter((t) => t.isWinckType);
  }
};
let bt = Me;
o(bt, "DEFAULT", new Me("default")), o(bt, "SMART_MARKETING", new Me("smart-marketing")), o(bt, "WINCK", new Me("winck"));
class Pt extends A {
}
let _a = class extends A {
}, Wu = class Fa extends s {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "entrypoint", "company/logos");
    o(this, "fromObject", (e) => Fa.fromObject(e));
    this.company = e, this.id = i, this.fileName = a, this.fileSize = n, this.fileType = l, this.url = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromObject(e) {
    return new Fa(
      s.parseField(e.company, J),
      s.parseField(e.id, _a),
      s.parseField(e.fileName),
      s.parseField(e.fileSize),
      s.parseField(e.fileType),
      s.parseField(e.url),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
};
class Jt extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D, M, $) {
    super();
    o(this, "entrypoint", "company/brands");
    o(this, "fromObject", (e) => Jt.fromObject(e));
    this.company = e, this.id = i, this.teams = a, this.name = n, this.logo = l, this.primaryColor = u, this.secondaryColor = h, this.textColor = c, this.linkColor = p, this.buttonColor = m, this.buttonTextColor = b, this.headingFontName = v, this.fontName = g, this.googleTagId = w, this.websiteUrl = O, this.additionalUrls = C, this.active = D, this.createdAt = M, this.updatedAt = $;
  }
  static fromObject(e) {
    return new Jt(
      s.parseField(e.company, J),
      s.parseField(e.id, Pt),
      s.parseField(e.teams, Fe),
      s.parseField(e.name),
      s.parseField(e.logo, Wu),
      s.parseField(e.primaryColor),
      s.parseField(e.secondaryColor),
      s.parseField(e.textColor),
      s.parseField(e.linkColor),
      s.parseField(e.buttonColor),
      s.parseField(e.buttonTextColor),
      s.parseField(e.headingFontName),
      s.parseField(e.fontName),
      s.parseField(e.googleTagId),
      s.parseField(e.websiteUrl),
      s.parseField(e.additionalUrls),
      s.parseField(e.active),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
  get websiteDomain() {
    return this.websiteUrl ? new URL(this.websiteUrl).hostname.replaceAll("www.", "") : void 0;
  }
}
class ws extends N {
  constructor(e, i, a, n, l, u, h, c, p, m, b) {
    super();
    o(this, "fromObject", (e) => ws.fromObject(e));
    this.team = e, this.facebookUrl = i, this.instagramUrl = a, this.linkedinUrl = n, this.youtubeUrl = l, this.xUrl = u, this.pinterestUrl = h, this.tiktokUrl = c, this.vimeoUrl = p, this.createdAt = m, this.updatedAt = b;
  }
  static fromObject(e) {
    return new ws(
      s.parseField(e.team, Fe),
      s.parseField(e.facebookUrl),
      s.parseField(e.instagramUrl),
      s.parseField(e.linkedinUrl),
      s.parseField(e.youtubeUrl),
      s.parseField(e.xUrl),
      s.parseField(e.pinterestUrl),
      s.parseField(e.tiktokUrl),
      s.parseField(e.vimeoUrl),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Ss extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O) {
    super();
    o(this, "entrypoint", "company/teams");
    o(this, "fromObject", (e) => Ss.fromObject(e));
    o(this, "subResources", {
      users: "company/teams/{id}/users",
      "available-users": "company/teams/{id}/available_users"
    });
    this.company = e, this.id = i, this.type = a, this.brand = n, this.socialMedia = l, this.name = u, this.displayName = h, this.address = c, this.phoneNumber = p, this.email = m, this.website = b, this.active = v, this.users = g, this.createdAt = w, this.updatedAt = O;
  }
  static fromObject(e) {
    return new Ss(
      s.parseField(e.company, J),
      s.parseField(e.id, ve),
      s.parseField(e.type, bt),
      s.parseField(e.brand, Jt),
      s.parseField(e.socialMedia, ws),
      s.parseField(e.name),
      s.parseField(e.displayName),
      s.parseField(e.address, wt),
      s.parseField(e.phoneNumber, vi),
      s.parseField(e.email, si),
      s.parseField(e.website),
      s.parseField(e.active),
      s.parseField(e.users, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const Fe = Ss;
class Fs extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b) {
    super();
    o(this, "entrypoint", "company/companies");
    o(this, "fromObject", (e) => Fs.fromObject(e));
    o(this, "subResources", {
      users: "company/companies/{id}/users",
      teams: "company/companies/{id}/teams",
      "available-pipelines": "company/companies/{id}/available_pipelines"
    });
    this.id = e, this.name = i, this.address = a, this.phoneNumber = n, this.email = l, this.website = u, this.active = h, this.teams = c, this.users = p, this.createdAt = m, this.updatedAt = b;
  }
  static fromObject(e) {
    return new Fs(
      s.parseField(e.id, pe),
      s.parseField(e.name),
      s.parseField(e.address, wt),
      s.parseField(e.phoneNumber, vi),
      s.parseField(e.email, si),
      s.parseField(e.website),
      s.parseField(e.active),
      s.parseField(e.teams, Fe),
      s.parseField(e.users, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const J = Fs, Bt = class extends I {
  get schemaConfig() {
    return Bt.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      Bt.DEFAULT,
      Bt.SMART_MARKETING
    ];
  }
};
let Ri = Bt;
o(Ri, "DEFAULT", new Bt("default")), o(Ri, "SMART_MARKETING", new Bt("smart-marketing"));
const ae = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: ae.MALE, label: "Man" },
      { value: ae.FEMALE, label: "Vrouw" },
      { value: ae.NEUTRAL, label: "Neutraal" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get shortSalutation() {
    var t;
    return ((t = [
      { value: ae.MALE, label: "dhr." },
      { value: ae.FEMALE, label: "mevr." },
      { value: ae.NEUTRAL, label: "dhr./mevr." }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get longSalutation() {
    var t;
    return ((t = [
      { value: ae.MALE, label: "heer" },
      { value: ae.FEMALE, label: "mevrouw" },
      { value: ae.NEUTRAL, label: "heer/mevrouw" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return ae.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(this.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      ae.MALE,
      ae.FEMALE,
      ae.NEUTRAL
    ];
  }
  static get options() {
    return this.values.map((t) => ({
      value: t.value,
      label: t.label
    }));
  }
};
let Tt = ae;
o(Tt, "MALE", new ae("male")), o(Tt, "FEMALE", new ae("female")), o(Tt, "NEUTRAL", new ae("neutral"));
class Qt extends Xi {
  constructor(t, e, i, a) {
    super(), this.initials = t, this.firstName = e, this.middleName = i, this.lastName = a;
  }
  toString() {
    return this.fullName;
  }
  equals(t) {
    return t instanceof Qt ? this.initials === t.initials && this.firstName === t.firstName && this.middleName === t.middleName && this.lastName === t.lastName : !1;
  }
  get schemaConfig() {
    return Qt.validationSchema;
  }
  static get validationSchema() {
    return f({
      initials: d().trim().nullable(),
      firstname: d().trim().nullable(),
      middlename: d().trim().nullable(),
      lastname: d().trim().nullable()
    });
  }
  get fullLastName() {
    return [
      this.middleName,
      this.lastName
    ].filter((t) => !!t).join(" ");
  }
  get fullName() {
    return [
      this.firstName,
      this.middleName,
      this.lastName
    ].filter((t) => !!t).join(" ");
  }
  get abbreviation() {
    return this.firstName && this.lastName ? this.firstName.substring(0, 1).toUpperCase() + this.lastName.substring(0, 1).toUpperCase() : this.firstName ? this.firstName.substring(0, 1).toUpperCase() : this.lastName ? this.lastName.substring(0, 1).toUpperCase() : "?";
  }
  static fromObject(t) {
    return new Qt(
      s.parseField(t.initials),
      s.parseField(t.firstName),
      s.parseField(t.middleName),
      s.parseField(t.lastName)
    );
  }
}
var he;
let zu = (he = class extends I {
  get schemaConfig() {
    return he.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      he.EMPLOYEE,
      he.TEAM_LEAD,
      he.TEAM_MANAGER,
      he.COMPANY_MANAGER
    ];
  }
}, o(he, "EMPLOYEE", new he("employee")), o(he, "TEAM_LEAD", new he("team-lead")), o(he, "TEAM_MANAGER", new he("team-manager")), o(he, "COMPANY_MANAGER", new he("company-manager")), he);
const Vt = class extends I {
  get schemaConfig() {
    return Vt.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      Vt.EMPLOYEE,
      Vt.COMPANY_MANAGER
    ];
  }
};
let hi = Vt;
o(hi, "EMPLOYEE", new Vt("employee")), o(hi, "COMPANY_MANAGER", new Vt("company-manager"));
class As extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D, M) {
    super();
    o(this, "entrypoint", "company/users");
    o(this, "fromObject", (e) => As.fromObject(e));
    o(this, "subResources", { teams: "company/users/{id}/teams" });
    this.company = e, this.id = i, this.type = a, this.gender = n, this.name = l, this.email = u, this.password = h, this.role = c, this.keyflowRole = p, this.superAdmin = m, this.avatar = b, this.phoneNumber = v, this.mobilePhoneNumber = g, this.absent = w, this.active = O, this.teams = C, this.createdAt = D, this.updatedAt = M;
  }
  get keyVueTeams() {
    const e = bt.keyVueValues.map((i) => i.value);
    return this.teams.filter((i) => e.includes(i.type.value));
  }
  get winckTeams() {
    const e = bt.winckValues.map((i) => i.value);
    return this.teams.filter((i) => e.includes(i.type.value));
  }
  static fromObject(e) {
    return new As(
      s.parseField(e.company, J),
      s.parseField(e.id, se),
      s.parseField(e.type, Ri),
      s.parseField(e.gender, Tt),
      s.parseField(e.name, Qt),
      s.parseField(e.email, si),
      s.parseField(e.password, wr),
      s.parseField(e.role, zu),
      s.parseField(e.keyflowRole, hi),
      s.parseField(e.superAdmin),
      s.parseField(e.avatar),
      s.parseField(e.phoneNumber),
      s.parseField(e.mobilePhoneNumber),
      s.parseField(e.absent),
      s.parseField(e.active),
      s.parseField(e.teams, Fe),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const ee = As;
class Ku {
  constructor(t) {
    o(this, "accessToken", null);
    // change to protected once legacy is out
    o(this, "refreshToken", null);
    // change to protected once legacy is out
    o(this, "company");
    o(this, "user");
    o(this, "storage");
    o(this, "client");
    o(this, "tokenListener");
    o(this, "sessionLoadPromiseListener");
    this.client = t, this.storage = localStorage;
  }
  async loadFromStorage() {
    this.storage && await this.applyTokens(
      this.storage.getItem("access_token"),
      this.storage.getItem("refresh_token")
    );
  }
  saveToStorage() {
    this.storage && (this.storage.setItem("access_token", this.accessToken ?? ""), this.storage.setItem("refresh_token", this.refreshToken ?? ""));
  }
  async applyTokens(t, e) {
    this.accessToken = t, this.refreshToken = e, this.saveToStorage(), this.isLoggedIn || (this.company = void 0, this.user = void 0), this.tokenListener && await this.tokenListener();
  }
  get decodedToken() {
    if (!this.accessToken)
      return null;
    const t = Uu(this.accessToken);
    return {
      iss: t.iss,
      sub: t.sub,
      aud: t.aud,
      jti: t.jti,
      nbf: t.nbf,
      exp: t.exp,
      iat: t.iat,
      userId: new se(t.id),
      companyId: new pe(t.companyId),
      email: new si(t.email),
      roles: t.roles
    };
  }
  get tokenExpiresAt() {
    return !this.decodedToken || !this.decodedToken.exp ? null : new Date(this.decodedToken.exp * 1e3);
  }
  get isTokenExpired() {
    return !this.decodedToken || !this.decodedToken.exp ? !0 : this.decodedToken.exp < Date.now() / 1e3;
  }
  get isLoggedIn() {
    return !!this.accessToken && !this.isTokenExpired;
  }
  get userId() {
    return this.decodedToken ? this.decodedToken.userId : null;
  }
  get companyId() {
    return this.decodedToken ? this.decodedToken.companyId : null;
  }
  get currentCompany() {
    return this.isLoggedIn ? this.company ?? null : null;
  }
  get currentUser() {
    return this.isLoggedIn ? this.user ?? null : null;
  }
  async loadSession() {
    if (await this.loadFromStorage(), !this.isLoggedIn) {
      try {
        await this.client.refreshTokens();
      } catch {
      }
      if (!this.isLoggedIn)
        return;
    }
    if (this.user && this.company)
      return;
    const t = [];
    this.userId && t.push(this.client.get(ee, this.userId.toString()).then((e) => {
      this.user = e;
    })), this.companyId && t.push(this.client.get(J, this.companyId.toString()).then((e) => {
      this.company = e;
    })), this.sessionLoadPromiseListener && t.push(...this.sessionLoadPromiseListener()), await Promise.all(t);
  }
  setTokenListener(t) {
    this.tokenListener = t;
  }
  setSessionLoadPromiseListener(t) {
    this.sessionLoadPromiseListener = t;
  }
}
class Ud {
  constructor(t) {
    o(this, "client", Nu.create());
    o(this, "session", new Ku(this));
    o(this, "isRefreshingTokens", !1);
    this.config = t, this.config = t, this.configureClient();
  }
  setClient(t) {
    this.client = t, this.configureClient();
  }
  configureClient() {
    this.client.defaults.baseURL = this.config.baseURL, this.client.defaults.headers["Content-Type"] = this.config.contentType ?? "application/ld+json", this.client.defaults.headers["One-Api-Application"] = this.config.oneApiApplication ?? null, this.client.interceptors.request.use((t) => this.onRequest(t)), this.client.interceptors.response.use(void 0, (t) => this.onError(t));
  }
  async onRequest(t) {
    return this.session.accessToken && (t.headers.Authorization = `Bearer ${this.session.accessToken}`), t;
  }
  async onError(t) {
    if (this.isRefreshingTokens)
      return await this.logout(), this.config.tokenRefreshErrorHandler && this.config.tokenRefreshErrorHandler(), Promise.reject(t);
    if (t.response.status === 401) {
      this.isRefreshingTokens = !0, await this.refreshTokens(), this.isRefreshingTokens = !1;
      const { config: e } = t;
      return e ? Promise.resolve(this.client(e)) : Promise.reject(t);
    }
    return Promise.reject(t);
  }
  async dispatch(t) {
    const e = await this.client.request({
      method: t.requestMethod,
      url: `${this.config.basePath}${t.requestPath}`,
      data: await t.parseRequest(
        await t.validate()
      ),
      headers: { "Content-Type": t.contentType }
    });
    return t.parseResponse(e.data);
  }
  async get(t, e, i) {
    const { entrypoint: a, fromObject: n } = new t(), l = await this.client.get(`${this.config.basePath}/${a}/${e}`, { params: i });
    return n(l.data);
  }
  async getSubResources(t, e, i, a) {
    const { subResources: n } = t, u = n[i].replace("{id}", t.id.value), { fromObject: h } = new e(), c = await this.client.get(`${this.config.basePath}/${u}`, { params: a });
    if (!("hydra:member" in c.data))
      throw new Error("Invalid resource collection response");
    return {
      data: c.data["hydra:member"].map((p) => h(p)),
      total: c.data["hydra:totalItems"]
    };
  }
  async getCollection(t, e) {
    const { entrypoint: i, fromObject: a } = new t(), n = await this.client.get(`${this.config.basePath}/${i}`, { params: e });
    if (!("hydra:member" in n.data))
      throw new Error("Invalid resource collection response");
    return {
      data: n.data["hydra:member"].map((l) => a(l)),
      total: n.data["hydra:totalItems"]
    };
  }
  /** Todo: make it so it accepts the command  */
  async login(t, e) {
    const i = await this.dispatch(
      new go(t, e)
    );
    await this.session.applyTokens(
      i.accessToken,
      i.refreshToken
    );
  }
  async logout() {
    await this.session.applyTokens(
      null,
      null
    );
  }
  async refreshTokens() {
    if (!this.session.refreshToken)
      throw new Error("No refresh token available");
    const t = await this.dispatch(
      new vo(this.session.refreshToken)
    );
    await this.session.applyTokens(
      t.accessToken,
      t.refreshToken
    );
  }
}
class Or extends A {
}
let Zt = class extends A {
};
class Bd extends S {
  constructor(t, e, i, a, n, l, u, h, c) {
    super(), this.id = t, this.templateId = e, this.teamId = i, this.wonenObjectId = a, this.wonenObjectAddress = n, this.payload = l, this.createdById = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromBrochure(t) {
    return new this(
      t.id.value,
      t.template.id.value,
      t.team.id.value,
      t.wonenObjectId,
      t.wonenObjectAddress,
      t.payload,
      t.createdBy.id.value,
      t.createdAt,
      t.updatedAt
    );
  }
  get validationSchema() {
    return f({
      id: Or.validationSchema.required(),
      templateId: Zt.validationSchema.required(),
      teamId: ve.validationSchema.required(),
      wonenObjectId: d().required(),
      wonenObjectAddress: d().required(),
      payload: f().nullable(),
      createdById: se.validationSchema.required(),
      createdAt: U().nullable(),
      updatedAt: U().nullable()
    });
  }
  get requestPath() {
    return "/brochure/brochures";
  }
  get requestMethod() {
    return F.POST;
  }
}
class Vd extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromBrochure(t) {
    return new this(
      t.id.value
    );
  }
  get validationSchema() {
    return f({ id: Or.validationSchema.required() });
  }
  get requestPath() {
    return `/brochure/brochures/${this.id.toString()}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
}
class Hd extends S {
  constructor(t) {
    super(), this.id = t;
  }
  get validationSchema() {
    return f({ id: Or.validationSchema.required() });
  }
  get requestPath() {
    return `/brochure/brochures/${this.id.toString()}/download`;
  }
  get requestMethod() {
    return F.GET;
  }
  async parseResponse(t) {
    return t == null ? void 0 : t.url;
  }
}
class Gd extends S {
  constructor(t, e, i, a) {
    super(), this.templateId = t, this.teamId = e, this.wonenObjectId = i, this.payload = a;
  }
  static fromBrochure(t) {
    var e;
    return new this(
      t.template.id.value,
      ((e = t.team) == null ? void 0 : e.id.value) ?? null,
      t.wonenObjectId,
      t.payload
    );
  }
  get validationSchema() {
    return f({
      templateId: Zt.validationSchema.required(),
      teamId: ve.validationSchema.nullable(),
      wonenObjectId: d().required(),
      payload: f().nullable()
    });
  }
  get requestPath() {
    return "/brochure/brochures/preview";
  }
  get requestMethod() {
    return F.POST;
  }
}
let Wd = class extends S {
  constructor(t, e, i, a, n, l, u, h, c, p, m, b) {
    super(), this.id = t, this.name = e, this.template = i, this.logoId = a, this.nvmLogoVisible = n, this.primaryColor = l, this.primaryTextColor = u, this.secondaryColor = h, this.secondaryTextColor = c, this.photosVisible = p, this.mapsVisible = m, this.active = b;
  }
  static fromTemplate(t) {
    var e;
    return new this(
      t.id.value,
      t.name,
      t.template,
      ((e = t.logo) == null ? void 0 : e.id.value) ?? null,
      t.nvmLogoVisible,
      t.primaryColor,
      t.primaryTextColor,
      t.secondaryColor,
      t.secondaryTextColor,
      t.photosVisible,
      t.mapsVisible,
      t.active
    );
  }
  get validationSchema() {
    return f({
      id: Zt.validationSchema.required(),
      name: d().required(),
      template: d().required(),
      logoId: d().nullable(),
      nvmLogoVisible: y().required(),
      primaryColor: d().nullable(),
      primaryTextColor: d().nullable(),
      secondaryColor: d().nullable(),
      secondaryTextColor: d().nullable(),
      photosVisible: y().required(),
      mapsVisible: y().required(),
      active: y().required()
    });
  }
  get requestPath() {
    return `/brochure/templates/${this.id.toString()}/change`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}, Kd = class extends S {
  constructor(t, e, i, a, n, l, u, h, c, p, m, b, v, g, w, O) {
    super(), this.companyId = t, this.id = e, this.name = i, this.template = a, this.logoId = n, this.nvmLogoVisible = l, this.primaryColor = u, this.primaryTextColor = h, this.secondaryColor = c, this.secondaryTextColor = p, this.photosVisible = m, this.mapsVisible = b, this.active = v, this.createdById = g, this.createdAt = w, this.updatedAt = O;
  }
  static fromTemplate(t) {
    var e;
    return new this(
      t.company.id,
      t.id.value,
      t.name,
      t.template,
      ((e = t.logo) == null ? void 0 : e.id.value) ?? null,
      t.nvmLogoVisible,
      t.primaryColor,
      t.primaryTextColor,
      t.secondaryColor,
      t.secondaryTextColor,
      t.photosVisible,
      t.mapsVisible,
      t.active,
      t.createdBy.id,
      t.createdAt,
      t.updatedAt
    );
  }
  get validationSchema() {
    return f({
      companyId: pe.validationSchema.required(),
      id: Zt.validationSchema.required(),
      name: d().required(),
      template: d().required(),
      logoId: d().nullable(),
      nvmLogoVisible: y().nullable(),
      primaryColor: d().nullable(),
      primaryTextColor: d().nullable(),
      secondaryColor: d().nullable(),
      secondaryTextColor: d().nullable(),
      photosVisible: y().nullable(),
      mapsVisible: y().nullable(),
      active: y().nullable(),
      createdById: se.validationSchema.required(),
      createdAt: U().nullable(),
      updatedAt: U().nullable()
    });
  }
  get requestPath() {
    return "/brochure/templates";
  }
  get requestMethod() {
    return F.POST;
  }
}, Qd = class extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromTemplate(t) {
    return new this(
      t.id.value
    );
  }
  get validationSchema() {
    return f({ id: Zt.validationSchema.required() });
  }
  get requestPath() {
    return `/brochure/templates/${this.id.toString()}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
}, Zd = class extends S {
  constructor(t, e, i, a, n, l, u, h, c, p, m, b, v) {
    super(), this.companyId = t, this.teamId = e, this.wonenObjectId = i, this.template = a, this.logoId = n, this.nvmLogoVisible = l, this.primaryColor = u, this.primaryTextColor = h, this.secondaryColor = c, this.secondaryTextColor = p, this.photosVisible = m, this.mapsVisible = b, this.payload = v;
  }
  static fromTemplate(t) {
    var e;
    return new this(
      t.template.company.id.value,
      t.teamId ?? null,
      t.wonenObjectId,
      t.template.template,
      ((e = t.template.logo) == null ? void 0 : e.id.value) ?? null,
      t.template.nvmLogoVisible,
      t.template.primaryColor,
      t.template.primaryTextColor,
      t.template.secondaryColor,
      t.template.secondaryTextColor,
      t.template.photosVisible,
      t.template.mapsVisible,
      t.payload ?? []
    );
  }
  get validationSchema() {
    return f({
      companyId: pe.validationSchema.required(),
      teamId: d().nullable(),
      wonenObjectId: d().required(),
      template: d().required(),
      logoId: d().nullable(),
      nvmLogoVisible: y().nullable(),
      primaryColor: d().nullable(),
      primaryTextColor: d().nullable(),
      secondaryColor: d().nullable(),
      secondaryTextColor: d().nullable(),
      photosVisible: y().nullable(),
      mapsVisible: y().nullable()
    });
  }
  get requestPath() {
    return "/brochure/templates/preview";
  }
  get requestMethod() {
    return F.POST;
  }
}, Cr = class extends A {
}, ec = class extends S {
  constructor(t, e, i) {
    super(), this.companyId = t, this.id = e, this.file = i;
  }
  get validationSchema() {
    return f({
      companyId: pe.validationSchema.required(),
      id: Cr.validationSchema.required(),
      file: ut().required().test("fileType", "File must be an image", (t) => t === null ? !1 : t.type.startsWith("image/"))
    });
  }
  get requestPath() {
    return "/brochure/logos";
  }
  get requestMethod() {
    return F.POST;
  }
  async parseRequest(t) {
    const e = new FormData();
    return e.append("companyId", t.companyId), e.append("id", t.id), e.append("file", t.file), e;
  }
  get contentType() {
    return "multipart/form-data";
  }
};
class ic extends S {
  constructor(t) {
    super(), this.id = t;
  }
  get validationSchema() {
    return f({ id: ve.validationSchema.required() });
  }
  get requestPath() {
    return `/company/teams/${this.id.toString()}/can_delete`;
  }
  async parseResponse(t) {
    return t.canDelete;
  }
}
class sc extends S {
  constructor(t, e) {
    super(), this.id = t, this.brandId = e;
  }
  get validationSchema() {
    return f({
      id: ve.validationSchema.required(),
      brandId: Pt.validationSchema.required()
    });
  }
  get requestPath() {
    return `/company/teams/${this.id.toString()}/change_brand`;
  }
  get requestMethod() {
    return F.PATCH;
  }
  async parseRequest(t) {
    return {
      id: t.id.toString(),
      brandId: t.brandId.toString()
    };
  }
}
class rc extends S {
  constructor(t, e, i, a, n, l, u, h, c) {
    super(), this.id = t, this.facebookUrl = e, this.instagramUrl = i, this.linkedinUrl = a, this.youtubeUrl = n, this.xUrl = l, this.pinterestUrl = u, this.tiktokUrl = h, this.vimeoUrl = c;
  }
  get validationSchema() {
    return f({
      id: ve.validationSchema.required(),
      facebookUrl: d().nullable(),
      instagramUrl: d().nullable(),
      linkedinUrl: d().nullable(),
      youtubeUrl: d().nullable(),
      xUrl: d().nullable(),
      pinterestUrl: d().nullable(),
      tiktokUrl: d().nullable(),
      vimeoUrl: d().nullable()
    });
  }
  get requestPath() {
    return `/company/teams/${this.id.toString()}/change_social_media`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class ac extends S {
  constructor(t, e, i, a = null, n = null, l = null, u = null, h = null, c = null, p = null, m = null, b = null, v = null, g = null, w = null, O = null, C = null) {
    super(), this.companyId = t, this.id = e, this.name = i, this.type = a, this.displayName = n, this.addressStreet = l, this.addressNumber = u, this.addressNumberSuffix = h, this.addressPostalCode = c, this.addressCity = p, this.addressRegion = m, this.addressCountry = b, this.phoneNumber = v, this.email = g, this.website = w, this.brandId = O, this.active = C;
  }
  get validationSchema() {
    return f({
      companyId: pe.validationSchema.required(),
      id: ve.validationSchema.required(),
      type: bt.validationSchema.nullable(),
      name: d().required(),
      displayName: d().nullable(),
      addressStreet: d().nullable(),
      addressNumber: d().nullable(),
      addressNumberSuffix: d().nullable(),
      addressPostalCode: d().nullable(),
      addressCity: d().nullable(),
      addressRegion: d().nullable(),
      addressCountry: d().nullable(),
      phoneNumber: d().nullable(),
      email: d().email().nullable(),
      website: d().url().nullable(),
      brandId: Pt.validationSchema.nullable(),
      active: y().nullable()
    });
  }
  get requestPath() {
    return "/company/teams";
  }
  get requestMethod() {
    return F.POST;
  }
  async parseRequest(t) {
    var e, i;
    return {
      ...t,
      companyId: t.companyId.toString(),
      id: t.id.toString(),
      type: (e = t.type) == null ? void 0 : e.toString(),
      brandId: (i = t.brandId) == null ? void 0 : i.toString()
    };
  }
}
class Ce extends A {
}
class nc extends S {
  constructor(t, e, i, a, n, l, u, h) {
    super(), this.id = t, this.street = e, this.number = i, this.numberSuffix = a, this.postalCode = n, this.city = l, this.region = u, this.country = h;
  }
  static fromContact(t) {
    var e, i, a, n, l, u, h;
    return new this(
      t.id,
      (e = t.address) == null ? void 0 : e.street,
      (i = t.address) == null ? void 0 : i.number,
      (a = t.address) == null ? void 0 : a.numberSuffix,
      (n = t.address) == null ? void 0 : n.postalCode,
      (l = t.address) == null ? void 0 : l.city,
      (u = t.address) == null ? void 0 : u.region,
      (h = t.address) == null ? void 0 : h.country
    );
  }
  get validationSchema() {
    return f({
      id: Ce.validationSchema.required(),
      street: d().nullable(),
      number: d().nullable(),
      numberSuffix: d().nullable(),
      postalCode: d().matches(/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i, { message: "Ongeldige postcode", excludeEmptyString: !0 }).nullable(),
      city: d().nullable(),
      region: d().nullable(),
      country: d().nullable()
    });
  }
  get requestPath() {
    return `/contact/contacts/${this.id.toString()}/change_address`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class lc extends S {
  constructor(t, e) {
    super(), this.id = t, this.birthDate = e;
  }
  static fromContact(t) {
    return new this(
      t.id,
      t.birthDate ?? null
    );
  }
  get validationSchema() {
    return f({
      id: Ce.validationSchema.required(),
      birthDate: U().nullable()
    });
  }
  get requestPath() {
    return `/contact/contacts/${this.id.toString()}/change_birth_date`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class oc extends S {
  constructor(t, e) {
    super(), this.id = t, this.email = e;
  }
  static fromContact(t) {
    var e;
    return new this(
      t.id,
      ((e = t.email) == null ? void 0 : e.toString()) ?? null
    );
  }
  get validationSchema() {
    return f({
      id: Ce.validationSchema.required(),
      email: d().nullable()
    });
  }
  get requestPath() {
    return `/contact/contacts/${this.id.toString()}/change_email`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class uc extends S {
  constructor(t, e, i, a, n, l, u, h) {
    super(), this.id = t, this.street = e, this.number = i, this.numberSuffix = a, this.postalCode = n, this.city = l, this.region = u, this.country = h;
  }
  static fromContact(t) {
    var e, i, a, n, l, u, h;
    return new this(
      t.id,
      ((e = t.futureAddress) == null ? void 0 : e.street) ?? null,
      ((i = t.futureAddress) == null ? void 0 : i.number) ?? null,
      ((a = t.futureAddress) == null ? void 0 : a.numberSuffix) ?? null,
      ((n = t.futureAddress) == null ? void 0 : n.postalCode) ?? null,
      ((l = t.futureAddress) == null ? void 0 : l.city) ?? null,
      ((u = t.futureAddress) == null ? void 0 : u.region) ?? null,
      ((h = t.futureAddress) == null ? void 0 : h.country) ?? null
    );
  }
  get validationSchema() {
    return f({
      id: Ce.validationSchema.required(),
      street: d().nullable(),
      number: d().nullable(),
      numberSuffix: d().nullable(),
      postalCode: d().matches(/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i, { message: "Ongeldige postcode", excludeEmptyString: !0 }).nullable(),
      city: d().nullable(),
      region: d().nullable(),
      country: d().nullable()
    });
  }
  get requestPath() {
    return `/contact/contacts/${this.id.toString()}/change_future_address`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class dc extends S {
  constructor(t, e) {
    super(), this.id = t, this.futureAddressStartingDate = e;
  }
  static fromContact(t) {
    return new this(
      t.id,
      t.futureAddressStartingDate
    );
  }
  get validationSchema() {
    return f({
      id: Ce.validationSchema.required(),
      futureAddressStartingDate: U().nullable()
    });
  }
  get requestPath() {
    return `/contact/contacts/${this.id.toString()}/change_future_address_starting_date`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class cc extends S {
  constructor(t, e) {
    super(), this.id = t, this.gender = e;
  }
  static fromContact(t) {
    var e;
    return new this(
      t.id,
      ((e = t.gender) == null ? void 0 : e.toString()) ?? null
    );
  }
  get validationSchema() {
    return f({
      id: Ce.validationSchema.required(),
      gender: d().nullable()
    });
  }
  get requestPath() {
    return `/contact/contacts/${this.id.toString()}/change_gender`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class hc extends S {
  constructor(t, e) {
    super(), this.id = t, this.mobilePhoneNumber = e;
  }
  static fromContact(t) {
    var e;
    return new this(
      t.id,
      ((e = t.mobilePhoneNumber) == null ? void 0 : e.toString()) ?? null
    );
  }
  get validationSchema() {
    return f({
      id: Ce.validationSchema.required(),
      mobilePhoneNumber: d().nullable()
    });
  }
  get requestPath() {
    return `/contact/contacts/${this.id.toString()}/change_mobile_phone_number`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class pc extends S {
  constructor(t, e, i, a, n) {
    super(), this.id = t, this.initials = e, this.firstName = i, this.middleName = a, this.lastName = n;
  }
  static fromContact(t) {
    var e, i, a, n;
    return new this(
      t.id,
      (e = t.name) == null ? void 0 : e.initials,
      (i = t.name) == null ? void 0 : i.firstName,
      (a = t.name) == null ? void 0 : a.middleName,
      (n = t.name) == null ? void 0 : n.lastName
    );
  }
  get validationSchema() {
    return f({
      id: Ce.validationSchema.required(),
      initials: d().nullable(),
      firstName: d().nullable(),
      middleName: d().nullable(),
      lastName: d().nullable()
    });
  }
  get requestPath() {
    return `/contact/contacts/${this.id.toString()}/change_name`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class mc extends S {
  constructor(t, e) {
    super(), this.id = t, this.phoneNumber = e;
  }
  static fromContact(t) {
    var e;
    return new this(
      t.id,
      ((e = t.phoneNumber) == null ? void 0 : e.toString()) ?? null
    );
  }
  get validationSchema() {
    return f({
      id: Ce.validationSchema.required(),
      phoneNumber: d().nullable()
    });
  }
  get requestPath() {
    return `/contact/contacts/${this.id.toString()}/change_phone_number`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class fc extends S {
  constructor(t, e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D, M, $, Z, te, oe, me, Pe, B, Ae, Je, Ze) {
    super(), this.companyId = t, this.id = e, this.gender = i, this.initials = a, this.firstName = n, this.middleName = l, this.lastName = u, this.addressStreet = h, this.addressNumber = c, this.addressNumberSuffix = p, this.addressPostalCode = m, this.addressCity = b, this.addressRegion = v, this.addressCountry = g, this.futureAddressStreet = w, this.futureAddressNumber = O, this.futureAddressNumberSuffix = C, this.futureAddressPostalCode = D, this.futureAddressCity = M, this.futureAddressRegion = $, this.futureAddressCountry = Z, this.futureAddressStartingDate = te, this.birthDate = oe, this.phoneNumber = me, this.mobilePhoneNumber = Pe, this.email = B, this.primaryContactId = Ae, this.createdAt = Je, this.updatedAt = Ze;
  }
  static fromContact(t) {
    var e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D, M, $, Z, te, oe, me;
    return new this(
      t.company.id,
      t.id,
      ((e = t.gender) == null ? void 0 : e.toString()) ?? null,
      (i = t.name) == null ? void 0 : i.initials,
      (a = t.name) == null ? void 0 : a.firstName,
      (n = t.name) == null ? void 0 : n.middleName,
      (l = t.name) == null ? void 0 : l.lastName,
      (u = t.address) == null ? void 0 : u.street,
      (h = t.address) == null ? void 0 : h.number,
      (c = t.address) == null ? void 0 : c.numberSuffix,
      (p = t.address) == null ? void 0 : p.postalCode,
      (m = t.address) == null ? void 0 : m.city,
      (b = t.address) == null ? void 0 : b.region,
      (v = t.address) == null ? void 0 : v.country,
      ((g = t.futureAddress) == null ? void 0 : g.street) ?? null,
      ((w = t.futureAddress) == null ? void 0 : w.number) ?? null,
      ((O = t.futureAddress) == null ? void 0 : O.numberSuffix) ?? null,
      ((C = t.futureAddress) == null ? void 0 : C.postalCode) ?? null,
      ((D = t.futureAddress) == null ? void 0 : D.city) ?? null,
      ((M = t.futureAddress) == null ? void 0 : M.region) ?? null,
      (($ = t.futureAddress) == null ? void 0 : $.country) ?? null,
      t.futureAddressStartingDate ?? null,
      t.birthDate ?? null,
      ((Z = t.phoneNumber) == null ? void 0 : Z.toString()) ?? null,
      ((te = t.mobilePhoneNumber) == null ? void 0 : te.toString()) ?? null,
      ((oe = t.email) == null ? void 0 : oe.toString()) ?? null,
      ((me = t.primaryContact) == null ? void 0 : me.id) ?? null,
      t.createdAt,
      t.updatedAt
    );
  }
  get validationSchema() {
    return f({
      companyId: pe.validationSchema.required(),
      id: Ce.validationSchema.required(),
      gender: d().nullable(),
      initials: d().nullable(),
      firstName: d().nullable(),
      middleName: d().nullable(),
      lastName: d().nullable(),
      addressStreet: d().nullable(),
      addressNumber: d().nullable(),
      addressNumberSuffix: d().nullable(),
      addressPostalCode: d().matches(/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i, { message: "Ongeldige postcode", excludeEmptyString: !0 }).nullable(),
      addressCity: d().nullable(),
      addressRegion: d().nullable(),
      addressCountry: d().nullable(),
      futureAddressStreet: d().nullable(),
      futureAddressNumber: d().nullable(),
      futureAddressNumberSuffix: d().nullable(),
      futureAddressPostalCode: d().nullable(),
      futureAddressCity: d().nullable(),
      futureAddressRegion: d().nullable(),
      futureAddressCountry: d().nullable(),
      futureAddressStartingDate: U().nullable(),
      birthDate: U().nullable(),
      phoneNumber: d().nullable(),
      mobilePhoneNumber: d().nullable(),
      email: d().nullable(),
      primaryContactId: Ce.validationSchema.nullable(),
      createdAt: U().nullable(),
      updatedAt: U().nullable()
    });
  }
  get requestPath() {
    return "/contact/contacts";
  }
  get requestMethod() {
    return F.POST;
  }
}
class bc extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromContact(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: Ce.validationSchema.required() });
  }
  get requestPath() {
    return `/contact/contacts/${this.id.toString()}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
}
let Gi = class extends A {
};
class Xt extends A {
}
class Ai extends A {
}
let vc = class extends S {
  constructor(t, e, i, a, n, l, u, h) {
    super(), this.id = t, this.templateId = e, this.teamId = i, this.leadId = a, this.payload = n, this.createdById = l, this.createdAt = u, this.updatedAt = h;
  }
  static create() {
    return new this(
      Gi.generate().value,
      "",
      "",
      "",
      {},
      "",
      null,
      null
    );
  }
  get validationSchema() {
    return f({
      id: Gi.validationSchema.required(),
      templateId: Xt.validationSchema.required(),
      teamId: ve.validationSchema.required(),
      leadId: Ai.validationSchema.required(),
      payload: f().nullable(),
      createdById: se.validationSchema.required(),
      createdAt: U().nullable(),
      updatedAt: U().nullable()
    });
  }
  get requestPath() {
    return "/document/documents";
  }
  get requestMethod() {
    return F.POST;
  }
};
class wc extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromDocument(t) {
    return new this(
      t.id.value
    );
  }
  get validationSchema() {
    return f({ id: Gi.validationSchema.required() });
  }
  get requestPath() {
    return `/document/documents/${this.id.toString()}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
}
class Sc extends S {
  constructor(t, e, i, a) {
    super(), this.templateId = t, this.teamId = e, this.leadId = i, this.payload = a;
  }
  static create() {
    return new this(
      "",
      "",
      "",
      {}
    );
  }
  get validationSchema() {
    return f({
      templateId: Xt.validationSchema.required(),
      teamId: ve.validationSchema.required(),
      leadId: Ai.validationSchema.required(),
      payload: f().nullable()
    });
  }
  get requestPath() {
    return "/document/documents/preview";
  }
  get requestMethod() {
    return F.POST;
  }
}
class Fc extends S {
  constructor(t) {
    super(), this.id = t;
  }
  get validationSchema() {
    return f({ id: Gi.validationSchema.required() });
  }
  get requestPath() {
    return `/document/documents/${this.id.toString()}/download`;
  }
  get requestMethod() {
    return F.GET;
  }
  async parseResponse(t) {
    return t == null ? void 0 : t.url;
  }
}
class _t extends A {
}
let Ac = class extends S {
  constructor(t, e, i) {
    super(), this.companyId = t, this.id = e, this.file = i;
  }
  static create() {
    return new this(
      "",
      _t.generate().value,
      null
    );
  }
  get validationSchema() {
    return f({
      companyId: pe.validationSchema.required(),
      id: _t.validationSchema.required(),
      file: ut().required().test("fileType", "File must be an image", (t) => t === null ? !1 : t.type.startsWith("image/"))
    });
  }
  get requestPath() {
    return "/document/logos";
  }
  get requestMethod() {
    return F.POST;
  }
  async parseRequest(t) {
    const e = new FormData();
    return e.append("companyId", t.companyId), e.append("id", t.id), e.append("file", t.file), e;
  }
  get contentType() {
    return "multipart/form-data";
  }
}, Oc = class extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromLogo(t) {
    return new this(
      t.id.value
    );
  }
  get validationSchema() {
    return f({ id: _t.validationSchema.required() });
  }
  get requestPath() {
    return `/document/logos/${this.id.toString()}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
};
class Ir extends A {
}
class Ic extends S {
  constructor(t, e, i, a, n, l) {
    super(), this.id = t, this.name = e, this.layoutId = i, this.logoId = a, this.payload = n, this.active = l;
  }
  static fromTemplate(t) {
    var e;
    return new this(
      t.id.value,
      t.name,
      t.layout.id.value,
      ((e = t.logo) == null ? void 0 : e.id.value) ?? null,
      t.payload,
      t.active
    );
  }
  get validationSchema() {
    return f({
      id: Xt.validationSchema.required(),
      name: d().required(),
      layoutId: Ir.validationSchema.required(),
      logoId: _t.validationSchema.nullable(),
      payload: f().required(),
      active: y().required()
    });
  }
  get requestPath() {
    return `/document/templates/${this.id.toString()}/change`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class Tc extends S {
  constructor(t, e, i, a, n, l, u, h, c, p) {
    super(), this.companyId = t, this.id = e, this.name = i, this.layoutId = a, this.logoId = n, this.payload = l, this.active = u, this.createdById = h, this.createdAt = c, this.updatedAt = p;
  }
  static create() {
    return new this(
      "",
      Xt.generate().value,
      "",
      "",
      null,
      {},
      null,
      "",
      null,
      null
    );
  }
  get validationSchema() {
    return f({
      companyId: pe.validationSchema.required(),
      id: Xt.validationSchema.required(),
      name: d().required(),
      layoutId: Ir.validationSchema.required(),
      logoId: _t.validationSchema.nullable(),
      payload: f().required(),
      active: y().nullable(),
      createdById: se.validationSchema.required(),
      createdAt: U().nullable(),
      updatedAt: U().nullable()
    });
  }
  get requestPath() {
    return "/document/templates";
  }
  get requestMethod() {
    return F.POST;
  }
}
class xc extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromTemplate(t) {
    return new this(
      t.id.value
    );
  }
  get validationSchema() {
    return f({ id: Xt.validationSchema.required() });
  }
  get requestPath() {
    return `/document/templates/${this.id.toString()}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
}
class Dc extends S {
  constructor(t, e, i, a, n) {
    super(), this.companyId = t, this.teamId = e, this.layoutId = i, this.logoId = a, this.payload = n;
  }
  static create() {
    return new this(
      "",
      null,
      "",
      null,
      {}
    );
  }
  get validationSchema() {
    return f({
      companyId: pe.validationSchema.required(),
      teamId: ve.validationSchema.nullable(),
      layoutId: Ir.validationSchema.nullable(),
      logoId: _t.validationSchema.nullable(),
      payload: f().required()
    });
  }
  get requestPath() {
    return "/document/templates/preview";
  }
  get requestMethod() {
    return F.POST;
  }
}
class fl extends A {
}
const Ee = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: Ee.VIDEO, label: "Videobellen" },
      { value: Ee.PHONE, label: "Telefonisch" },
      { value: Ee.OFFICE, label: "Op kantoor" },
      { value: Ee.CONTACT, label: "Bij de lead" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return Ee.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      Ee.VIDEO,
      Ee.PHONE,
      Ee.OFFICE,
      Ee.CONTACT
    ];
  }
};
let It = Ee;
o(It, "VIDEO", new Ee("video")), o(It, "PHONE", new Ee("phone")), o(It, "OFFICE", new Ee("office")), o(It, "CONTACT", new Ee("contact"));
const Le = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: Le.TENTATIVE, label: "Voorlopig" },
      { value: Le.CONFIRMED, label: "Bevestigd" },
      { value: Le.CANCELED, label: "Geannuleerd" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return Le.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      Le.TENTATIVE,
      Le.CONFIRMED,
      Le.CANCELED
    ];
  }
};
let qt = Le;
o(qt, "TENTATIVE", new Le("tentative")), o(qt, "CONFIRMED", new Le("confirmed")), o(qt, "CANCELED", new Le("canceled"));
class Rc extends S {
  constructor(t, e, i, a, n, l, u, h, c, p) {
    super(), this.leadId = t, this.id = e, this.startDateTime = i, this.endDateTime = a, this.comment = n, this.type = l, this.customType = u, this.status = h, this.assignedUserIds = c, this.createdById = p;
  }
  get validationSchema() {
    return f({
      leadId: Ai.validationSchema,
      id: fl.validationSchema,
      startDateTime: U().required(),
      endDateTime: U().required(),
      comment: d(),
      type: It.validationSchema,
      customType: d(),
      status: qt.validationSchema,
      assignedUserIds: R().of(se.validationSchema),
      createdById: se.validationSchema
    });
  }
  get requestPath() {
    return "/lead/appointments";
  }
  async parseResponse(t) {
    return !!t;
  }
}
class Nc extends S {
  constructor(t) {
    super(), this.id = t;
  }
  get validationSchema() {
    return f({ id: Ai.validationSchema });
  }
  get requestMethod() {
    return F.POST;
  }
  get requestPath() {
    return `/lead/leads/${this.id}/register_viewed`;
  }
}
class bl extends A {
}
const W = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: W.CALL, label: "Bellen" },
      { value: W.EMAIL, label: "E-mail" },
      { value: W.REMINDER, label: "Herinnering" },
      { value: W.LETTER, label: "Post" },
      { value: W.BILLING, label: "Facturatie" },
      { value: W.UPDATE, label: "Update" },
      { value: W.NOTIFICATION, label: "Notificatie" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return W.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      W.CALL,
      W.EMAIL,
      W.REMINDER,
      W.LETTER,
      W.BILLING,
      W.UPDATE,
      W.NOTIFICATION
    ];
  }
};
let Ke = W;
o(Ke, "CALL", new W("call")), o(Ke, "EMAIL", new W("email")), o(Ke, "REMINDER", new W("reminder")), o(Ke, "LETTER", new W("letter")), o(Ke, "BILLING", new W("billing")), o(Ke, "UPDATE", new W("update")), o(Ke, "NOTIFICATION", new W("notification"));
const Ie = class extends I {
  get label() {
    var t;
    return ((t = Ie.options.find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return Ie.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      Ie.OPEN,
      Ie.COMPLETED,
      Ie.CANCELED
    ];
  }
  static get options() {
    return [
      { value: Ie.OPEN, label: "Open" },
      { value: Ie.COMPLETED, label: "Voltooid" },
      { value: Ie.CANCELED, label: "Geannuleerd" }
    ];
  }
};
let gt = Ie;
o(gt, "OPEN", new Ie("open")), o(gt, "COMPLETED", new Ie("completed")), o(gt, "CANCELED", new Ie("canceled"));
class Pc extends S {
  constructor(t, e, i, a, n, l, u, h, c) {
    super(), this.leadId = t, this.id = e, this.dueDateTime = i, this.comment = a, this.type = n, this.customType = l, this.status = u, this.assignedUserIds = h, this.createdById = c;
  }
  get validationSchema() {
    return f({
      leadId: Ai.validationSchema,
      id: bl.validationSchema,
      dueDateTime: U().required(),
      comment: d(),
      type: Ke.validationSchema,
      customType: d(),
      status: gt.validationSchema,
      assignedUserIds: R().of(se.validationSchema),
      createdById: se.validationSchema
    });
  }
  get requestPath() {
    return "/lead/tasks";
  }
  async parseResponse(t) {
    return !!t;
  }
}
class xt extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O) {
    super();
    o(this, "entrypoint", "contact/contacts");
    o(this, "fromObject", (e) => xt.fromObject(e));
    this.company = e, this.id = i, this.gender = a, this.name = n, this.address = l, this.futureAddress = u, this.futureAddressStartingDate = h, this.birthDate = c, this.phoneNumber = p, this.mobilePhoneNumber = m, this.email = b, this.primaryContact = v, this.secondaryContact = g, this.createdAt = w, this.updatedAt = O;
  }
  createPartner() {
    return new xt(
      this.company,
      Ce.generate(),
      Tt.NEUTRAL,
      // @todo should be null, but will break input-select if null,
      Qt.fromObject({}),
      this.address,
      this.futureAddress,
      this.futureAddressStartingDate,
      null,
      this.phoneNumber,
      this.mobilePhoneNumber,
      this.email,
      this,
      null,
      new Date(),
      new Date()
    );
  }
  static fromObject(e) {
    return new xt(
      s.parseField(e.company, J),
      s.parseField(e.id, Ce),
      s.parseField(e.gender, Tt),
      s.parseField(e.name, Qt),
      s.parseField(e.address, wt),
      s.parseField(e.futureAddress, wt),
      s.parseField(e.futureAddressStartingDate, Date),
      s.parseField(e.birthDate, Date),
      s.parseField(e.phoneNumber, vi),
      s.parseField(e.mobilePhoneNumber, vi),
      s.parseField(e.email, si),
      s.parseField(e.primaryContact, xt),
      s.parseField(e.secondaryContact, xt),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Yu extends A {
}
class ki extends s {
  constructor(e, i, a, n) {
    super();
    o(this, "entrypoint");
    o(this, "fromObject", (e) => ki.fromObject(e));
    this.id = e, this.company = i, this.team = a, this.user = n;
  }
  equals(e) {
    return e instanceof ki ? this.company.equals(e.company) && this.team.equals(e.team) && (this.user === null ? e.user === null : this.user.equals(e.user)) : !1;
  }
  static fromObject(e) {
    return new ki(
      s.parseField(e.id, Yu),
      s.parseField(e.company, J),
      s.parseField(e.team, Fe),
      s.parseField(e.user, ee)
    );
  }
}
class Qu extends A {
}
class ys extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v) {
    super();
    o(this, "entrypoint", "lead/attachments");
    o(this, "fromObject", (e) => ys.fromObject(e));
    this.lead = e, this.id = i, this.fileName = a, this.fileSize = n, this.fileType = l, this.name = u, this.description = h, this.source = c, this.createdByContact = p, this.createdBy = m, this.createdAt = b, this.updatedAt = v;
  }
  static fromObject(e) {
    return new ys(
      s.parseField(e.lead, ri),
      s.parseField(e.id, Qu),
      s.parseField(e.fileName),
      s.parseField(e.fileSize),
      s.parseField(e.fileType),
      s.parseField(e.name),
      s.parseField(e.description),
      s.parseField(e.source),
      s.parseField(e.createdByContact),
      s.parseField(e.createdBy, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Ju extends A {
}
const ke = class extends I {
  get schemaConfig() {
    return ke.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      ke.SYSTEM,
      ke.USER,
      ke.VIRTUAL_COLLEAGUE
    ];
  }
  static get options() {
    return [
      { value: ke.SYSTEM, label: "Systeem" },
      { value: ke.USER, label: "Gebruiker" },
      { value: ke.VIRTUAL_COLLEAGUE, label: "Virtuele Collega" }
    ];
  }
};
let vt = ke;
o(vt, "SYSTEM", new ke("system")), o(vt, "USER", new ke("user")), o(vt, "VIRTUAL_COLLEAGUE", new ke("virtual-colleague"));
const je = class extends I {
  get schemaConfig() {
    return je.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      je.PERSONAL,
      je.PRIVATE,
      je.PUBLIC
    ];
  }
  static get options() {
    return [
      { value: je.PUBLIC, label: "Alle betrokkenen" },
      { value: je.PRIVATE, label: "Binnen huidige bedrijf" },
      { value: je.PERSONAL, label: "Alleen ik" }
    ];
  }
};
let He = je;
o(He, "PERSONAL", new je("personal")), o(He, "PRIVATE", new je("private")), o(He, "PUBLIC", new je("public"));
class Os extends s {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "entrypoint", "lead/comments");
    o(this, "fromObject", (e) => Os.fromObject(e));
    this.lead = e, this.id = i, this.comment = a, this.origin = n, this.visibility = l, this.createdBy = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromObject(e) {
    return new Os(
      s.parseField(e.lead, ri),
      s.parseField(e.id, Ju),
      s.parseField(e.comment),
      s.parseField(e.origin, vt),
      s.parseField(e.visibility, He),
      s.parseField(e.createdBy, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
  get visibilityLabel() {
    var e;
    return ((e = [
      { value: He.PERSONAL, label: "Persoonlijk" },
      { value: He.PRIVATE, label: "Binnen huidige bedrijf" },
      { value: He.PUBLIC, label: "Alle betrokkenen" }
    ].find((i) => this.visibility.equals(i.value))) == null ? void 0 : e.label) ?? this.visibility.value;
  }
  get visibilitySubLabel() {
    var e;
    return ((e = [
      { value: He.PERSONAL, label: "Alleen de persoon die de opmerking plaatst kan deze lezen" },
      { value: He.PRIVATE, label: "Iedereen die werkzaam is voor dit bedrijf en bij de lead mag komen, kan de opmerking lezen" },
      { value: He.PUBLIC, label: "Iedereen die te maken heeft met deze lead mag de opmerking lezen" }
    ].find((i) => this.visibility.equals(i.value))) == null ? void 0 : e.label) ?? this.visibility.value;
  }
  get isSystemComment() {
    return this.origin.equals(vt.SYSTEM);
  }
  get isVirtualColleagueComment() {
    return this.origin.equals(vt.VIRTUAL_COLLEAGUE);
  }
  get isUserComment() {
    return this.origin.equals(vt.USER);
  }
}
class Zu extends A {
}
class Xu extends A {
}
const Te = class extends I {
  get label() {
    var t;
    return ((t = Te.options.find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return Te.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      Te.USER,
      Te.ONLINE,
      Te.REALWORKS
    ];
  }
  static get options() {
    return [
      { value: Te.USER, label: "Handmatig" },
      { value: Te.ONLINE, label: "Online" },
      { value: Te.REALWORKS, label: "Realworks" }
    ];
  }
};
let Ut = Te;
o(Ut, "USER", new Te("user")), o(Ut, "ONLINE", new Te("online")), o(Ut, "REALWORKS", new Te("realworks"));
class Cs extends s {
  constructor(e, i, a, n, l, u, h) {
    super();
    o(this, "entrypoint", "lead/sources");
    o(this, "fromObject", (e) => Cs.fromObject(e));
    this.company = e, this.id = i, this.channel = a, this.name = n, this.active = l, this.createdAt = u, this.updatedAt = h;
  }
  static fromObject(e) {
    return new Cs(
      s.parseField(e.company, J),
      s.parseField(e.id, Xu),
      s.parseField(e.channel, Ut),
      s.parseField(e.name),
      s.parseField(e.active),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class ji extends s {
  constructor(e, i, a) {
    super();
    o(this, "entrypoint");
    o(this, "fromObject", (e) => ji.fromObject(e));
    this.id = e, this.channel = i, this.source = a;
  }
  equals(e) {
    return e instanceof ji ? this.channel.equals(e.channel) && this.source.equals(e.source) : !1;
  }
  static fromObject(e) {
    return new ji(
      s.parseField(e.id, Zu),
      s.parseField(e.channel, Ut),
      s.parseField(e.source, Cs)
    );
  }
}
class _u extends A {
}
class qi extends s {
  constructor(e, i, a, n) {
    super();
    o(this, "entrypoint");
    o(this, "fromObject", (e) => qi.fromObject(e));
    this.id = e, this.company = i, this.team = a, this.user = n;
  }
  equals(e) {
    return e instanceof qi ? this.company.equals(e.company) && this.team.equals(e.team) && (this.user === null ? e.user === null : this.user.equals(e.user)) : !1;
  }
  static fromObject(e) {
    return new qi(
      s.parseField(e.id, _u),
      s.parseField(e.company, J),
      s.parseField(e.team, Fe),
      s.parseField(e.user, ee)
    );
  }
}
const qe = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: qe.NEGATIVE, label: "Negatief" },
      { value: qe.NEUTRAL, label: "Neutraal" },
      { value: qe.POSITIVE, label: "Positief" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return qe.validationSchema;
  }
  static get validationSchema() {
    return _().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      qe.NEGATIVE,
      qe.NEUTRAL,
      qe.POSITIVE
    ];
  }
};
let ni = qe;
o(ni, "NEGATIVE", new qe(-1)), o(ni, "NEUTRAL", new qe(0)), o(ni, "POSITIVE", new qe(1));
const pt = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: pt.EXISTING, label: "Bestaand" },
      { value: pt.NEW, label: "Nieuwbouw" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return pt.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      pt.EXISTING,
      pt.NEW
    ];
  }
};
let Ni = pt;
o(Ni, "EXISTING", new pt("existing")), o(Ni, "NEW", new pt("new"));
class ed extends A {
}
class td extends A {
}
class Wi extends s {
  constructor(e, i, a, n, l, u) {
    super();
    o(this, "entrypoint", "lead/projects");
    o(this, "fromObject", (e) => Wi.fromObject(e));
    this.company = e, this.id = i, this.name = a, this.active = n, this.createdAt = l, this.updatedAt = u;
  }
  static fromObject(e) {
    return new Wi(
      s.parseField(e.company, J),
      s.parseField(e.id, td),
      s.parseField(e.name),
      s.parseField(e.active),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Ui extends s {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "entrypoint");
    o(this, "fromObject", (e) => Ui.fromObject(e));
    this.id = e, this.address = i, this.addressStartingDate = a, this.buildType = n, this.project = l, this.projectConstructionNumber = u, this.assigneeProject = h, this.assigneeProjectConstructionNumber = c;
  }
  equals(e) {
    return e instanceof Ui ? this.id.equals(e.id) : !1;
  }
  static fromObject(e) {
    return new Ui(
      s.parseField(e.id, ed),
      s.parseField(e.address, wt),
      s.parseField(e.addressStartingDate, Date),
      s.parseField(e.buildType, Ni),
      s.parseField(e.project, Wi),
      s.parseField(e.projectConstructionNumber),
      s.parseField(e.assigneeProject, Wi),
      s.parseField(e.assigneeProjectConstructionNumber)
    );
  }
}
class id extends A {
}
class $i extends s {
  constructor(e, i, a, n, l) {
    super();
    o(this, "entrypoint");
    o(this, "fromObject", (e) => $i.fromObject(e));
    this.id = e, this.transportDate = i, this.productionDate = a, this.orderValue = n, this.commission = l;
  }
  equals(e) {
    return e instanceof $i ? this.transportDate === e.transportDate && this.productionDate === e.productionDate && this.orderValue === e.orderValue && this.commission === e.commission : !1;
  }
  static fromObject(e) {
    return new $i(
      s.parseField(e.id, id),
      s.parseField(e.transportDate, Date),
      s.parseField(e.productionDate, Date),
      s.parseField(e.orderValue),
      s.parseField(e.commission)
    );
  }
}
const k = class extends I {
  get label() {
    var t;
    return ((t = k.options.find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  compareTo(t) {
    const e = k.values.findIndex((a) => a.equals(this)), i = k.values.findIndex((a) => a.equals(t));
    return e - i;
  }
  get isKeyVueCategory() {
    return !this.isWinckCategory;
  }
  get isWinckCategory() {
    switch (this.value) {
      case k.EMAIL1.value:
      case k.EMAIL2.value:
      case k.EMAIL3.value:
        return !0;
      default:
        return !1;
    }
  }
  get schemaConfig() {
    return k.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get options() {
    return [
      { value: k.ENTRY, label: "Binnenkomst" },
      { value: k.APPROACH, label: "Benadering" },
      { value: k.DECISION, label: "Beslissing" },
      { value: k.EMAIL1, label: "E-mail 1" },
      { value: k.EMAIL2, label: "E-mail 2" },
      { value: k.EMAIL3, label: "E-mail 3" }
    ];
  }
  static get values() {
    return [
      k.ENTRY,
      k.APPROACH,
      k.DECISION,
      k.EMAIL1,
      k.EMAIL2,
      k.EMAIL3
    ];
  }
  static get keyVueOptions() {
    return k.options.filter((t) => t.value.isKeyVueCategory);
  }
  static get winckOptions() {
    return k.options.filter((t) => t.value.isWinckCategory);
  }
  static get keyVueValues() {
    return k.values.filter((t) => t.isKeyVueCategory);
  }
  static get winckValues() {
    return k.values.filter((t) => t.isWinckCategory);
  }
};
let ct = k;
o(ct, "ENTRY", new k("entry")), o(ct, "APPROACH", new k("approach")), o(ct, "DECISION", new k("decision")), o(ct, "EMAIL1", new k("email1")), o(ct, "EMAIL2", new k("email2")), o(ct, "EMAIL3", new k("email3"));
class sd extends A {
}
const T = class extends I {
  get label() {
    var t;
    return ((t = T.options.find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get isKeyVueCategory() {
    return !this.isWinckCategory;
  }
  get isWinckCategory() {
    return this.value.startsWith("winck-");
  }
  get schemaConfig() {
    return T.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get options() {
    return [
      // KeyVue
      { value: T.PURCHASE, label: "Woning aankoop" },
      { value: T.SALE, label: "Woning verkoop" },
      { value: T.MORTGAGE, label: "Hypotheek" },
      { value: T.TAXATION, label: "Taxatie" },
      { value: T.SUSTAINABILITY, label: "Verduurzaming" },
      { value: T.INSURANCE, label: "Assurantie" },
      { value: T.NEW_BUILD, label: "Nieuwbouw" },
      { value: T.RENTAL, label: "Verhuur" },
      { value: T.BUSINESS_REAL_ESTATE, label: "BOG" },
      // Winck
      { value: T.WINCK_REMINDER, label: "Herinnering" },
      { value: T.WINCK_SERVICE, label: "Service" },
      { value: T.WINCK_CONFIRMATION, label: "Bevestiging" },
      { value: T.WINCK_MILESTONE, label: "Verjaring" },
      { value: T.WINCK_SALES, label: "Sales" },
      { value: T.WINCK_UPSELL, label: "Upsell" }
    ];
  }
  static get values() {
    return [
      // KeyVue
      T.PURCHASE,
      T.SALE,
      T.MORTGAGE,
      T.TAXATION,
      T.SUSTAINABILITY,
      T.INSURANCE,
      T.NEW_BUILD,
      T.RENTAL,
      T.BUSINESS_REAL_ESTATE,
      // Winck
      T.WINCK_REMINDER,
      T.WINCK_SERVICE,
      T.WINCK_CONFIRMATION,
      T.WINCK_MILESTONE,
      T.WINCK_SALES,
      T.WINCK_UPSELL
    ];
  }
  static get keyVueOptions() {
    return T.options.filter((t) => t.value.isKeyVueCategory);
  }
  static get winckOptions() {
    return T.options.filter((t) => t.value.isWinckCategory);
  }
  static get keyVueValues() {
    return T.values.filter((t) => t.isKeyVueCategory);
  }
  static get winckValues() {
    return T.values.filter((t) => t.isWinckCategory);
  }
};
let ie = T;
// KeyVue
o(ie, "PURCHASE", new T("purchase")), o(ie, "SALE", new T("sale")), o(ie, "MORTGAGE", new T("mortgage")), o(ie, "TAXATION", new T("taxation")), o(ie, "SUSTAINABILITY", new T("sustainability")), o(ie, "INSURANCE", new T("insurance")), o(ie, "NEW_BUILD", new T("new-build")), o(ie, "RENTAL", new T("rental")), o(ie, "BUSINESS_REAL_ESTATE", new T("business-real-estate")), // Winck
o(ie, "WINCK_REMINDER", new T("winck-reminder")), o(ie, "WINCK_SERVICE", new T("winck-service")), o(ie, "WINCK_CONFIRMATION", new T("winck-confirmation")), o(ie, "WINCK_MILESTONE", new T("winck-milestone")), o(ie, "WINCK_SALES", new T("winck-sales")), o(ie, "WINCK_UPSELL", new T("winck-upsell"));
class zi extends A {
}
class rd extends A {
}
var K;
let Is = (K = class extends I {
  constructor() {
    super(...arguments);
    o(this, "reasonRequired", !1);
    o(this, "nullReasonEnabled", !1);
    o(this, "reasons", []);
  }
  get label() {
    var e;
    return ((e = K.options.find((i) => this.equals(i.value))) == null ? void 0 : e.label) ?? this.value;
  }
  get isFinal() {
    return this.equals(K.WON) || this.equals(K.LOST);
  }
  get schemaConfig() {
    return K.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((e) => e.value));
  }
  static get values() {
    return [
      K.OPEN,
      K.WON,
      K.LOST,
      K.OPPORTUNITY
    ];
  }
  static get options() {
    return [
      { value: K.OPEN, label: "Open" },
      { value: K.WON, label: "Gewonnen" },
      { value: K.LOST, label: "Verloren" },
      { value: K.OPPORTUNITY, label: "Kans" }
    ];
  }
}, o(K, "OPEN", new K("open")), o(K, "WON", new K("won")), o(K, "LOST", new K("lost")), o(K, "OPPORTUNITY", new K("opportunity")), K);
class Ei extends s {
  constructor(e, i, a, n, l, u, h, c, p) {
    super();
    o(this, "entrypoint", "lead/reasons");
    o(this, "fromObject", (e) => Ei.fromObject(e));
    this.company = e, this.id = i, this.pipeline = a, this.phases = n, this.status = l, this.name = u, this.active = h, this.createdAt = c, this.updatedAt = p;
  }
  static fromObject(e) {
    return new Ei(
      s.parseField(e.company, J),
      s.parseField(e.id, rd),
      s.parseField(e.pipeline, ts),
      s.parseField(e.phases, is),
      s.parseField(e.status, Is),
      s.parseField(e.name),
      s.parseField(e.active),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Ts extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D) {
    super();
    o(this, "entrypoint", "lead/pipelines");
    o(this, "fromObject", (e) => Ts.fromObject(e));
    o(this, "subResources", {
      "available-teams": "lead/pipelines/{id}/available_teams",
      "available-reasons": "lead/pipelines/{id}/available_reasons",
      reasons: "lead/pipelines/{id}/reasons"
    });
    this.company = e, this.id = i, this.name = a, this.category = n, this.teams = l, this.fallbackTeam = u, this.potentialOrderValuePerReferral = h, this.conversionPercentage = c, this.active = p, this.phases = m, this.reasons = b, this.averageDaysInPipeline = v, this.averageDaysInEntryCategory = g, this.averageDaysInApproachCategory = w, this.averageDaysInDecisionCategory = O, this.createdAt = C, this.updatedAt = D;
  }
  hasTeam(e) {
    return this.teams.findIndex((i) => i.equals(e)) >= 0;
  }
  get activePhases() {
    return this.phases.filter((e) => e.active);
  }
  static fromObject(e) {
    const i = [];
    return e.phases && s.parseField(e.phases, is).forEach((a) => {
      a.id !== null && i.push(a);
    }), i.sort((a, n) => a.compareTo(n)), new Ts(
      s.parseField(e.company, J),
      s.parseField(e.id, zi),
      s.parseField(e.name),
      s.parseField(e.category, ie),
      s.parseField(e.teams, Fe),
      s.parseField(e.fallbackTeam, Fe),
      s.parseField(e.potentialOrderValuePerReferral),
      s.parseField(e.conversionPercentage),
      s.parseField(e.active),
      i,
      s.parseField(e.reasons, Ei),
      s.parseField(e.averageDaysInPipeline),
      s.parseField(e.averageDaysInEntryCategory),
      s.parseField(e.averageDaysInApproachCategory),
      s.parseField(e.averageDaysInDecisionCategory),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const ts = Ts;
class xs extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v) {
    super();
    o(this, "entrypoint", "lead/phases");
    o(this, "fromObject", (e) => xs.fromObject(e));
    this.pipeline = e, this.id = i, this.name = a, this.category = n, this.color = l, this.sort = u, this.reasonRequired = h, this.nullReasonEnabled = c, this.active = p, this.reasons = m, this.createdAt = b, this.updatedAt = v;
  }
  compareTo(e) {
    const i = this.category.compareTo(e.category);
    return i !== 0 ? i : this.sort - e.sort;
  }
  static fromObject(e) {
    return new xs(
      s.parseField(e.pipeline, ts),
      s.parseField(e.id, sd),
      s.parseField(e.name),
      s.parseField(e.category, ct),
      s.parseField(e.color),
      s.parseField(e.sort),
      s.parseField(e.reasonRequired),
      s.parseField(e.nullReasonEnabled),
      s.parseField(e.active),
      s.parseField(e.reasons, Ei),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const is = xs;
class Ki extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g) {
    super();
    o(this, "entrypoint", "lead/tasks");
    o(this, "fromObject", (e) => Ki.fromObject(e));
    this.lead = e, this.id = i, this.dueDateTime = a, this.comment = n, this.type = l, this.customType = u, this.status = h, this.assignedUsers = c, this.source = p, this.sourceId = m, this.createdBy = b, this.createdAt = v, this.updatedAt = g;
  }
  static fromObject(e) {
    return new Ki(
      s.parseField(e.lead, ri),
      s.parseField(e.id, bl),
      s.parseField(e.dueDateTime, Date),
      s.parseField(e.comment),
      s.parseField(e.type, Ke),
      s.parseField(e.customType),
      s.parseField(e.status, gt),
      s.parseField(e.assignedUsers, ee),
      s.parseField(e.source),
      s.parseField(e.sourceId),
      s.parseField(e.createdBy, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
  get typeLabel() {
    return this.customType !== null ? this.customType : this.type !== null ? this.type.label : null;
  }
  get isCompleted() {
    return this.status.equals(gt.COMPLETED);
  }
  get isOverdue() {
    return this.isPast && this.status.equals(gt.OPEN);
  }
  get isToday() {
    const e = new Date();
    return this.dueDateTime.getDate() === e.getDate() && this.dueDateTime.getMonth() === e.getMonth() && this.dueDateTime.getFullYear() === e.getFullYear();
  }
  get isFuture() {
    return this.dueDateTime > new Date();
  }
  get isPast() {
    return this.dueDateTime < new Date();
  }
}
class Ds {
  constructor(t, e, i) {
    o(this, "fromObject", (t) => Ds.fromObject(t));
    this.category = t, this.entryDateTime = e, this.exitDateTime = i;
  }
  static fromObject(t) {
    return new Ds(
      s.parseField(t.category),
      s.parseField(t.entryDateTime, Date),
      s.parseField(t.exitDateTime, Date)
    );
  }
}
class Rs {
  constructor(t, e, i) {
    o(this, "fromObject", (t) => Rs.fromObject(t));
    this.phase = t, this.entryDateTime = e, this.exitDateTime = i;
  }
  static fromObject(t) {
    return new Rs(
      s.parseField(t.phase, is),
      s.parseField(t.entryDateTime, Date),
      s.parseField(t.exitDateTime, Date)
    );
  }
}
class Ns {
  constructor(t, e, i) {
    o(this, "fromObject", (t) => Ns.fromObject(t));
    this.status = t, this.entryDateTime = e, this.exitDateTime = i;
  }
  static fromObject(t) {
    return new Ns(
      s.parseField(t.status),
      s.parseField(t.entryDateTime, Date),
      s.parseField(t.exitDateTime, Date)
    );
  }
}
class Ps extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D, M, $, Z, te, oe, me, Pe, B, Ae, Je, Ze, Oi, Ci, Ii, Ti, xi) {
    super();
    o(this, "entrypoint", "lead/leads");
    o(this, "fromObject", (e) => Ps.fromObject(e));
    o(this, "subResources", { "mentionable-users": "lead/leads/{id}/mentionable_users" });
    this.id = e, this.primaryContact = i, this.secondaryContacts = a, this.pipeline = n, this.phase = l, this.status = u, this.reason = h, this.referrer = c, this.assignee = p, this.priority = m, this.score = b, this.origin = v, this.subject = g, this.transaction = w, this.nextOrPreviousAppointment = O, this.nextOrPreviousTask = C, this.medianValuation = D, this.manualValuation = M, this.data = $, this.potentialOrderValue = Z, this.comments = te, this.attachments = oe, this.appointments = me, this.tasks = Pe, this.phaseCategoryLogs = B, this.phaseLogs = Ae, this.statusLogs = Je, this.onSchedule = Ze, this.daysInactive = Oi, this.createdAt = Ci, this.updatedAt = Ii, this.viewedAt = Ti, this.permissions = xi;
  }
  static fromObject(e) {
    return new Ps(
      s.parseField(e.id, Ai),
      s.parseField(e.primaryContact, xt),
      s.parseField(e.secondaryContacts, xt),
      s.parseField(e.pipeline, ts),
      s.parseField(e.phase, is),
      s.parseField(e.status, Is),
      s.parseField(e.reason, Ei),
      s.parseField(e.referrer, qi),
      s.parseField(e.assignee, ki),
      s.parseField(e.priority),
      s.parseField(e.score, ni),
      s.parseField(e.origin, ji),
      s.parseField(e.subject, Ui),
      s.parseField(e.transaction, $i),
      s.parseField(e.nextOrPreviousAppointment, Dn),
      s.parseField(e.nextOrPreviousTask, Ki),
      s.parseField(e.medianValuation),
      s.parseField(e.manualValuation),
      s.parseField(e.data),
      s.parseField(e.potentialOrderValue),
      s.parseField(e.comments, Os),
      s.parseField(e.attachments, ys),
      s.parseField(e.appointments, Dn),
      s.parseField(e.tasks, Ki),
      s.parseField(e.phaseCategoryLogs, Ds),
      s.parseField(e.phaseLogs, Rs),
      s.parseField(e.statusLogs, Ns),
      s.parseField(e.onSchedule),
      s.parseField(e.daysInactive),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date),
      s.parseField(e.viewedAt, Date),
      s.parseField(e.permissions)
    );
  }
  get viewedAtLabel() {
    if (!this.viewedAt)
      return "Nooit";
    const e = (new Date().getTime() - this.viewedAt.getTime()) / 1e3, i = Math.floor(e / 60), a = Math.floor(i / 60), n = Math.floor(a / 24), l = Math.floor(n / 7), u = Math.floor(l / 4);
    return i < 5 ? "Zojuist" : i < 60 ? `${i} minuten geleden` : a < 24 ? `${a} uur geleden` : n < 14 ? `${n} dagen geleden` : l < 12 ? `${l} weken geleden` : `${u} maanden geleden`;
  }
  get executionId() {
    var e;
    return (e = this.data) == null ? void 0 : e.executionId;
  }
  get hasExecution() {
    return !!this.executionId;
  }
  get canExecutionBeCancelled() {
    return this.hasExecution && this.status.equals(Is.OPEN);
  }
}
const ri = Ps;
class Ms extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O) {
    super();
    o(this, "entrypoint", "lead/appointments");
    o(this, "fromObject", (e) => Ms.fromObject(e));
    this.lead = e, this.id = i, this.startDateTime = a, this.endDateTime = n, this.location = l, this.comment = u, this.type = h, this.customType = c, this.status = p, this.assignedUsers = m, this.source = b, this.sourceId = v, this.createdBy = g, this.createdAt = w, this.updatedAt = O;
  }
  static fromObject(e) {
    return new Ms(
      s.parseField(e.lead, ri),
      s.parseField(e.id, fl),
      s.parseField(e.startDateTime, Date),
      s.parseField(e.endDateTime, Date),
      s.parseField(e.location),
      s.parseField(e.comment),
      s.parseField(e.type, It),
      s.parseField(e.customType),
      s.parseField(e.status, qt),
      s.parseField(e.assignedUsers, ee),
      s.parseField(e.source),
      s.parseField(e.sourceId),
      s.parseField(e.createdBy, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
  get typeLabel() {
    return this.customType !== null ? this.customType : this.type !== null ? this.type.label : null;
  }
  get isToday() {
    const e = new Date();
    return this.startDateTime.getDate() === e.getDate() && this.startDateTime.getMonth() === e.getMonth() && this.startDateTime.getFullYear() === e.getFullYear();
  }
  get isFuture() {
    return this.startDateTime > new Date();
  }
  get isPast() {
    return this.startDateTime < new Date();
  }
}
const Dn = Ms;
let ad = class Aa extends s {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "entrypoint", "brochure/logos");
    o(this, "fromObject", (e) => Aa.fromObject(e));
    this.id = e, this.file = i, this.fileName = a, this.fileSize = n, this.fileType = l, this.url = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromObject(e) {
    return new Aa(
      s.parseField(e.id, Cr),
      s.parseField(e.file),
      s.parseField(e.fileName),
      s.parseField(e.fileSize),
      s.parseField(e.fileType),
      s.parseField(e.url),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}, nd = class ms extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C) {
    super();
    o(this, "entrypoint", "brochure/templates");
    o(this, "fromObject", (e) => ms.fromObject(e));
    this.company = e, this.id = i, this.name = a, this.template = n, this.logo = l, this.nvmLogoVisible = u, this.primaryColor = h, this.primaryTextColor = c, this.secondaryColor = p, this.secondaryTextColor = m, this.photosVisible = b, this.mapsVisible = v, this.active = g, this.createdBy = w, this.createdAt = O, this.updatedAt = C;
  }
  static fromObject(e) {
    return new ms(
      s.parseField(e.company, J),
      s.parseField(e.id, Zt),
      s.parseField(e.name),
      s.parseField(e.template),
      s.parseField(e.logo, ad),
      s.parseField(e.nvmLogoVisible),
      s.parseField(e.primaryColor),
      s.parseField(e.primaryTextColor),
      s.parseField(e.secondaryColor),
      s.parseField(e.secondaryTextColor),
      s.parseField(e.photosVisible),
      s.parseField(e.mapsVisible),
      s.parseField(e.active),
      s.parseField(e.createdBy, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
  static create(e) {
    if (!e.company)
      throw new Error("User must have a company to create a new template");
    return new ms(
      e.company,
      Zt.generate(),
      "",
      "",
      null,
      !0,
      "#01a28d",
      "#ffffff",
      "#01a28d",
      "#ffffff",
      !0,
      !0,
      !0,
      e,
      new Date(),
      new Date()
    );
  }
};
var G;
let ld = (G = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: G.DRAFT, label: "Concept" },
      { value: G.PENDING, label: "In afwachting" },
      { value: G.GENERATING, label: "Wordt gegenereerd" },
      { value: G.SUCCESS, label: "Gegenereerd" },
      { value: G.FAILURE, label: "Mislukt" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return G.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      G.DRAFT,
      G.PENDING,
      G.GENERATING,
      G.SUCCESS,
      G.FAILURE
    ];
  }
}, o(G, "DRAFT", new G("draft")), o(G, "PENDING", new G("pending")), o(G, "GENERATING", new G("generating")), o(G, "SUCCESS", new G("success")), o(G, "FAILURE", new G("failure")), G);
class ya extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g) {
    super();
    o(this, "entrypoint", "brochure/brochures");
    o(this, "fromObject", (e) => ya.fromObject(e));
    this.id = e, this.template = i, this.team = a, this.wonenObjectId = n, this.wonenObjectAddress = l, this.payload = u, this.name = h, this.filename = c, this.rendererId = p, this.rendererStatus = m, this.createdBy = b, this.createdAt = v, this.updatedAt = g;
  }
  static fromObject(e) {
    return new ya(
      s.parseField(e.id, Or),
      s.parseField(e.template, nd),
      s.parseField(e.team, Fe),
      s.parseField(e.wonenObjectId),
      s.parseField(e.wonenObjectAddress),
      s.parseField(e.payload),
      s.parseField(e.name),
      s.parseField(e.filename),
      s.parseField(e.rendererId),
      s.parseField(e.rendererStatus, ld),
      s.parseField(e.createdBy, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Mc extends S {
  constructor(t, e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D) {
    super(), this.companyId = t, this.id = e, this.name = i, this.logoId = a, this.primaryColor = n, this.secondaryColor = l, this.textColor = u, this.linkColor = h, this.buttonColor = c, this.buttonTextColor = p, this.headingFontName = m, this.fontName = b, this.googleTagId = v, this.websiteUrl = g, this.additionalUrls = w, this.active = O, this.createdAt = C, this.updatedAt = D;
  }
  get validationSchema() {
    return f({
      companyId: d().required(),
      id: d().required(),
      name: d().required(),
      logoId: d().nullable(),
      primaryColor: d().nullable(),
      secondaryColor: d().nullable(),
      textColor: d().nullable(),
      linkColor: d().nullable(),
      buttonColor: d().nullable(),
      buttonTextColor: d().nullable(),
      headingFontName: d().nullable(),
      fontName: d().nullable(),
      googleTagId: d().nullable(),
      websiteUrl: d().url().nullable(),
      additionalUrls: f(),
      active: y().nullable(),
      createdAt: U().nullable(),
      updatedAt: U().nullable()
    });
  }
  get requestPath() {
    return "/company/brands";
  }
  get requestMethod() {
    return F.POST;
  }
}
class Lc extends S {
  constructor(t, e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C) {
    super(), this.companyId = t, this.id = e, this.name = i, this.logoId = a, this.primaryColor = n, this.secondaryColor = l, this.textColor = u, this.linkColor = h, this.buttonColor = c, this.buttonTextColor = p, this.headingFontName = m, this.fontName = b, this.googleTagId = v, this.websiteUrl = g, this.additionalUrls = w, this.active = O, this.updatedAt = C;
  }
  get validationSchema() {
    return f({
      companyId: d().required(),
      id: d().required(),
      name: d().required(),
      logoId: d().nullable(),
      primaryColor: d().nullable(),
      secondaryColor: d().nullable(),
      textColor: d().nullable(),
      linkColor: d().nullable(),
      buttonColor: d().nullable(),
      buttonTextColor: d().nullable(),
      headingFontName: d().nullable(),
      fontName: d().nullable(),
      googleTagId: d().nullable(),
      websiteUrl: d().url().nullable(),
      additionalUrls: f(),
      active: y().required(),
      updatedAt: U().nullable()
    });
  }
  get requestPath() {
    return `/company/brands/${this.id.toString()}/change`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
let kc = class extends S {
  constructor(t) {
    super(), this.id = t;
  }
  get validationSchema() {
    return f({ id: Pt.validationSchema.required() });
  }
  get requestPath() {
    return `/company/brands/${this.id.toString()}/can_delete`;
  }
  async parseResponse(t) {
    return t.canDelete;
  }
};
class qc extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromBrand(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: Pt.validationSchema.required() });
  }
  get requestPath() {
    return `/company/brands/${this.id.toString()}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
}
class Uc extends S {
  constructor(t, e, i) {
    super(), this.companyId = t, this.id = e, this.file = i;
  }
  static create() {
    return new this(
      "",
      _a.generate().value,
      null
    );
  }
  get validationSchema() {
    return f({
      companyId: d().required(),
      id: d().required(),
      file: ut().required().test("fileType", "File must be an image", (t) => t === null ? !1 : t.type.startsWith("image/"))
    });
  }
  get requestPath() {
    return "/company/logos";
  }
  get requestMethod() {
    return F.POST;
  }
  async parseRequest(t) {
    const e = new FormData();
    return e.append("companyId", t.companyId), e.append("id", t.id), e.append("file", t.file), e;
  }
  get contentType() {
    return "multipart/form-data";
  }
}
class $c extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromLogo(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: _a.validationSchema.required() });
  }
  get requestPath() {
    return `/company/logos/${this.id.toString()}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
}
class Bc extends S {
  constructor(t) {
    super(), this.id = t;
  }
  get validationSchema() {
    return f({ id: se.validationSchema.required() });
  }
  get requestPath() {
    return `/company/users/${this.id.toString()}/can_delete`;
  }
  async parseResponse(t) {
    return t.canDelete;
  }
}
class Vc extends S {
  constructor(t, e) {
    super(), this.id = t, this.keyflowRole = e;
  }
  get validationSchema() {
    return f({
      id: se.validationSchema.required(),
      keyflowRole: hi.validationSchema.nullable()
    });
  }
  get requestPath() {
    return `/company/users/${this.id.toString()}/change_keyflow_role`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
const Ue = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: Ue.LETTER, label: "Brief" },
      { value: Ue.PROPOSAL, label: "Voorstel" },
      { value: Ue.SALES, label: "Sales Brochure" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return Ue.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      Ue.LETTER,
      Ue.PROPOSAL,
      Ue.SALES
    ];
  }
};
let $t = Ue;
o($t, "LETTER", new Ue("letter")), o($t, "PROPOSAL", new Ue("proposal")), o($t, "SALES", new Ue("sales"));
class Bi extends Xi {
  constructor(t, e) {
    super(), this.width = t, this.height = e;
  }
  toString() {
    return `${this.width}, ${this.height}`;
  }
  equals(t) {
    return t instanceof Bi ? this.width === t.width && this.height === t.height : !1;
  }
  get schemaConfig() {
    return Bi.validationSchema;
  }
  static get validationSchema() {
    return f({
      width: _(),
      height: _()
    });
  }
  static fromObject(t) {
    return new Bi(
      s.parseField(t.width),
      s.parseField(t.height)
    );
  }
}
class Ls extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b) {
    super();
    o(this, "entrypoint", "document/layouts");
    o(this, "fromObject", (e) => Ls.fromObject(e));
    this.id = e, this.type = i, this.name = a, this.templateId = n, this.size = l, this.company = u, this.active = h, this.configurable = c, this.editable = p, this.createdAt = m, this.updatedAt = b;
  }
  static fromObject(e) {
    return new Ls(
      s.parseField(e.id, Ir),
      s.parseField(e.type, $t),
      s.parseField(e.name),
      s.parseField(e.templateId),
      s.parseField(e.size, Bi),
      s.parseField(e.company, J),
      s.parseField(e.active),
      s.parseField(e.configurable),
      s.parseField(e.editable),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class ks extends s {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "entrypoint", "document/logos");
    o(this, "fromObject", (e) => ks.fromObject(e));
    this.company = e, this.id = i, this.fileName = a, this.fileSize = n, this.fileType = l, this.url = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromObject(e) {
    return new ks(
      s.parseField(e.company, J),
      s.parseField(e.id, _t),
      s.parseField(e.fileName),
      s.parseField(e.fileSize),
      s.parseField(e.fileType),
      s.parseField(e.url),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
let od = class Oa extends s {
  constructor(e, i, a, n, l, u, h, c, p, m) {
    super();
    o(this, "entrypoint", "document/templates");
    o(this, "fromObject", (e) => Oa.fromObject(e));
    this.company = e, this.id = i, this.name = a, this.layout = n, this.logo = l, this.payload = u, this.active = h, this.createdBy = c, this.createdAt = p, this.updatedAt = m;
  }
  static fromObject(e) {
    return new Oa(
      s.parseField(e.company, J),
      s.parseField(e.id, Xt),
      s.parseField(e.name),
      s.parseField(e.layout, Ls),
      s.parseField(e.logo, ks),
      s.parseField(e.payload),
      s.parseField(e.active),
      s.parseField(e.createdBy, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
};
const ne = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: ne.DRAFT, label: "Concept" },
      { value: ne.PENDING, label: "In afwachting" },
      { value: ne.GENERATING, label: "Wordt gegenereerd" },
      { value: ne.SUCCESS, label: "Gegenereerd" },
      { value: ne.FAILURE, label: "Mislukt" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return ne.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      ne.DRAFT,
      ne.PENDING,
      ne.GENERATING,
      ne.SUCCESS,
      ne.FAILURE
    ];
  }
};
let Ot = ne;
o(Ot, "DRAFT", new ne("draft")), o(Ot, "PENDING", new ne("pending")), o(Ot, "GENERATING", new ne("generating")), o(Ot, "SUCCESS", new ne("success")), o(Ot, "FAILURE", new ne("failure"));
let Hc = class Ca extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v) {
    super();
    o(this, "entrypoint", "document/documents");
    o(this, "fromObject", (e) => Ca.fromObject(e));
    this.id = e, this.template = i, this.team = a, this.lead = n, this.payload = l, this.name = u, this.filename = h, this.rendererId = c, this.rendererStatus = p, this.createdBy = m, this.createdAt = b, this.updatedAt = v;
  }
  static fromObject(e) {
    return new Ca(
      s.parseField(e.id, Gi),
      s.parseField(e.template, od),
      s.parseField(e.team, Fe),
      s.parseField(e.lead, ri),
      s.parseField(e.payload),
      s.parseField(e.name),
      s.parseField(e.filename),
      s.parseField(e.rendererId),
      s.parseField(e.rendererStatus, Ot),
      s.parseField(e.createdBy, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
};
class ud extends A {
}
class Ia extends s {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "entrypoint", "document/texts");
    o(this, "fromObject", (e) => Ia.fromObject(e));
    this.id = e, this.type = i, this.name = a, this.text = n, this.company = l, this.active = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromObject(e) {
    return new Ia(
      s.parseField(e.id, ud),
      s.parseField(e.type, $t),
      s.parseField(e.name),
      s.parseField(e.text),
      s.parseField(e.company, J),
      s.parseField(e.active),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Gc extends S {
  constructor(t) {
    super(), this.pipelineCategory = t;
  }
  get validationSchema() {
    return f({ pipelineCategory: ie.validationSchema.nullable() });
  }
  get requestPath() {
    return "/lead/leads/count";
  }
  get requestMethod() {
    return F.POST;
  }
  async parseResponse(t) {
    return t == null ? void 0 : t.counts;
  }
}
class dd extends A {
}
class Ta extends s {
  constructor(e, i, a, n) {
    super();
    o(this, "entrypoint", "lead/lead_permissions");
    o(this, "fromObject", (e) => Ta.fromObject(e));
    this.id = e, this.lead = i, this.user = a, this.team = n;
  }
  static fromObject(e) {
    return new Ta(
      s.parseField(e.id, dd),
      s.parseField(e.lead, ri),
      s.parseField(e.user, ee),
      s.parseField(e.team, Fe)
    );
  }
}
class cd extends A {
  constructor(t, e) {
    super(`company=${t.value};status=${e.value}`);
  }
}
class xa extends s {
  constructor(e, i, a, n, l, u) {
    super();
    o(this, "entrypoint", "lead/status_settings");
    o(this, "fromObject", (e) => xa.fromObject(e));
    this.company = e, this.status = i, this.reasonRequired = a, this.nullReasonEnabled = n, this.createdAt = l, this.updatedAt = u;
  }
  get id() {
    return new cd(this.company.id, this.status);
  }
  static fromObject(e) {
    return new xa(
      s.parseField(e.company, J),
      s.parseField(e.status, Is),
      s.parseField(e.reasonRequired),
      s.parseField(e.nullReasonEnabled),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Rn extends A {
}
class en extends A {
}
const j = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: j.TOP, label: "Boven" },
      { value: j.TOP_LEFT, label: "Linksboven" },
      { value: j.TOP_RIGHT, label: "Rechtsboven" },
      { value: j.BOTTOM, label: "Onder" },
      { value: j.BOTTOM_LEFT, label: "Linksonder" },
      { value: j.BOTTOM_RIGHT, label: "Rechtsonder" },
      { value: j.LEFT, label: "Links" },
      { value: j.CENTER, label: "Midden" },
      { value: j.RIGHT, label: "Rechts" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return j.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(j.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      j.TOP,
      j.TOP_LEFT,
      j.TOP_RIGHT,
      j.BOTTOM,
      j.BOTTOM_LEFT,
      j.BOTTOM_RIGHT,
      j.LEFT,
      j.CENTER,
      j.RIGHT
    ];
  }
};
let de = j;
o(de, "TOP", new j("top")), o(de, "TOP_LEFT", new j("top-left")), o(de, "TOP_RIGHT", new j("top-right")), o(de, "BOTTOM", new j("bottom")), o(de, "BOTTOM_LEFT", new j("bottom-left")), o(de, "BOTTOM_RIGHT", new j("bottom-right")), o(de, "LEFT", new j("left")), o(de, "CENTER", new j("center")), o(de, "RIGHT", new j("right"));
const fe = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: fe.ROUND, label: "Rond" },
      { value: fe.SQUARE, label: "Rechthoek" },
      { value: fe.ROUNDED_SQUARE, label: "Vierkant" },
      { value: fe.CORNERED_CIRCLE, label: "Rond met hoek" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return fe.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(fe.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      fe.ROUND,
      fe.SQUARE,
      fe.ROUNDED_SQUARE,
      fe.CORNERED_CIRCLE
    ];
  }
};
let We = fe;
o(We, "ROUND", new fe("round")), o(We, "SQUARE", new fe("square")), o(We, "ROUNDED_SQUARE", new fe("rounded_square")), o(We, "CORNERED_CIRCLE", new fe("cornered_circle"));
const be = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: be.CONTAINS, label: "Bevat" },
      { value: be.EQUALS, label: "Is gelijk aan" },
      { value: be.STARTS_WITH, label: "Begint met" },
      { value: be.ENDS_WITH, label: "Eindigt met" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return be.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(be.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      be.CONTAINS,
      be.EQUALS,
      be.STARTS_WITH,
      be.ENDS_WITH
    ];
  }
};
let kt = be;
o(kt, "CONTAINS", new be("contains")), o(kt, "EQUALS", new be("equals")), o(kt, "STARTS_WITH", new be("starts-with")), o(kt, "ENDS_WITH", new be("ends-with"));
class js extends N {
  constructor(e, i) {
    super();
    o(this, "fromObject", (e) => js.fromObject(e));
    this.type = e, this.value = i;
  }
  static fromObject(e) {
    return new js(
      s.parseField(e.type, kt),
      s.parseField(e.value)
    );
  }
}
const _e = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: _e.EVERYWHERE, label: "Overal" },
      { value: _e.SPECIFIC, label: "Specifieke pagina's" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return _e.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(_e.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      _e.EVERYWHERE,
      _e.SPECIFIC
    ];
  }
};
let Ht = _e;
o(Ht, "EVERYWHERE", new _e("everywhere")), o(Ht, "SPECIFIC", new _e("specific"));
const et = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: et.FLAT, label: "Flat" },
      { value: et.MODERN, label: "Modern" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return et.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(et.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      et.FLAT,
      et.MODERN
    ];
  }
};
let ot = et;
o(ot, "FLAT", new et("flat")), o(ot, "MODERN", new et("modern"));
class Yi extends N {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D, M, $, Z, te, oe, me, Pe) {
    super();
    o(this, "fromObject", (e) => Yi.fromObject(e));
    this.id = e, this.greeting = i, this.color = a, this.balloonColor = n, this.quickOptions = l, this.mobilePosition = u, this.mobileVariant = h, this.mobileType = c, this.mobileChatStyle = p, this.desktopPosition = m, this.desktopVariant = b, this.desktopType = v, this.desktopChatStyle = g, this.beamReopenLabel = w, this.beamDisplayAfterPercentage = O, this.openAfterSeconds = C, this.hintAfterSeconds = D, this.repeatAfterSeconds = M, this.filterMode = $, this.filters = Z, this.showOnFlowPages = te, this.showQuickOptionsInsteadOfGreeting = oe, this.createdAt = me, this.updatedAt = Pe;
  }
  static fromObject(e) {
    return new Yi(
      s.parseField(e.id, en),
      s.parseField(e.greeting),
      s.parseField(e.color),
      s.parseField(e.balloonColor),
      s.parseField(e.quickOptions, tn),
      s.parseField(e.mobilePosition, de),
      s.parseField(e.mobileVariant, We),
      s.parseField(e.mobileType, wi),
      s.parseField(e.mobileChatStyle, ot),
      s.parseField(e.desktopPosition, de),
      s.parseField(e.desktopVariant, We),
      s.parseField(e.desktopType, wi),
      s.parseField(e.desktopChatStyle, ot),
      s.parseField(e.beamReopenLabel),
      s.parseField(e.beamDisplayAfterPercentage),
      s.parseField(e.openAfterSeconds),
      s.parseField(e.hintAfterSeconds),
      s.parseField(e.repeatAfterSeconds),
      s.parseField(e.filterMode, Ht),
      e.filters ? e.filters.map((i) => js.fromObject(i)) : [],
      s.parseField(e.showOnFlowPages),
      s.parseField(e.showQuickOptionsInsteadOfGreeting),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class qs extends N {
  constructor(e, i, a, n, l, u) {
    super();
    o(this, "fromObject", (e) => qs.fromObject(e));
    this.widget = e, this.id = i, this.shortMessage = a, this.message = n, this.englishShortMessage = l, this.englishMessage = u;
  }
  static fromObject(e) {
    return new qs(
      s.parseField(e.widget, Yi),
      s.parseField(e.id, Rn),
      s.parseField(e.shortMessage),
      s.parseField(e.message),
      s.parseField(e.englishShortMessage),
      s.parseField(e.englishMessage)
    );
  }
  getShortMessageForLocale(e) {
    return e === "en" && this.englishShortMessage ? this.englishShortMessage : this.shortMessage;
  }
  getMessageForLocale(e) {
    return e === "en" && this.englishMessage ? this.englishMessage : this.message;
  }
  static get validationSchema() {
    return f({
      id: Rn.validationSchema,
      shortMessage: d().max(255).required(),
      message: d().max(255).required(),
      englishShortMessage: d().max(255).nullable(),
      englishMessage: d().max(255).nullable()
    });
  }
}
const tn = qs;
class Mt extends A {
}
const ge = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: ge.VARIANT1, label: "Variant 1" },
      { value: ge.VARIANT2, label: "Variant 2" },
      { value: ge.VARIANT3, label: "Variant 3" },
      { value: ge.CUSTOM, label: "Eigen afbeelding" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return ge.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(ge.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      ge.VARIANT1,
      ge.VARIANT2,
      ge.VARIANT3,
      ge.CUSTOM
    ];
  }
};
let ft = ge;
o(ft, "VARIANT1", new ge("variant1")), o(ft, "VARIANT2", new ge("variant2")), o(ft, "VARIANT3", new ge("variant3")), o(ft, "CUSTOM", new ge("custom"));
const tt = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: tt.LEAD_GENERATION, label: "Leadgeneratie" },
      { value: tt.SERVICE, label: "Service" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return tt.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(tt.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      tt.LEAD_GENERATION,
      tt.SERVICE
    ];
  }
};
let Gt = tt;
o(Gt, "LEAD_GENERATION", new tt("lead-generation")), o(Gt, "SERVICE", new tt("service"));
const Y = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: Y.SHIMMER, label: "Shimmer" },
      { value: Y.ALLOY, label: "Alloy" },
      { value: Y.ECHO, label: "Echo" },
      { value: Y.FABLE, label: "Fable" },
      { value: Y.ONYX, label: "Onyx" },
      { value: Y.NOVA, label: "Nova" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return Y.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(Y.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      Y.SHIMMER,
      Y.ALLOY,
      Y.ECHO,
      Y.FABLE,
      Y.ONYX,
      Y.NOVA
    ];
  }
};
let Ye = Y;
o(Ye, "SHIMMER", new Y("shimmer")), o(Ye, "ALLOY", new Y("alloy")), o(Ye, "ECHO", new Y("echo")), o(Ye, "FABLE", new Y("fable")), o(Ye, "ONYX", new Y("onyx")), o(Ye, "NOVA", new Y("nova"));
class sn extends A {
}
class rn extends A {
}
const it = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: it.CASUAL, label: "Casual / zakelijk" },
      { value: it.PROFESSIONAL, label: "Professioneel / zakelijk" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return it.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(it.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      it.CASUAL,
      it.PROFESSIONAL
    ];
  }
};
let Wt = it;
o(Wt, "CASUAL", new it("casual")), o(Wt, "PROFESSIONAL", new it("professional"));
const st = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: st.INFORMAL, label: "Jij" },
      { value: st.FORMAL, label: "U" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return st.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(st.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      st.INFORMAL,
      st.FORMAL
    ];
  }
};
let zt = st;
o(zt, "INFORMAL", new st("informal")), o(zt, "FORMAL", new st("formal"));
var P;
let an = (P = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: P.VALUATION, label: "Waardebepaling" },
      { value: P.SALE, label: "Verkoop" },
      { value: P.PURCHASE, label: "Aankoop" },
      { value: P.TAXATION, label: "Taxatie" },
      { value: P.INSURANCE, label: "Assurantie" },
      { value: P.MORTGAGE, label: "Hypotheek" },
      { value: P.SEARCH, label: "Zoekservice" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return P.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(P.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      P.VALUATION,
      P.SALE,
      P.PURCHASE,
      P.TAXATION,
      P.INSURANCE,
      P.MORTGAGE,
      P.SEARCH
    ];
  }
}, o(P, "VALUATION", new P("valuation")), o(P, "SALE", new P("sale")), o(P, "PURCHASE", new P("purchase")), o(P, "TAXATION", new P("taxation")), o(P, "INSURANCE", new P("insurance")), o(P, "MORTGAGE", new P("mortgage")), o(P, "SEARCH", new P("search")), P);
const X = class extends I {
  get label() {
    var t;
    return ((t = X.options.find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return X.validationSchema;
  }
  static get validationSchema() {
    return f();
  }
  static get options() {
    return [
      { value: X.NAME, label: "Naam" },
      { value: X.EMAIL, label: "E-mailadres" },
      { value: X.PHONE_NUMBER, label: "Telefoonnummer" },
      { value: X.POSTAL_CODE, label: "Postcode" },
      { value: X.HOUSE_NUMBER, label: "Huisnummer" }
    ];
  }
  static get starterOptions() {
    return [
      { value: X.NAME, label: "Naam" },
      { value: X.EMAIL, label: "E-mailadres" }
    ];
  }
  static get values() {
    return [
      X.NAME,
      X.EMAIL,
      X.PHONE_NUMBER,
      X.POSTAL_CODE,
      X.HOUSE_NUMBER
    ];
  }
};
let Ge = X;
o(Ge, "NAME", new X("name")), o(Ge, "EMAIL", new X("email")), o(Ge, "PHONE_NUMBER", new X("phone-number")), o(Ge, "POSTAL_CODE", new X("postal-code")), o(Ge, "HOUSE_NUMBER", new X("house-number"));
const xe = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: xe.PESSIMISTIC, label: "Pessimistisch" },
      { value: xe.CONSERVATIVE, label: "Conservatief" },
      { value: xe.OPTIMISTIC, label: "Optimistisch" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return xe.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(xe.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      xe.PESSIMISTIC,
      xe.CONSERVATIVE,
      xe.OPTIMISTIC
    ];
  }
};
let Dt = xe;
o(Dt, "PESSIMISTIC", new xe("pessimistic")), o(Dt, "CONSERVATIVE", new xe("conservative")), o(Dt, "OPTIMISTIC", new xe("optimistic"));
const rt = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: rt.ICON, label: "Icoon" },
      { value: rt.FLOATING_BEAM, label: "Zwevende balk" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return rt.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(rt.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      rt.ICON,
      rt.FLOATING_BEAM
    ];
  }
};
let Pi = rt;
o(Pi, "ICON", new rt("icon")), o(Pi, "FLOATING_BEAM", new rt("floating-beam"));
const wi = Pi, Q = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: Q.FULL_NAME, label: "Volledige naam" },
      { value: Q.FIRST_NAME, label: "Voornaam" },
      { value: Q.LAST_NAME, label: "Achternaam" },
      { value: Q.PHONE_NUMBER, label: "Telefoonnummer" },
      { value: Q.MOBILE_NUMBER, label: "Mobiel nummer" },
      { value: Q.EMAIL_ADDRESS, label: "E-mailadres" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return Q.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(Q.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      Q.FULL_NAME,
      Q.FIRST_NAME,
      Q.LAST_NAME,
      Q.PHONE_NUMBER,
      Q.MOBILE_NUMBER,
      Q.EMAIL_ADDRESS
    ];
  }
};
let ye = Q;
o(ye, "FULL_NAME", new Q("Full Name")), o(ye, "FIRST_NAME", new Q("First Name")), o(ye, "LAST_NAME", new Q("Last Name")), o(ye, "PHONE_NUMBER", new Q("Phone Number")), o(ye, "MOBILE_NUMBER", new Q("Mobile Number")), o(ye, "EMAIL_ADDRESS", new Q("Email Address"));
class Wc extends S {
  constructor(t, e, i, a = [], n = null, l = null, u = null, h = null, c = null, p = null, m = null, b = [], v = null, g = null, w = null, O = null, C = null, D = null, M = null, $ = null, Z = null, te = null, oe = null, me = [], Pe = null, B = [], Ae = null, Je = [], Ze = null, Oi = null, Ci = null, Ii = null, Ti = null, xi = [], Rr = null, Nr = null, Pr = null, Mr = null, Lr = null, kr = null, jr = null, qr = null, Ur = null, $r = null, Br = null, Vr = null, Hr = [], Gr = null, Wr = null, zr = null, Kr = null, Yr = null, Qr = null, Jr = null, Zr = null, Xr = null, _r = null, ea = null, ta = null, ia = null, sa = null, ra = [], aa = null, na = null, la = null) {
    super(), this.brandId = t, this.id = e, this.name = i, this.roles = a, this.avatarVariant = n, this.avatar = l, this.voice = u, this.createdById = h, this.featuresId = c, this.featureWithoutBranding = p, this.featureAppraisalEnabled = m, this.featureAppraisalRequiredFields = b, this.featureAppraisalEstimateOffsetType = v, this.featureWozEnabled = g, this.featureEnergyLabelEnabled = w, this.featureFundaEnabled = O, this.featureAreaInfoEnabled = C, this.featurePostalCodeEnabled = D, this.featureStreetviewEnabled = M, this.featureEmailEnabled = $, this.featureSmsEnabled = Z, this.featureNearestOfficeEnabled = te, this.featureHypotheekMaandlastenEnabled = oe, this.featureHypotheekMaandlastenRequiredFields = me, this.featureMaximumMortgageEnabled = Pe, this.featureMaximumMortgageRequiredFields = B, this.featureRequestContactDataEnabled = Ae, this.featureRequiredContactDataFields = Je, this.behaviorId = Ze, this.behaviorPersonality = Oi, this.behaviorFormality = Ci, this.behaviorAnswerLength = Ii, this.behaviorAllowEmoticons = Ti, this.behaviorGoals = xi, this.behaviorContext = Rr, this.behaviorContextEnabled = Nr, this.behaviorDocumentsEnabled = Pr, this.behaviorFaqsEnabled = Mr, this.behaviorWebsiteEnabled = Lr, this.behaviorCustomInstruction = kr, this.behaviorCustomInstructionEnabled = jr, this.behaviorEnglishSupportEnabled = qr, this.widgetId = Ur, this.widgetGreeting = $r, this.widgetColor = Br, this.widgetBalloonColor = Vr, this.widgetQuickOptions = Hr, this.widgetMobilePosition = Gr, this.widgetMobileVariant = Wr, this.widgetMobileType = zr, this.widgetMobileChatStyle = Kr, this.widgetDesktopPosition = Yr, this.widgetDesktopVariant = Qr, this.widgetDesktopType = Jr, this.widgetDesktopChatStyle = Zr, this.widgetBeamReopenLabel = Xr, this.widgetBeamDisplayAfterPercentage = _r, this.widgetOpenAfterSeconds = ea, this.widgetHintAfterSeconds = ta, this.widgetRepeatAfterSeconds = ia, this.widgetFilterMode = sa, this.widgetFilters = ra, this.widgetShowOnFlowPages = aa, this.widgetShowQuickOptionsInsteadOfGreeting = na, this.active = la;
  }
  static create(t) {
    return new this(
      t.brandId,
      t.id,
      t.name,
      t.roles ?? [],
      t.avatarVariant ?? null,
      t.avatar ?? null,
      t.voice ?? null,
      t.createdById ?? null,
      t.featuresId ?? null,
      t.featureWithoutBranding ?? null,
      t.featureAppraisalEnabled ?? null,
      t.featureAppraisalRequiredFields ?? [],
      t.featureAppraisalEstimateOffsetType ?? null,
      t.featureWozEnabled ?? null,
      t.featureEnergyLabelEnabled ?? null,
      t.featureFundaEnabled ?? null,
      t.featureAreaInfoEnabled ?? null,
      t.featurePostalCodeEnabled ?? null,
      t.featureStreetviewEnabled ?? null,
      t.featureEmailEnabled ?? null,
      t.featureSmsEnabled ?? null,
      t.featureNearestOfficeEnabled ?? null,
      t.featureHypotheekMaandlastenEnabled ?? null,
      t.featureHypotheekMaandlastenRequiredFields ?? [],
      t.featureMaximumMortgageEnabled ?? null,
      t.featureMaximumMortgageRequiredFields ?? [],
      t.featureRequestContactDataEnabled ?? null,
      t.featureRequiredContactDataFields ?? [Ge.NAME, Ge.EMAIL],
      t.behaviorId ?? null,
      t.behaviorPersonality ?? null,
      t.behaviorFormality ?? null,
      t.behaviorAnswerLength ?? null,
      t.behaviorAllowEmoticons ?? null,
      t.behaviorGoals ?? [],
      t.behaviorContext ?? null,
      t.behaviorContextEnabled ?? null,
      t.behaviorDocumentsEnabled ?? null,
      t.behaviorFaqsEnabled ?? null,
      t.behaviorWebsiteEnabled ?? null,
      t.behaviorCustomInstruction ?? null,
      t.behaviorCustomInstructionEnabled ?? null,
      t.behaviorEnglishSupportEnabled ?? null,
      t.widgetId ?? null,
      t.widgetGreeting ?? null,
      t.widgetColor ?? null,
      t.widgetBalloonColor ?? null,
      t.widgetQuickOptions ?? [],
      t.widgetMobilePosition ?? null,
      t.widgetMobileVariant ?? null,
      t.widgetMobileType ?? null,
      t.widgetMobileChatStyle ?? null,
      t.widgetDesktopPosition ?? null,
      t.widgetDesktopVariant ?? null,
      t.widgetDesktopType ?? null,
      t.widgetDesktopChatStyle ?? null,
      t.widgetBeamReopenLabel ?? null,
      t.widgetBeamDisplayAfterPercentage ?? null,
      t.widgetOpenAfterSeconds ?? null,
      t.widgetHintAfterSeconds ?? null,
      t.widgetRepeatAfterSeconds ?? null,
      t.widgetFilterMode ?? null,
      t.widgetFilters ?? [],
      t.widgetShowOnFlowPages ?? null,
      t.widgetShowQuickOptionsInsteadOfGreeting ?? null,
      t.active ?? null
    );
  }
  static fromAssistent(t) {
    var e, i;
    return new this(
      t.brand.id,
      t.id,
      t.name,
      t.roles,
      t.avatarVariant,
      ((e = t.avatar) == null ? void 0 : e.file) ?? null,
      t.voice,
      ((i = t.createdBy) == null ? void 0 : i.id) ?? null,
      t.features.id,
      t.features.withoutBranding,
      t.features.appraisalEnabled,
      t.features.appraisalRequiredFields,
      t.features.appraisalEstimateOffsetType,
      t.features.wozEnabled,
      t.features.energyLabelEnabled,
      t.features.fundaEnabled,
      t.features.areaInfoEnabled,
      t.features.postalCodeEnabled,
      t.features.streetviewEnabled,
      t.features.emailEnabled,
      t.features.smsEnabled,
      t.features.nearestOfficeEnabled,
      t.features.hypotheekMaandlastenEnabled,
      t.features.hypotheekMaandlastenRequiredFields,
      t.features.maximumMortgageEnabled,
      t.features.maximumMortgageRequiredFields,
      t.features.requestContactDataEnabled,
      t.features.requiredContactDataFields,
      t.behavior.id,
      t.behavior.personality,
      t.behavior.formality,
      t.behavior.answerLength,
      t.behavior.allowEmoticons,
      t.behavior.goals,
      t.behavior.context,
      t.behavior.contextEnabled,
      t.behavior.documentsEnabled,
      t.behavior.faqsEnabled,
      t.behavior.websiteEnabled,
      t.behavior.customInstruction,
      t.behavior.customInstructionEnabled,
      t.behavior.englishSupportEnabled,
      t.widget.id,
      t.widget.greeting,
      t.widget.color,
      t.widget.balloonColor,
      t.widget.quickOptions,
      t.widget.mobilePosition,
      t.widget.mobileVariant,
      t.widget.mobileType,
      t.widget.mobileChatStyle,
      t.widget.desktopPosition,
      t.widget.desktopVariant,
      t.widget.desktopType,
      t.widget.desktopChatStyle,
      t.widget.beamReopenLabel,
      t.widget.beamDisplayAfterPercentage,
      t.widget.openAfterSeconds,
      t.widget.hintAfterSeconds,
      t.widget.repeatAfterSeconds,
      t.widget.filterMode,
      t.widget.filters,
      t.widget.showOnFlowPages,
      t.widget.showQuickOptionsInsteadOfGreeting,
      t.active
    );
  }
  get validationSchema() {
    return f({
      brandId: Pt.validationSchema.required(),
      id: Mt.validationSchema.required(),
      name: d().required(),
      roles: R().of(Gt.validationSchema).nullable(),
      avatarVariant: ft.validationSchema.nullable(),
      avatar: ut().nullable(),
      voice: Ye.validationSchema.nullable(),
      createdById: se.validationSchema.nullable(),
      featuresId: sn.validationSchema.nullable(),
      featureWithoutBranding: y().nullable(),
      featureAppraisalEnabled: y().nullable(),
      featureAppraisalRequiredFields: R().of(ye.validationSchema).nullable(),
      featureAppraisalEstimateOffsetType: Dt.validationSchema.nullable(),
      featureWozEnabled: y().nullable(),
      featureEnergyLabelEnabled: y().nullable(),
      featureFundaEnabled: y().nullable(),
      featureAreaInfoEnabled: y().nullable(),
      featurePostalCodeEnabled: y().nullable(),
      featureStreetviewEnabled: y().nullable(),
      featureEmailEnabled: y().nullable(),
      featureSmsEnabled: y().nullable(),
      featureNearestOfficeEnabled: y().nullable(),
      featureHypotheekMaandlastenEnabled: y().nullable(),
      featureHypotheekMaandlastenRequiredFields: R().of(ye.validationSchema).nullable(),
      featureMaximumMortgageEnabled: y().nullable(),
      featureMaximumMortgageRequiredFields: R().of(ye.validationSchema).nullable(),
      featureRequestContactDataEnabled: y().nullable(),
      featureRequiredContactDataFields: R().of(Ge.validationSchema).nullable(),
      behaviorId: rn.validationSchema.nullable(),
      behaviorPersonality: Wt.validationSchema.nullable(),
      behaviorFormality: zt.validationSchema.nullable(),
      behaviorAllowEmoticons: y().nullable(),
      behaviorGoals: R().of(an.validationSchema).nullable(),
      behaviorContext: d().nullable(),
      behaviorContextEnabled: y().nullable(),
      behaviorDocuments: R().of(ut()).nullable(),
      behaviorDocumentsEnabled: y().nullable(),
      behaviorFaqs: R().of(d()).nullable(),
      behaviorFaqsEnabled: y().nullable(),
      behaviorWebsiteEnabled: y().nullable(),
      behaviorCustomInstruction: d().nullable(),
      behaviorCustomInstructionEnabled: y().nullable(),
      behaviorEnglishSupportEnabled: y().nullable(),
      widgetId: en.validationSchema.nullable(),
      widgetGreeting: d().nullable(),
      widgetColor: d().nullable(),
      widgetBalloonColor: d().nullable(),
      widgetQuickOptions: R().of(tn.validationSchema).nullable(),
      widgetMobilePosition: de.validationSchema.nullable(),
      widgetMobileVariant: We.validationSchema.nullable(),
      widgetMobileType: wi.validationSchema.nullable(),
      widgetMobileChatStyle: ot.validationSchema.nullable(),
      widgetDesktopPosition: de.validationSchema.nullable(),
      widgetDesktopVariant: We.validationSchema.nullable(),
      widgetDesktopType: wi.validationSchema.nullable(),
      widgetDesktopChatStyle: ot.validationSchema.nullable(),
      widgetBeamReopenLabel: d().nullable(),
      widgetBeamDisplayAfterPercentage: _().nullable(),
      widgetOpenAfterSeconds: _().nullable(),
      widgetHintAfterSeconds: _().nullable(),
      widgetRepeatAfterSeconds: _().nullable(),
      widgetFilterMode: Ht.validationSchema.nullable(),
      widgetFilters: R().of(f()).nullable(),
      widgetShowOnFlowPages: y().nullable(),
      widgetShowQuickOptionsInsteadOfGreeting: y().nullable(),
      active: y().nullable()
    }).strict(!0);
  }
  get requestPath() {
    return "/ai/assistent/assistents";
  }
  get requestMethod() {
    return F.POST;
  }
  async parseRequest(t) {
    const e = new FormData();
    return e.append("brandId", t.brandId), e.append("id", t.id), e.append("name", t.name), t.roles && t.roles.forEach((i, a) => {
      e.append(`roles[${a}]`, i);
    }), t.avatarVariant && e.append("avatarVariant", t.avatarVariant), t.avatar && e.append("avatar", t.avatar), t.createdById && e.append("createdById", t.createdById), t.voice && e.append("voice", t.voice), t.featuresId && e.append("featuresId", t.featuresId), t.featureWithoutBranding && e.append("featureWithoutBranding", t.featureWithoutBranding), t.featureAppraisalEnabled && e.append("featureAppraisalEnabled", t.featureAppraisalEnabled), t.featureAppraisalRequiredFields && t.featureAppraisalRequiredFields.forEach((i, a) => {
      e.append(`featureAppraisalRequiredFields[${a}]`, i.value);
    }), t.featureAppraisalEstimateOffsetType && e.append("featureAppraisalEstimateOffsetType", t.featureAppraisalEstimateOffsetType), t.featureWozEnabled && e.append("featureWozEnabled", t.featureWozEnabled), t.featureEnergyLabelEnabled && e.append("featureEnergyLabelEnabled", t.featureEnergyLabelEnabled), t.featureFundaEnabled && e.append("featureFundaEnabled", t.featureFundaEnabled), t.featureAreaInfoEnabled && e.append("featureAreaInfoEnabled", t.featureAreaInfoEnabled), t.featurePostalCodeEnabled && e.append("featurePostalCodeEnabled", t.featurePostalCodeEnabled), t.featureStreetviewEnabled && e.append("featureStreetviewEnabled", t.featureStreetviewEnabled), t.featureEmailEnabled && e.append("featureEmailEnabled", t.featureEmailEnabled), t.featureSmsEnabled && e.append("featureSmsEnabled", t.featureSmsEnabled), t.featureNearestOfficeEnabled && e.append("featureNearestOfficeEnabled", t.featureNearestOfficeEnabled), t.featureHypotheekMaandlastenEnabled && e.append("featureHypotheekMaandlastenEnabled", t.featureHypotheekMaandlastenEnabled), t.featureHypotheekMaandlastenRequiredFields && t.featureHypotheekMaandlastenRequiredFields.forEach((i, a) => {
      e.append(`featureHypotheekMaandlastenRequiredFields[${a}]`, i.value);
    }), t.featureMaximumMortgageEnabled && e.append("featureMaximumMortgageEnabled", t.featureMaximumMortgageEnabled), t.featureMaximumMortgageRequiredFields && t.featureMaximumMortgageRequiredFields.forEach((i, a) => {
      e.append(`featureMaximumMortgageRequiredFields[${a}]`, i.value);
    }), t.featureRequestContactDataEnabled !== null && e.append("featureRequestContactDataEnabled", t.featureRequestContactDataEnabled), t.featureRequiredContactDataFields && t.featureRequiredContactDataFields.forEach((i, a) => {
      e.append(`featureRequiredContactDataFields[${a}]`, i);
    }), t.behaviorId && e.append("behaviorId", t.behaviorId), t.behaviorPersonality && e.append("behaviorPersonality", t.behaviorPersonality), t.behaviorFormality && e.append("behaviorFormality", t.behaviorFormality), t.behaviorAnswerLength && e.append("behaviorAnswerLength", t.behaviorAnswerLength), t.behaviorAllowEmoticons && e.append("behaviorAllowEmoticons", t.behaviorAllowEmoticons), t.behaviorGoals && t.behaviorGoals.forEach((i, a) => {
      e.append(`behaviorGoals[${a}]`, i);
    }), t.behaviorContext && e.append("behaviorContext", t.behaviorContext), t.behaviorContextEnabled && e.append("behaviorContextEnabled", t.behaviorContextEnabled), t.behaviorDocuments && t.behaviorDocuments.forEach((i, a) => {
      e.append(`behaviorDocuments[${a}]`, i);
    }), t.behaviorDocumentsEnabled && e.append("behaviorDocumentsEnabled", t.behaviorDocumentsEnabled), t.behaviorFaqs && t.behaviorFaqs.forEach((i, a) => {
      e.append(`behaviorFaqs[${a}]`, i);
    }), t.behaviorFaqsEnabled && e.append("behaviorFaqsEnabled", t.behaviorFaqsEnabled), t.behaviorWebsiteEnabled && e.append("behaviorWebsiteEnabled", t.behaviorWebsiteEnabled), t.behaviorCustomInstruction && e.append("behaviorCustomInstruction", t.behaviorCustomInstruction), t.behaviorCustomInstructionEnabled && e.append("behaviorCustomInstructionEnabled", t.behaviorCustomInstructionEnabled), t.behaviorEnglishSupportEnabled && e.append("behaviorEnglishSupportEnabled", t.behaviorEnglishSupportEnabled), t.widgetId && e.append("widgetId", t.widgetId), t.widgetGreeting && e.append("widgetGreeting", t.widgetGreeting), t.widgetColor && e.append("widgetColor", t.widgetColor), t.widgetBalloonColor && e.append("widgetBalloonColor", t.widgetBalloonColor), t.widgetQuickOptions && t.widgetQuickOptions.forEach((i, a) => {
      e.append(`widgetQuickOptions[${a}]`, i);
    }), t.widgetMobilePosition && e.append("widgetMobilePosition", t.widgetMobilePosition), t.widgetMobileVariant && e.append("widgetMobileVariant", t.widgetMobileVariant), t.widgetMobileType && e.append("widgetMobileType", t.widgetMobileType), t.widgetMobileChatStyle && e.append("widgetMobileChatStyle", t.widgetMobileChatStyle), t.widgetDesktopPosition && e.append("widgetDesktopPosition", t.widgetDesktopPosition), t.widgetDesktopVariant && e.append("widgetDesktopVariant", t.widgetDesktopVariant), t.widgetDesktopType && e.append("widgetDesktopType", t.widgetDesktopType), t.widgetDesktopChatStyle && e.append("widgetDesktopChatStyle", t.widgetDesktopChatStyle), t.widgetBeamReopenLabel && e.append("widgetBeamReopenLabel", t.widgetBeamReopenLabel), t.widgetBeamReopenLabel && e.append("widgetBeamDisplayAfterPercentage", t.widgetBeamDisplayAfterPercentage), t.widgetOpenAfterSeconds && e.append("widgetOpenAfterSeconds", t.widgetOpenAfterSeconds), t.widgetHintAfterSeconds && e.append("widgetHintAfterSeconds", t.widgetHintAfterSeconds), t.widgetRepeatAfterSeconds && e.append("widgetRepeatAfterSeconds", t.widgetRepeatAfterSeconds), t.widgetFilterMode && e.append("widgetFilterMode", t.widgetFilterMode), t.widgetFilters && t.widgetFilters.forEach((i, a) => {
      e.append(`widgetFilters[${a}][type]`, i.type.value), e.append(`widgetFilters[${a}][value]`, i.value);
    }), t.widgetShowOnFlowPages && e.append("widgetShowOnFlowPages", t.widgetShowOnFlowPages), t.widgetShowQuickOptionsInsteadOfGreeting && e.append("widgetShowQuickOptionsInsteadOfGreeting", t.widgetShowQuickOptionsInsteadOfGreeting), t.active && e.append("active", t.active), e;
  }
  get contentType() {
    return "multipart/form-data";
  }
}
class gl extends A {
}
const $e = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: $e.BALANCED, label: "Gebalanceerd" },
      { value: $e.QUICK_AND_SHORT, label: "Snel & kort" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get tooltip() {
    var t;
    return ((t = [
      { value: $e.BALANCED, tooltip: "Standaard, passend bij de vraag" },
      { value: $e.QUICK_AND_SHORT, tooltip: "Minimaal, maar duidelijk" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.tooltip) ?? "";
  }
  get schemaConfig() {
    return $e.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf($e.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      $e.BALANCED,
      $e.QUICK_AND_SHORT
    ];
  }
};
let pi = $e;
o(pi, "QUICK_AND_SHORT", new $e("quick_and_short")), o(pi, "BALANCED", new $e("balanced"));
class zc extends S {
  constructor(t, e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D, M, $, Z, te, oe, me, Pe, B, Ae, Je, Ze, Oi, Ci, Ii, Ti, xi, Rr, Nr, Pr, Mr, Lr, kr, jr, qr, Ur, $r, Br, Vr, Hr, Gr, Wr, zr, Kr, Yr, Qr, Jr, Zr, Xr, _r, ea, ta, ia, sa, ra, aa, na, la, Ol, Cl, Il) {
    super(), this.id = t, this.name = e, this.roles = i, this.avatarVariant = a, this.avatar = n, this.voice = l, this.featuresId = u, this.featureWithoutBranding = h, this.featureAppraisalEnabled = c, this.featureAppraisalRequiredFields = p, this.featureAppraisalEstimateOffsetType = m, this.featureWozEnabled = b, this.featureEnergyLabelEnabled = v, this.featureFundaEnabled = g, this.featureAreaInfoEnabled = w, this.featurePostalCodeEnabled = O, this.featureStreetviewEnabled = C, this.featureEmailEnabled = D, this.featureSmsEnabled = M, this.featureNearestOfficeEnabled = $, this.featureHypotheekMaandlastenEnabled = Z, this.featureHypotheekMaandlastenRequiredFields = te, this.featureMaximumMortgageEnabled = oe, this.featureMaximumMortgageRequiredFields = me, this.featureRequestContactDataEnabled = Pe, this.featureRequiredContactDataFields = B, this.behaviorId = Ae, this.behaviorPersonality = Je, this.behaviorFormality = Ze, this.behaviorAnswerLength = Oi, this.behaviorAllowEmoticons = Ci, this.behaviorGoals = Ii, this.behaviorContext = Ti, this.behaviorContextEnabled = xi, this.behaviorDocuments = Rr, this.behaviorDocumentsEnabled = Nr, this.behaviorFaqs = Pr, this.behaviorFaqsEnabled = Mr, this.behaviorWebsiteEnabled = Lr, this.behaviorCustomInstruction = kr, this.behaviorCustomInstructionEnabled = jr, this.behaviorEnglishSupportEnabled = qr, this.emailRoutingId = Ur, this.emailRoutingFromName = $r, this.emailRoutingForwardEmailAddress = Br, this.widgetId = Vr, this.widgetGreeting = Hr, this.widgetColor = Gr, this.widgetBalloonColor = Wr, this.widgetQuickOptions = zr, this.widgetMobilePosition = Kr, this.widgetMobileVariant = Yr, this.widgetMobileType = Qr, this.widgetMobileChatStyle = Jr, this.widgetDesktopPosition = Zr, this.widgetDesktopVariant = Xr, this.widgetDesktopType = _r, this.widgetDesktopChatStyle = ea, this.widgetBeamReopenLabel = ta, this.widgetBeamDisplayAfterPercentage = ia, this.widgetOpenAfterSeconds = sa, this.widgetHintAfterSeconds = ra, this.widgetRepeatAfterSeconds = aa, this.widgetFilterMode = na, this.widgetFilters = la, this.widgetShowOnFlowPages = Ol, this.widgetShowQuickOptionsInsteadOfGreeting = Cl, this.active = Il;
  }
  static fromAssistent(t) {
    var e, i, a, n;
    return new this(
      t.id,
      t.name,
      t.roles,
      t.avatarVariant,
      ((e = t.avatar) == null ? void 0 : e.file) ?? null,
      t.voice,
      t.features.id,
      t.features.withoutBranding,
      t.features.appraisalEnabled,
      t.features.appraisalRequiredFields,
      t.features.appraisalEstimateOffsetType,
      t.features.wozEnabled,
      t.features.energyLabelEnabled,
      t.features.fundaEnabled,
      t.features.areaInfoEnabled,
      t.features.postalCodeEnabled,
      t.features.streetviewEnabled,
      t.features.emailEnabled,
      t.features.smsEnabled,
      t.features.nearestOfficeEnabled,
      t.features.hypotheekMaandlastenEnabled,
      t.features.hypotheekMaandlastenRequiredFields,
      t.features.maximumMortgageEnabled,
      t.features.maximumMortgageRequiredFields,
      t.features.requestContactDataEnabled,
      t.features.requiredContactDataFields,
      t.behavior.id,
      t.behavior.personality,
      t.behavior.formality,
      t.behavior.answerLength,
      t.behavior.allowEmoticons,
      t.behavior.goals,
      t.behavior.context,
      t.behavior.contextEnabled,
      t.behavior.documents,
      t.behavior.documentsEnabled,
      t.behavior.faqs,
      t.behavior.faqsEnabled,
      t.behavior.websiteEnabled,
      t.behavior.customInstruction,
      t.behavior.customInstructionEnabled,
      t.behavior.englishSupportEnabled,
      ((i = t.emailRouting) == null ? void 0 : i.id) ?? null,
      ((a = t.emailRouting) == null ? void 0 : a.fromName) ?? null,
      ((n = t.emailRouting) == null ? void 0 : n.forwardEmailAddress) ?? null,
      t.widget.id,
      t.widget.greeting,
      t.widget.color,
      t.widget.balloonColor,
      t.widget.quickOptions,
      t.widget.mobilePosition,
      t.widget.mobileVariant,
      t.widget.mobileType,
      t.widget.mobileChatStyle,
      t.widget.desktopPosition,
      t.widget.desktopVariant,
      t.widget.desktopType,
      t.widget.desktopChatStyle,
      t.widget.beamReopenLabel,
      t.widget.beamDisplayAfterPercentage,
      t.widget.openAfterSeconds,
      t.widget.hintAfterSeconds,
      t.widget.repeatAfterSeconds,
      t.widget.filterMode,
      t.widget.filters,
      t.widget.showOnFlowPages,
      t.widget.showQuickOptionsInsteadOfGreeting,
      t.active
    );
  }
  get validationSchema() {
    return f({
      id: Mt.validationSchema.required(),
      name: d().required(),
      roles: R().of(Gt.validationSchema).nullable(),
      avatarVariant: ft.validationSchema.nullable(),
      avatar: ut().nullable(),
      voice: Ye.validationSchema.nullable(),
      featuresId: sn.validationSchema.nullable(),
      featureWithoutBranding: y().nullable(),
      featureAppraisalEnabled: y().nullable(),
      featureAppraisalRequiredFields: R().of(ye.validationSchema).required(),
      featureAppraisalEstimateOffsetType: Dt.validationSchema.nullable(),
      featureWozEnabled: y().nullable(),
      featureEnergyLabelEnabled: y().nullable(),
      featureFundaEnabled: y().nullable(),
      featureAreaInfoEnabled: y().nullable(),
      featurePostalCodeEnabled: y().nullable(),
      featureStreetviewEnabled: y().nullable(),
      featureEmailEnabled: y().nullable(),
      featureSmsEnabled: y().nullable(),
      featureNearestOfficeEnabled: y().nullable(),
      featureHypotheekMaandlastenEnabled: y().nullable(),
      featureHypotheekMaandlastenRequiredFields: R().of(ye.validationSchema).required(),
      featureMaximumMortgageEnabled: y().nullable(),
      featureMaximumMortgageRequiredFields: R().of(ye.validationSchema).required(),
      featureRequestContactDataEnabled: y().nullable(),
      featureRequiredContactDataFields: R().of(Ge.validationSchema).min(1).nullable(),
      behaviorId: rn.validationSchema.nullable(),
      behaviorPersonality: Wt.validationSchema.nullable(),
      behaviorFormality: zt.validationSchema.nullable(),
      behaviorAnswerLength: pi.validationSchema.nullable(),
      behaviorAllowEmoticons: y().nullable(),
      behaviorGoals: R().of(an.validationSchema).nullable(),
      behaviorContext: d().nullable(),
      behaviorContextEnabled: y().nullable(),
      behaviorDocuments: R().of(ut()).nullable(),
      behaviorDocumentsEnabled: y().nullable(),
      behaviorFaqs: R().of(ut()).nullable(),
      behaviorFaqsEnabled: y().nullable(),
      behaviorWebsiteEnabled: y().nullable(),
      behaviorCustomInstruction: d().nullable(),
      behaviorCustomInstructionEnabled: y().nullable(),
      behaviorEnglishSupportEnabled: y().nullable(),
      emailRoutingId: gl.validationSchema.nullable(),
      emailRoutingFromName: d().nullable(),
      emailRoutingForwardEmailAddress: d().nullable(),
      widgetId: en.validationSchema.nullable(),
      widgetGreeting: d().nullable(),
      widgetColor: d().nullable(),
      widgetBalloonColor: d().nullable(),
      widgetQuickOptions: R().of(tn.validationSchema).nullable(),
      widgetMobilePosition: de.validationSchema.nullable(),
      widgetMobileVariant: We.validationSchema.nullable(),
      widgetMobileType: wi.validationSchema.nullable(),
      widgetMobileChatStyle: ot.validationSchema.nullable(),
      widgetDesktopPosition: de.validationSchema.nullable(),
      widgetDesktopVariant: We.validationSchema.nullable(),
      widgetDesktopType: wi.validationSchema.nullable(),
      widgetDesktopChatStyle: ot.validationSchema.nullable(),
      widgetBeamReopenLabel: d().nullable(),
      widgetBeamDisplayAfterPercentage: _().nullable(),
      widgetOpenAfterSeconds: _().nullable(),
      widgetHintAfterSeconds: _().nullable(),
      widgetRepeatAfterSeconds: _().nullable(),
      widgetFilterMode: Ht.validationSchema.nullable(),
      widgetFilters: R().of(f()).nullable(),
      widgetShowOnFlowPages: y().nullable(),
      widgetShowQuickOptionsInsteadOfGreeting: y().nullable(),
      active: y().nullable()
    }).strict(!0);
  }
  get requestPath() {
    return `/ai/assistent/assistents/${this.id.toString()}/change`;
  }
  get requestMethod() {
    return F.POST;
  }
  async parseRequest(t) {
    const e = new FormData();
    return e.append("id", t.id), e.append("name", t.name), t.roles && t.roles.forEach((i, a) => {
      e.append(`roles[${a}]`, i);
    }), t.avatarVariant && e.append("avatarVariant", t.avatarVariant), t.avatar && e.append("avatar", t.avatar), t.voice && e.append("voice", t.voice), t.featuresId && e.append("featuresId", t.featuresId), t.featureWithoutBranding !== null && e.append("featureWithoutBranding", t.featureWithoutBranding), t.featureAppraisalEnabled !== null && e.append("featureAppraisalEnabled", t.featureAppraisalEnabled), t.featureAppraisalRequiredFields && t.featureAppraisalRequiredFields.forEach((i, a) => {
      e.append(`featureAppraisalRequiredFields[${a}]`, i.value);
    }), t.featureAppraisalEstimateOffsetType && e.append("featureAppraisalEstimateOffsetType", t.featureAppraisalEstimateOffsetType), t.featureWozEnabled !== null && e.append("featureWozEnabled", t.featureWozEnabled), t.featureEnergyLabelEnabled !== null && e.append("featureEnergyLabelEnabled", t.featureEnergyLabelEnabled), t.featureFundaEnabled !== null && e.append("featureFundaEnabled", t.featureFundaEnabled), t.featureAreaInfoEnabled !== null && e.append("featureAreaInfoEnabled", t.featureAreaInfoEnabled), t.featurePostalCodeEnabled !== null && e.append("featurePostalCodeEnabled", t.featurePostalCodeEnabled), t.featureStreetviewEnabled !== null && e.append("featureStreetviewEnabled", t.featureStreetviewEnabled), t.featureEmailEnabled !== null && e.append("featureEmailEnabled", t.featureEmailEnabled), t.featureSmsEnabled !== null && e.append("featureSmsEnabled", t.featureSmsEnabled), t.featureNearestOfficeEnabled !== null && e.append("featureNearestOfficeEnabled", t.featureNearestOfficeEnabled), t.featureHypotheekMaandlastenEnabled !== null && e.append("featureHypotheekMaandlastenEnabled", t.featureHypotheekMaandlastenEnabled), t.featureHypotheekMaandlastenRequiredFields && t.featureHypotheekMaandlastenRequiredFields.forEach((i, a) => {
      e.append(`featureHypotheekMaandlastenRequiredFields[${a}]`, i.value);
    }), t.featureMaximumMortgageEnabled !== null && e.append("featureMaximumMortgageEnabled", t.featureMaximumMortgageEnabled), t.featureMaximumMortgageRequiredFields && t.featureMaximumMortgageRequiredFields.forEach((i, a) => {
      e.append(`featureMaximumMortgageRequiredFields[${a}]`, i.value);
    }), t.featureRequestContactDataEnabled !== null && e.append("featureRequestContactDataEnabled", t.featureRequestContactDataEnabled), t.featureRequiredContactDataFields && t.featureRequiredContactDataFields.forEach((i, a) => {
      e.append(`featureRequiredContactDataFields[${a}]`, i.value);
    }), t.behaviorId && e.append("behaviorId", t.behaviorId), t.behaviorPersonality && e.append("behaviorPersonality", t.behaviorPersonality), t.behaviorFormality && e.append("behaviorFormality", t.behaviorFormality), t.behaviorAnswerLength && e.append("behaviorAnswerLength", t.behaviorAnswerLength), t.behaviorAllowEmoticons !== null && e.append("behaviorAllowEmoticons", t.behaviorAllowEmoticons), t.behaviorGoals && t.behaviorGoals.forEach((i, a) => {
      e.append(`behaviorGoals[${a}]`, i);
    }), t.behaviorContext && e.append("behaviorContext", t.behaviorContext), t.behaviorContextEnabled !== null && e.append("behaviorContextEnabled", t.behaviorContextEnabled), t.behaviorDocuments && t.behaviorDocuments.forEach((i, a) => {
      i.file !== null ? e.append(`behaviorNewDocuments[${a}]`, i.file) : e.append(`behaviorCurrentDocumentIds[${a}]`, i.id);
    }), t.behaviorDocumentsEnabled !== null && e.append("behaviorDocumentsEnabled", t.behaviorDocumentsEnabled), t.behaviorFaqs && t.behaviorFaqs.forEach((i, a) => {
      e.append(`behaviorFaqs[${a}][id]`, i.id.id), e.append(`behaviorFaqs[${a}][question]`, i.question), e.append(`behaviorFaqs[${a}][answer]`, i.answer);
    }), t.behaviorFaqsEnabled !== null && e.append("behaviorFaqsEnabled", t.behaviorFaqsEnabled), t.behaviorWebsiteEnabled !== null && e.append("behaviorWebsiteEnabled", t.behaviorWebsiteEnabled), t.behaviorCustomInstruction !== null && e.append("behaviorCustomInstruction", t.behaviorCustomInstruction), t.behaviorCustomInstructionEnabled !== null && e.append("behaviorCustomInstructionEnabled", t.behaviorCustomInstructionEnabled), t.behaviorEnglishSupportEnabled !== null && e.append("behaviorEnglishSupportEnabled", t.behaviorEnglishSupportEnabled), t.emailRoutingId && e.append("emailRoutingId", t.emailRoutingId), t.emailRoutingFromName && e.append("emailRoutingFromName", t.emailRoutingFromName), t.emailRoutingForwardEmailAddress && e.append("emailRoutingForwardEmailAddress", t.emailRoutingForwardEmailAddress), t.widgetId && e.append("widgetId", t.widgetId), t.widgetGreeting && e.append("widgetGreeting", t.widgetGreeting), t.widgetColor && e.append("widgetColor", t.widgetColor), t.widgetBalloonColor && e.append("widgetBalloonColor", t.widgetBalloonColor), t.widgetQuickOptions && t.widgetQuickOptions.forEach((i, a) => {
      e.append(`widgetQuickOptions[${a}][id]`, i.id.id), e.append(`widgetQuickOptions[${a}][shortMessage]`, i.shortMessage), e.append(`widgetQuickOptions[${a}][message]`, i.message), i.englishShortMessage && e.append(`widgetQuickOptions[${a}][englishShortMessage]`, i.englishShortMessage), i.englishMessage && e.append(`widgetQuickOptions[${a}][englishMessage]`, i.englishMessage);
    }), t.widgetMobilePosition && e.append("widgetMobilePosition", t.widgetMobilePosition), t.widgetMobileVariant && e.append("widgetMobileVariant", t.widgetMobileVariant), t.widgetMobileType && e.append("widgetMobileType", t.widgetMobileType), t.widgetMobileChatStyle && e.append("widgetMobileChatStyle", t.widgetMobileChatStyle), t.widgetDesktopPosition && e.append("widgetDesktopPosition", t.widgetDesktopPosition), t.widgetDesktopVariant && e.append("widgetDesktopVariant", t.widgetDesktopVariant), t.widgetDesktopType && e.append("widgetDesktopType", t.widgetDesktopType), t.widgetDesktopChatStyle && e.append("widgetDesktopChatStyle", t.widgetDesktopChatStyle), t.widgetBeamReopenLabel && e.append("widgetBeamReopenLabel", t.widgetBeamReopenLabel), t.widgetBeamDisplayAfterPercentage && e.append("widgetBeamDisplayAfterPercentage", t.widgetBeamDisplayAfterPercentage), t.widgetOpenAfterSeconds && e.append("widgetOpenAfterSeconds", t.widgetOpenAfterSeconds), t.widgetHintAfterSeconds && e.append("widgetHintAfterSeconds", t.widgetHintAfterSeconds), t.widgetRepeatAfterSeconds && e.append("widgetRepeatAfterSeconds", t.widgetRepeatAfterSeconds), t.widgetFilterMode && e.append("widgetFilterMode", t.widgetFilterMode), t.widgetFilters && t.widgetFilters.forEach((i, a) => {
      e.append(`widgetFilters[${a}][type]`, i.type.value), e.append(`widgetFilters[${a}][value]`, i.value);
    }), t.widgetShowOnFlowPages !== null && e.append("widgetShowOnFlowPages", t.widgetShowOnFlowPages), t.widgetShowQuickOptionsInsteadOfGreeting !== null && e.append("widgetShowQuickOptionsInsteadOfGreeting", t.widgetShowQuickOptionsInsteadOfGreeting), t.active !== null && e.append("active", t.active), e;
  }
  get contentType() {
    return "multipart/form-data";
  }
}
class Kc extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromAssistent(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: Mt.validationSchema.required() }).strict(!0);
  }
  get requestPath() {
    return `/ai/assistent/assistents/${this.id.toString()}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
}
class Yc extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromAssistent(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: Mt.validationSchema.required() }).strict(!0);
  }
  get requestPath() {
    return `/ai/assistent/assistents/${this.id.toString()}/activate`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class Qc extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromAssistent(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: Mt.validationSchema.required() }).strict(!0);
  }
  get requestPath() {
    return `/ai/assistent/assistents/${this.id.toString()}/deactivate`;
  }
  get requestMethod() {
    return F.POST;
  }
}
const x = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: x.FULL_NAME, label: "Volledige naam" },
      { value: x.FIRST_NAME, label: "Voornaam" },
      { value: x.LAST_NAME, label: "Achternaam" },
      { value: x.GENDER, label: "Geslacht" },
      { value: x.DATE_OF_BIRTH, label: "Geboortedatum" },
      { value: x.PHONE_NUMBER, label: "Telefoonnummer" },
      { value: x.MOBILE_NUMBER, label: "Mobiel nummer" },
      { value: x.EMAIL_ADDRESS, label: "E-mailadres" },
      { value: x.STREET_NAME, label: "Straatnaam" },
      { value: x.HOUSE_NUMBER, label: "Huisnummer" },
      { value: x.POSTAL_CODE, label: "Postcode" },
      { value: x.CITY, label: "Woonplaats" },
      { value: x.PREFERRED_DATE, label: "Voorkeur datum" },
      { value: x.PREFERRED_TIME, label: "Voorkeur tijd" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return x.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(x.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      x.FULL_NAME,
      x.FIRST_NAME,
      x.LAST_NAME,
      x.GENDER,
      x.DATE_OF_BIRTH,
      x.PHONE_NUMBER,
      x.MOBILE_NUMBER,
      x.EMAIL_ADDRESS,
      x.STREET_NAME,
      x.HOUSE_NUMBER,
      x.POSTAL_CODE,
      x.CITY,
      x.PREFERRED_DATE,
      x.PREFERRED_TIME
    ];
  }
};
let V = x;
o(V, "FULL_NAME", new x("Full Name")), o(V, "FIRST_NAME", new x("First Name")), o(V, "LAST_NAME", new x("Last Name")), o(V, "GENDER", new x("Gender")), o(V, "DATE_OF_BIRTH", new x("Date of Birth")), o(V, "PHONE_NUMBER", new x("Phone Number")), o(V, "MOBILE_NUMBER", new x("Mobile Number")), o(V, "EMAIL_ADDRESS", new x("Email Address")), o(V, "STREET_NAME", new x("Street Name")), o(V, "HOUSE_NUMBER", new x("House Number")), o(V, "POSTAL_CODE", new x("Postal Code")), o(V, "CITY", new x("City")), o(V, "PREFERRED_DATE", new x("Preferred Date")), o(V, "PREFERRED_TIME", new x("Preferred Time"));
class Us extends N {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D, M, $, Z = []) {
    super();
    o(this, "fromObject", (e) => Us.fromObject(e));
    this.id = e, this.withoutBranding = i, this.appraisalEnabled = a, this.appraisalRequiredFields = n, this.appraisalEstimateOffsetType = l, this.wozEnabled = u, this.energyLabelEnabled = h, this.fundaEnabled = c, this.areaInfoEnabled = p, this.postalCodeEnabled = m, this.streetviewEnabled = b, this.emailEnabled = v, this.smsEnabled = g, this.nearestOfficeEnabled = w, this.hypotheekMaandlastenEnabled = O, this.hypotheekMaandlastenRequiredFields = C, this.maximumMortgageEnabled = D, this.maximumMortgageRequiredFields = M, this.requestContactDataEnabled = $, this.requiredContactDataFields = Z;
  }
  static fromObject(e) {
    return new Us(
      s.parseField(e.id, sn),
      s.parseField(e.withoutBranding),
      s.parseField(e.appraisalEnabled),
      s.parseField(e.appraisalRequiredFields, V),
      s.parseField(e.appraisalEstimateOffsetType, Dt),
      s.parseField(e.wozEnabled),
      s.parseField(e.energyLabelEnabled),
      s.parseField(e.fundaEnabled),
      s.parseField(e.areaInfoEnabled),
      s.parseField(e.postalCodeEnabled),
      s.parseField(e.streetviewEnabled),
      s.parseField(e.emailEnabled),
      s.parseField(e.smsEnabled),
      s.parseField(e.nearestOfficeEnabled),
      s.parseField(e.hypotheekMaandlastenEnabled),
      s.parseField(e.hypotheekMaandlastenRequiredFields, V),
      s.parseField(e.maximumMortgageEnabled),
      s.parseField(e.maximumMortgageRequiredFields, V),
      s.parseField(e.requestContactDataEnabled),
      e.requiredContactDataFields ? e.requiredContactDataFields.map((i) => s.parseField(i, Ge)) : []
    );
  }
}
class hd extends A {
}
class $s extends N {
  constructor(e, i, a, n, l, u, h) {
    super();
    o(this, "fromObject", (e) => $s.fromObject(e));
    this.id = e, this.file = i, this.fileName = a, this.fileSize = n, this.fileType = l, this.createdAt = u, this.updatedAt = h;
  }
  static fromObject(e) {
    return new $s(
      s.parseField(e.id, hd),
      s.parseField(e.file),
      s.parseField(e.fileName),
      s.parseField(e.fileSize),
      s.parseField(e.fileType),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class pd extends A {
}
class Bs extends N {
  constructor(e, i, a, n, l, u) {
    super();
    o(this, "fromObject", (e) => Bs.fromObject(e));
    this.behavior = e, this.id = i, this.question = a, this.answer = n, this.createdAt = l, this.updatedAt = u;
  }
  static fromObject(e) {
    return new Bs(
      s.parseField(e.behavior, vl),
      s.parseField(e.id, pd),
      s.parseField(e.question),
      s.parseField(e.answer),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Vs extends N {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D, M, $, Z, te, oe) {
    super();
    o(this, "fromObject", (e) => Vs.fromObject(e));
    this.id = e, this.personality = i, this.formality = a, this.answerLength = n, this.allowEmoticons = l, this.goals = u, this.context = h, this.contextEnabled = c, this.documents = p, this.documentsEnabled = m, this.faqs = b, this.faqsEnabled = v, this.websiteEnabled = g, this.customInstruction = w, this.customInstructionEnabled = O, this.englishSupportEnabled = C, this.analyzedInstruction = D, this.analyzedAt = M, this.generatedInstruction = $, this.generatedAt = Z, this.createdAt = te, this.updatedAt = oe;
  }
  static fromObject(e) {
    return new Vs(
      s.parseField(e.id, rn),
      s.parseField(e.personality, Wt),
      s.parseField(e.formality, zt),
      s.parseField(e.answerLength, pi),
      s.parseField(e.allowEmoticons),
      e.goals ? e.goals.map((i) => s.parseField(i, an)) : [],
      s.parseField(e.context),
      s.parseField(e.contextEnabled),
      s.parseField(e.documents, $s),
      s.parseField(e.documentsEnabled),
      s.parseField(e.faqs, Bs),
      s.parseField(e.faqsEnabled),
      s.parseField(e.websiteEnabled),
      s.parseField(e.customInstruction),
      s.parseField(e.customInstructionEnabled),
      s.parseField(e.englishSupportEnabled),
      s.parseField(e.analyzedInstruction),
      s.parseField(e.analyzedAt, Date),
      s.parseField(e.generatedInstruction),
      s.parseField(e.generatedAt, Date),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const vl = Vs;
class Hs extends s {
  constructor(e, i, a, n, l, u, h, c, p) {
    super();
    o(this, "entrypoint", "ai/avatar");
    o(this, "fromObject", (e) => Hs.fromObject(e));
    this.assistent = e, this.id = i, this.file = a, this.fileName = n, this.fileSize = l, this.fileType = u, this.url = h, this.createdAt = c, this.updatedAt = p;
  }
  static fromObject(e) {
    return new Hs(
      s.parseField(e.assistent, El),
      s.parseField(e.id, String),
      s.parseField(e.file),
      s.parseField(e.fileName),
      s.parseField(e.fileSize),
      s.parseField(e.fileType),
      s.parseField(e.url),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Gs extends N {
  constructor(e, i, a, n, l) {
    super();
    o(this, "fromObject", (e) => Gs.fromObject(e));
    this.id = e, this.fromName = i, this.forwardEmailAddress = a, this.createdAt = n, this.updatedAt = l;
  }
  static fromObject(e) {
    return new Gs(
      s.parseField(e.id, gl),
      s.parseField(e.fromName),
      s.parseField(e.forwardEmailAddress),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
var H;
let ls = (H = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: H.READY, label: "Gereed" },
      { value: H.CRAWLING, label: "Bezig met indexeren" },
      { value: H.ANALYZING, label: "Bezig met analyseren" },
      { value: H.GENERATING, label: "Bezig met genereren" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get tooltip() {
    var t;
    return ((t = [
      { value: H.READY, label: "Gereed" },
      { value: H.CRAWLING, label: "Je website wordt momenteel opgehaald, een moment geduld" },
      { value: H.ANALYZING, label: "Je website wordt momenteel geanalyseerd, een moment geduld" },
      { value: H.GENERATING, label: "Jouw AI wordt nu gegenereerd, een moment geduld" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return H.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(H.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      H.READY,
      H.CRAWLING,
      H.ANALYZING,
      H.GENERATING
    ];
  }
}, o(H, "READY", new H("ready")), o(H, "CRAWLING", new H("crawling")), o(H, "ANALYZING", new H("analyzing")), o(H, "GENERATING", new H("generating")), H);
class Ws extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D, M, $, Z, te) {
    super();
    o(this, "entrypoint", "ai/assistent/assistents");
    o(this, "fromObject", (e) => Ws.fromObject(e));
    o(this, "subResources", {
      goals: "ai/assistent/assistents/{id}/goals",
      system_goals: "ai/assistent/assistents/{id}/system_goals"
    });
    this.brand = e, this.id = i, this.status = a, this.externalId = n, this.vectorStoreId = l, this.name = u, this.description = h, this.roles = c, this.avatarVariant = p, this.avatar = m, this.voice = b, this.features = v, this.behavior = g, this.emailRouting = w, this.widget = O, this.active = C, this.chatsCount = D, this.instruction = M, this.createdBy = $, this.createdAt = Z, this.updatedAt = te;
  }
  get isGenerating() {
    return ls.CRAWLING.equals(this.status) || ls.ANALYZING.equals(this.status) || ls.GENERATING.equals(this.status);
  }
  get isGeneratingForTheFirstTime() {
    return this.isGenerating && this.behavior.generatedAt === null;
  }
  static fromObject(e) {
    return new Ws(
      s.parseField(e.brand, Jt),
      s.parseField(e.id, Mt),
      s.parseField(e.status, ls),
      s.parseField(e.externalId),
      s.parseField(e.vectorStoreId),
      s.parseField(e.name),
      s.parseField(e.description),
      s.parseField(e.roles, Gt),
      s.parseField(e.avatarVariant, ft),
      s.parseField(e.avatar, Hs),
      s.parseField(e.voice, Ye),
      s.parseField(e.features, Us),
      s.parseField(e.behavior, vl),
      s.parseField(e.emailRouting, Gs),
      s.parseField(e.widget, Yi),
      s.parseField(e.active),
      s.parseField(e.chatsCount),
      s.parseField(e.instruction),
      s.parseField(e.createdBy, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const El = Ws;
class Jc extends A {
}
class Zc extends S {
  constructor(t) {
    super(), this.assistentId = t;
  }
  get validationSchema() {
    return f({ pipelineCategory: ie.validationSchema.nullable() });
  }
  get requestPath() {
    return `/ai/assistent/assistents/${this.assistentId.toString()}/chat_counts`;
  }
  get requestMethod() {
    return F.POST;
  }
  async parseResponse(t) {
    return t;
  }
}
class ss extends A {
}
class wl extends S {
  constructor(t, e) {
    super(), this.id = t, this.note = e;
  }
  static fromChat(t) {
    return new wl(
      t.id,
      t.note
    );
  }
  get validationSchema() {
    return f({
      id: ss.validationSchema.required(),
      note: d().required()
    }).strict(!0);
  }
  async parseRequest(t) {
    return super.parseRequest({
      ...t,
      id: t.id.id
    });
  }
  get requestPath() {
    return `/ai/chat/chats/${this.id.toString()}/change_note`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class Xc extends S {
  constructor(t, e, i) {
    super(), this.chatId = t, this.emailAddresses = e, this.senderUserId = i;
  }
  static fromChat(t, e, i) {
    return new this(
      t.id,
      e,
      i
    );
  }
  get validationSchema() {
    return f({
      chatId: ss.validationSchema.required(),
      emailAddresses: R().of(d()).min(1).required(),
      senderUserId: se.validationSchema.required()
    }).strict(!0);
  }
  async parseRequest(t) {
    return super.parseRequest({
      ...t,
      chatId: t.chatId.value,
      senderUserId: t.senderUserId.value
    });
  }
  get requestPath() {
    return `/ai/chat/chats/${this.chatId}/forward`;
  }
  get requestMethod() {
    return F.POST;
  }
}
let Sl = class extends A {
};
class eh extends S {
  constructor(t, e, i) {
    super(), this.emailId = t, this.emailAddresses = e, this.senderUserId = i;
  }
  static fromEmail(t, e, i) {
    return new this(
      t.id,
      e,
      i
    );
  }
  get validationSchema() {
    return f({
      emailId: Sl.validationSchema.required(),
      emailAddresses: R().of(d()).min(1).required(),
      senderUserId: se.validationSchema.required()
    }).strict(!0);
  }
  async parseRequest(t) {
    return super.parseRequest({
      ...t,
      emailId: t.emailId.value,
      senderUserId: t.senderUserId.value
    });
  }
  get requestPath() {
    return `/ai/chat/emails/${this.emailId}/forward`;
  }
  get requestMethod() {
    return F.POST;
  }
}
let th = class extends S {
  constructor(t, e) {
    super(), this.id = t, this.userId = e;
  }
  get validationSchema() {
    return f({
      id: ss.validationSchema.required(),
      userId: se.validationSchema.required()
    }).strict(!0);
  }
  async parseRequest(t) {
    return super.parseRequest({
      ...t,
      id: t.id.id,
      userId: t.userId.id
    });
  }
  get requestPath() {
    return `/ai/chat/chats/${this.id.toString()}/favorite`;
  }
  get requestMethod() {
    return F.POST;
  }
};
class sh extends S {
  constructor(t, e) {
    super(), this.id = t, this.userId = e;
  }
  get validationSchema() {
    return f({
      id: ss.validationSchema.required(),
      userId: se.validationSchema.required()
    }).strict(!0);
  }
  async parseRequest(t) {
    return super.parseRequest({
      ...t,
      id: t.id.id,
      userId: t.userId.id
    });
  }
  get requestPath() {
    return `/ai/chat/chats/${this.id.toString()}/unfavorite`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class yi extends A {
}
const at = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: at.GENERATING, label: "Aan het Genereren" },
      { value: at.READY, label: "Klaar" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return at.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(at.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      at.GENERATING,
      at.READY
    ];
  }
};
let mi = at;
o(mi, "GENERATING", new at("generating")), o(mi, "READY", new at("ready"));
class Da extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D) {
    super();
    o(this, "entrypoint", "ai/assistent/goal/goals");
    o(this, "fromObject", (e) => Da.fromObject(e));
    this.id = e, this.name = i, this.description = a, this.recipientEmail = n, this.goalDescription = l, this.functionName = u, this.functionDescription = h, this.functionPurpose = c, this.functionUsage = p, this.messageFieldDescription = m, this.successMessage = b, this.requiredFields = v, this.optionalFields = g, this.status = w, this.active = O, this.createdAt = C, this.updatedAt = D;
  }
  static fromObject(e) {
    return new Da(
      s.parseField(e.id, yi),
      s.parseField(e.name),
      s.parseField(e.description),
      s.parseField(e.recipientEmail),
      s.parseField(e.goalDescription),
      s.parseField(e.functionName),
      s.parseField(e.functionDescription),
      s.parseField(e.functionPurpose),
      s.parseField(e.functionUsage),
      s.parseField(e.messageFieldDescription),
      s.parseField(e.successMessage),
      s.parseField(e.requiredFields, V),
      s.parseField(e.optionalFields, V),
      s.parseField(e.status, mi),
      s.parseField(e.active),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
  changeActive(e) {
    this.active = e;
  }
}
class Tr extends A {
}
class Ra extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D) {
    super();
    o(this, "entrypoint", "ai/assistent/goal/system_goals");
    o(this, "fromObject", (e) => Ra.fromObject(e));
    this.id = e, this.name = i, this.description = a, this.recipientEmail = n, this.goalDescription = l, this.functionName = u, this.functionDescription = h, this.functionPurpose = c, this.functionUsage = p, this.messageFieldDescription = m, this.successMessage = b, this.requiredFields = v, this.optionalFields = g, this.status = w, this.active = O, this.createdAt = C, this.updatedAt = D;
  }
  static fromObject(e) {
    return new Ra(
      s.parseField(e.id, Tr),
      s.parseField(e.name),
      s.parseField(e.description),
      s.parseField(e.recipientEmail),
      s.parseField(e.goalDescription),
      s.parseField(e.functionName),
      s.parseField(e.functionDescription),
      s.parseField(e.functionPurpose),
      s.parseField(e.functionUsage),
      s.parseField(e.messageFieldDescription),
      s.parseField(e.successMessage),
      s.parseField(e.requiredFields, V),
      s.parseField(e.optionalFields, V),
      s.parseField(e.status, mi),
      s.parseField(e.active),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
  changeActive(e) {
    this.active = e;
  }
}
class rh extends S {
  constructor(t, e, i, a, n) {
    super(), this.id = t, this.assistentId = e, this.name = i, this.recipientEmail = a, this.goalDescription = n;
  }
  get validationSchema() {
    return f({
      id: yi.validationSchema.required(),
      assistentId: Mt.validationSchema.required(),
      name: d().required(),
      recipientEmail: d().required(),
      goalDescription: d().required()
    }).strict(!0);
  }
  async parseRequest(t) {
    return super.parseRequest({
      ...t,
      id: t.id.id,
      assistentId: t.assistentId.id
    });
  }
  get requestPath() {
    return "/ai/assistent/goal/goals";
  }
  get requestMethod() {
    return F.POST;
  }
}
class Fl extends S {
  constructor(t, e, i, a, n, l, u, h, c, p) {
    super(), this.id = t, this.name = e, this.recipientEmail = i, this.functionName = a, this.functionDescription = n, this.functionPurpose = l, this.functionUsage = u, this.successMessage = h, this.requiredFields = c, this.optionalFields = p;
  }
  static fromGoal(t) {
    return new Fl(
      t.id,
      t.name,
      t.recipientEmail,
      t.functionName,
      t.functionDescription,
      t.functionPurpose,
      t.functionUsage,
      t.successMessage,
      t.requiredFields,
      t.optionalFields
    );
  }
  get validationSchema() {
    return f({
      id: yi.validationSchema.required(),
      name: d().required(),
      recipientEmail: d().required(),
      functionName: d().required(),
      functionDescription: d().required(),
      functionPurpose: d().required(),
      functionUsage: d().required(),
      successMessage: d().nullable(),
      requiredFields: R().of(V.validationSchema).required(),
      optionalFields: R().of(V.validationSchema).required()
    }).strict(!0);
  }
  async parseRequest(t) {
    return super.parseRequest({
      ...t,
      id: t.id.id,
      requiredFields: t.requiredFields.map((e) => e.value),
      optionalFields: t.optionalFields.map((e) => e.value)
    });
  }
  get requestPath() {
    return `/ai/assistent/goal/goals/${this.id.toString()}/change`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class Al extends S {
  constructor(t, e, i, a) {
    super(), this.id = t, this.recipientEmail = e, this.requiredFields = i, this.optionalFields = a;
  }
  static fromGoal(t) {
    return new Al(
      t.id,
      t.recipientEmail,
      t.requiredFields,
      t.optionalFields
    );
  }
  get validationSchema() {
    return f({
      id: Tr.validationSchema.required(),
      recipientEmail: d().required(),
      requiredFields: R().of(V.validationSchema).required(),
      optionalFields: R().of(V.validationSchema).required()
    }).strict(!0);
  }
  async parseRequest(t) {
    return super.parseRequest({
      ...t,
      id: t.id.id,
      requiredFields: t.requiredFields.map((e) => e.value),
      optionalFields: t.optionalFields.map((e) => e.value)
    });
  }
  get requestPath() {
    return `/ai/assistent/goal/system_goals/${this.id.toString()}/change`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class ah extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromGoal(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: yi.validationSchema.required() }).strict(!0);
  }
  get requestPath() {
    return `/ai/assistent/goal/goals/${this.id.toString()}/activate`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class nh extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromGoal(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: Tr.validationSchema.required() }).strict(!0);
  }
  get requestPath() {
    return `/ai/assistent/goal/system_goals/${this.id.toString()}/activate`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class lh extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromGoal(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: yi.validationSchema.required() }).strict(!0);
  }
  get requestPath() {
    return `/ai/assistent/goal/goals/${this.id.toString()}/deactivate`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class oh extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromGoal(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: Tr.validationSchema.required() }).strict(!0);
  }
  get requestPath() {
    return `/ai/assistent/goal/system_goals/${this.id.toString()}/deactivate`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class uh extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromGoal(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: yi.validationSchema.required() }).strict(!0);
  }
  get requestPath() {
    return `/ai/assistent/goal/goals/${this.id.toString()}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
}
class dh extends S {
  constructor(t, e, i, a, n) {
    super(), this.from = t, this.name = e, this.recipient = i, this.subject = a, this.body = n;
  }
  get validationSchema() {
    return f({
      from: d().nullable(),
      name: d().nullable(),
      recipient: d().required(),
      subject: d().required(),
      body: d().required()
    }).strict(!0);
  }
  get requestPath() {
    return "/ai/assistent/assistents/request_new_functionality";
  }
  get requestMethod() {
    return F.POST;
  }
}
class md extends A {
}
const De = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: De.EVENT, label: "Gebeurtenis" },
      { value: De.MESSAGE, label: "Bericht" },
      { value: De.FUNCTION, label: "Functie" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return De.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(De.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      De.EVENT,
      De.MESSAGE,
      De.FUNCTION
    ];
  }
};
let li = De;
o(li, "EVENT", new De("event")), o(li, "MESSAGE", new De("message")), o(li, "FUNCTION", new De("function"));
const Re = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: Re.USER, label: "Gebruiker" },
      { value: Re.ASSISTENT, label: "Assistent" },
      { value: Re.SYSTEM, label: "Systeem" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return Re.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(Re.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      Re.USER,
      Re.ASSISTENT,
      Re.SYSTEM
    ];
  }
};
let oi = Re;
o(oi, "USER", new Re("user")), o(oi, "ASSISTENT", new Re("assistent")), o(oi, "SYSTEM", new Re("system"));
class zs extends N {
  constructor(e, i, a, n, l, u, h, c, p) {
    super();
    o(this, "fromObject", (e) => zs.fromObject(e));
    this.chat = e, this.id = i, this.type = a, this.origin = n, this.url = l, this.pageTitle = u, this.content = h, this.context = c, this.createdAt = p;
  }
  static fromObject(e) {
    return new zs(
      s.parseField(e.chat, nn),
      s.parseField(e.id, md),
      s.parseField(e.type, li),
      s.parseField(e.origin, oi),
      s.parseField(e.url),
      s.parseField(e.pageTitle),
      s.parseField(e.content),
      s.parseField(e.context),
      s.parseField(e.createdAt, Date)
    );
  }
}
class fd extends A {
}
class Ks extends N {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "fromObject", (e) => Ks.fromObject(e));
    this.id = e, this.name = i, this.email = a, this.phoneNumber = n, this.postalCode = l, this.houseNumber = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromObject(e) {
    return new Ks(
      s.parseField(e.id, fd),
      s.parseField(e.name),
      s.parseField(e.email),
      s.parseField(e.phoneNumber),
      s.parseField(e.postalCode),
      s.parseField(e.houseNumber),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class bd extends A {
}
class Ys extends N {
  constructor(e, i, a, n, l) {
    super();
    o(this, "fromObject", (e) => Ys.fromObject(e));
    this.chat = e, this.id = i, this.tag = a, this.color = n, this.createdAt = l;
  }
  static fromObject(e) {
    return new Ys(
      s.parseField(e.chat, nn),
      s.parseField(e.id, bd),
      s.parseField(e.tag),
      s.parseField(e.color),
      s.parseField(e.createdAt, Date)
    );
  }
}
const nt = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: nt.FUNCTION, label: "Functie" },
      { value: nt.GOAL, label: "Doel" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return nt.validationSchema;
  }
  static get validationSchema() {
    return f({ value: d().oneOf(nt.values.map((t) => t.value)) });
  }
  static get values() {
    return [
      nt.FUNCTION,
      nt.GOAL
    ];
  }
};
let Mi = nt;
o(Mi, "FUNCTION", new nt("function")), o(Mi, "GOAL", new nt("goal"));
let gd = class Na extends s {
  constructor(e, i, a, n, l, u, h, c, p) {
    super();
    o(this, "entrypoint", "ai/chat/emails");
    o(this, "fromObject", (e) => Na.fromObject(e));
    this.chat = e, this.id = i, this.type = a, this.sender = n, this.senderName = l, this.subject = u, this.recipient = h, this.body = c, this.createdAt = p;
  }
  static fromObject(e) {
    return new Na(
      s.parseField(e.chat, nn),
      s.parseField(e.id, Sl),
      s.parseField(e.type, Mi),
      s.parseField(e.sender),
      s.parseField(e.senderName),
      s.parseField(e.subject),
      s.parseField(e.recipient),
      s.parseField(e.body),
      s.parseField(e.createdAt, Date)
    );
  }
};
class Qs extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g) {
    super();
    o(this, "entrypoint", "ai/chat/chats");
    o(this, "fromObject", (e) => Qs.fromObject(e));
    this.assistent = e, this.id = i, this.externalId = a, this.note = n, this.interactions = l, this.emails = u, this.contactData = h, this.tags = c, this.isFavorite = p, this.createdAt = m, this.updatedAt = b, this.closedAt = v, this.closed = g;
  }
  static fromObject(e) {
    return new Qs(
      s.parseField(e.assistent, El),
      s.parseField(e.id, ss),
      s.parseField(e.externalId),
      s.parseField(e.note),
      s.parseField(e.interactions, zs),
      s.parseField(e.emails, gd),
      s.parseField(e.contactData, Ks),
      s.parseField(e.tags, Ys),
      s.parseField(e.isFavorite),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date),
      s.parseField(e.closedAt, Date),
      s.parseField(e.closed)
    );
  }
}
const nn = Qs;
let Nn = class Pa extends N {
  constructor(e) {
    super();
    o(this, "fromObject", (e) => Pa.fromObject(e));
    this.newChatsCount = e;
  }
  static fromObject(e) {
    return new Pa(
      s.parseField(e.newChatsCount)
    );
  }
};
class Js extends N {
  constructor(e, i, a, n) {
    super();
    o(this, "fromObject", (e) => Js.fromObject(e));
    this.current = e, this.dataScale = i, this.data = a, this.previous = n;
  }
  static fromObject(e) {
    return new Js(
      s.parseField(e.current, Nn),
      s.parseField(e.dataScale),
      e.data,
      s.parseField(e.previous, Nn)
    );
  }
}
var ce;
let ch = (ce = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: ce.TODAY, label: "Vandaag" },
      { value: ce.THIS_WEEK, label: "Deze week" },
      { value: ce.THIS_MONTH, label: "Deze maand" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return ce.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      ce.TODAY,
      ce.THIS_WEEK,
      ce.THIS_MONTH
    ];
  }
}, o(ce, "TODAY", new ce("today")), o(ce, "THIS_WEEK", new ce("this-week")), o(ce, "THIS_MONTH", new ce("this-month")), ce);
class hh extends S {
  constructor(t, e) {
    super(), this.assistentId = t, this.range = e;
  }
  get validationSchema() {
    return f({
      assistentId: Mt.validationSchema.required(),
      range: d().required()
    });
  }
  get requestPath() {
    const t = new URLSearchParams({ range: this.range.value });
    return `/ai/assistent/assistents/${this.assistentId.value}/statistics?${t.toString()}`;
  }
  get requestMethod() {
    return F.GET;
  }
  async parseResponse(t) {
    return Js.fromObject(t);
  }
}
class ln extends A {
}
class ph extends S {
  constructor(t) {
    super(), this.reportId = t;
  }
  static fromReport(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ reportId: ln.validationSchema.required() });
  }
  get requestPath() {
    return `/ai/report/reports/${this.reportId.toString()}/approve`;
  }
  get requestMethod() {
    return F.POST;
  }
  async parseRequest(t) {
    return super.parseRequest({ reportId: t.reportId.toString() });
  }
}
class bi extends Xi {
  constructor(t, e) {
    super(), this.source = t, this.pipelineId = e;
  }
  toString() {
    return this.source;
  }
  equals(t) {
    return !(t instanceof bi) || !this.pipelineId || !t.pipelineId ? !1 : this.source === t.source && this.pipelineId.equals(t.pipelineId);
  }
  get schemaConfig() {
    return bi.validationSchema;
  }
  static get validationSchema() {
    return f({
      source: d(),
      pipelineId: zi.validationSchema.nullable()
    });
  }
  static fromObject(t) {
    return new bi(
      s.parseField(t.source),
      s.parseField(t.pipelineId, zi)
    );
  }
}
class mh extends S {
  constructor(t, e, i) {
    super(), this.id = t, this.ownSources = e, this.thirdPartySources = i;
  }
  static fromSettings(t) {
    return new this(
      t.id,
      t.ownSources,
      t.thirdPartySources
    );
  }
  get validationSchema() {
    return f({
      id: pe.validationSchema.required(),
      ownSources: R().of(d()).required(),
      thirdPartySources: R().of(bi.validationSchema).required()
    });
  }
  get requestPath() {
    return `/ai/report/settings/${this.id.toString()}/change`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class fh extends S {
  constructor(t, e) {
    super(), this.reportId = t, this.content = e;
  }
  static fromReport(t) {
    return new this(
      t.id,
      t.modifiedContent
    );
  }
  get validationSchema() {
    return f({
      reportId: ln.validationSchema.required(),
      content: d().required()
    });
  }
  get requestPath() {
    return `/ai/report/reports/${this.reportId.toString()}/change_content`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class xr extends A {
}
class on extends A {
}
const Ne = class extends I {
  get label() {
    var t;
    return ((t = Ne.options.find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return Ne.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      Ne.WEEKLY,
      Ne.MONTHLY,
      Ne.QUARTERLY
    ];
  }
  static get options() {
    return [
      { value: Ne.WEEKLY, label: "Wekelijks" },
      { value: Ne.MONTHLY, label: "Maandelijks" },
      { value: Ne.QUARTERLY, label: "Elk kwartaal" }
    ];
  }
};
let Rt = Ne;
o(Rt, "WEEKLY", new Ne("weekly")), o(Rt, "MONTHLY", new Ne("monthly")), o(Rt, "QUARTERLY", new Ne("quarterly"));
let bh = class extends S {
  constructor(t, e, i, a, n, l) {
    super(), this.id = t, this.frequencies = e, this.teamIds = i, this.pipelineIds = a, this.roleId = n, this.recipientIds = l;
  }
  static fromRule(t) {
    return new this(
      t.id,
      t.frequencies,
      t.teams.map((e) => e.id),
      t.pipelines.map((e) => e.id),
      t.role.id,
      t.recipients.map((e) => e.id)
    );
  }
  get validationSchema() {
    return f({
      id: xr.validationSchema.required(),
      frequencies: R().of(Rt.validationSchema).required(),
      teamIds: R().of(ve.validationSchema).required(),
      pipelineIds: R().of(zi.validationSchema).required(),
      roleId: on.validationSchema.required(),
      recipientIds: R().of(se.validationSchema).required()
    });
  }
  get requestPath() {
    return `/ai/report/rules/${this.id.toString()}/change`;
  }
  get requestMethod() {
    return F.PATCH;
  }
};
class vh extends S {
  constructor(t, e, i, a, n, l, u) {
    super(), this.companyId = t, this.id = e, this.frequencies = i, this.teamIds = a, this.pipelineIds = n, this.roleId = l, this.recipientIds = u;
  }
  static fromRule(t, e) {
    return new this(
      e,
      t.id,
      t.frequencies,
      t.teams.map((i) => i.id),
      t.pipelines.map((i) => i.id),
      t.role.id,
      t.recipients.map((i) => i.id)
    );
  }
  get validationSchema() {
    return f({
      companyId: pe.validationSchema.required(),
      id: xr.validationSchema.required(),
      frequencies: R().of(Rt.validationSchema).required(),
      teamIds: R().of(ve.validationSchema).required(),
      pipelineIds: R().of(zi.validationSchema).required(),
      roleId: on.validationSchema.required(),
      recipientIds: R().of(se.validationSchema).required()
    });
  }
  get requestPath() {
    return "/ai/rules";
  }
  get requestMethod() {
    return F.POST;
  }
}
class Eh extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromRule(t) {
    return new this(
      t.id
    );
  }
  get validationSchema() {
    return f({ id: xr.validationSchema.required() });
  }
  get requestPath() {
    return `/ai/report/rules/${this.id.toString()}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
}
class Si extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O) {
    super();
    o(this, "entrypoint", "ai/report/roles");
    o(this, "fromObject", (e) => Si.fromObject(e));
    this.id = e, this.name = i, this.description = a, this.icon = n, this.provider = l, this.providerId = u, this.generationStrategy = h, this.generationContext = c, this.reportEmptyEmailContent = p, this.reportSuccessEmailPreContent = m, this.reportSuccessEmailPostContent = b, this.visible = v, this.active = g, this.createdAt = w, this.updatedAt = O;
  }
  static fromObject(e) {
    return new Si(
      s.parseField(e.id, on),
      s.parseField(e.name),
      s.parseField(e.description),
      s.parseField(e.icon),
      s.parseField(e.provider),
      s.parseField(e.providerId),
      s.parseField(e.generationStrategy),
      s.parseField(e.generationContext),
      s.parseField(e.reportEmptyEmailContent),
      s.parseField(e.reportSuccessEmailPreContent),
      s.parseField(e.reportSuccessEmailPostContent),
      s.parseField(e.visible),
      s.parseField(e.active),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class wh extends Si {
  constructor() {
    super(...arguments);
    o(this, "entrypoint", "ai/report/available_roles");
  }
}
class Ma extends s {
  constructor(e, i, a, n, l) {
    super();
    o(this, "entrypoint", "ai/report/settings");
    o(this, "fromObject", (e) => Ma.fromObject(e));
    this.id = e, this.ownSources = i, this.thirdPartySources = a, this.createdAt = n, this.updatedAt = l;
  }
  static fromObject(e) {
    var i;
    return new Ma(
      s.parseField(e.id, pe),
      s.parseField(e.ownSources),
      (i = e.thirdPartySources) == null ? void 0 : i.map((a) => s.parseField(a, bi)),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const Be = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: Be.WEEKLY, label: "Weekelijks" },
      { value: Be.MONTHLY, label: "Maandelijks" },
      { value: Be.QUARTERLY, label: "Per kwartaal" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return Be.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      Be.WEEKLY,
      Be.MONTHLY,
      Be.QUARTERLY
    ];
  }
};
let ui = Be;
o(ui, "WEEKLY", new Be("weekly")), o(ui, "MONTHLY", new Be("monthly")), o(ui, "QUARTERLY", new Be("quarterly"));
const mt = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: mt.PROMPT, label: "Prompt" },
      { value: mt.DATA, label: "Data" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return mt.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      mt.PROMPT,
      mt.DATA
    ];
  }
};
let Li = mt;
o(Li, "PROMPT", new mt("prompt")), o(Li, "DATA", new mt("data"));
class Vi extends N {
  constructor(e, i, a, n, l) {
    super();
    o(this, "fromObject", (e) => Vi.fromObject(e));
    this.prompt = e, this.sort = i, this.type = a, this.context = n, this.run = l;
  }
  static fromObject(e) {
    return new Vi(
      N.parseField(e.prompt, Vi),
      N.parseField(e.sort),
      N.parseField(e.type, Li),
      N.parseField(e.context),
      N.parseField(e.run)
    );
  }
}
const we = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: we.PENDING, label: "In afwachting" },
      { value: we.GENERATING, label: "Wordt gegenereerd" },
      { value: we.SUCCESS, label: "Gegenereerd" },
      { value: we.FAILURE, label: "Mislukt" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return we.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      we.PENDING,
      we.GENERATING,
      we.SUCCESS,
      we.FAILURE
    ];
  }
};
let jt = we;
o(jt, "PENDING", new we("pending")), o(jt, "GENERATING", new we("generating")), o(jt, "SUCCESS", new we("success")), o(jt, "FAILURE", new we("failure"));
class La extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C, D, M) {
    super();
    o(this, "entrypoint", "ai/report/reports");
    o(this, "fromObject", (e) => La.fromObject(e));
    this.company = e, this.id = i, this.frequency = a, this.fromDate = n, this.untilDate = l, this.teams = u, this.pipelines = h, this.role = c, this.prompts = p, this.recipients = m, this.status = b, this.originalContent = v, this.modifiedContent = g, this.threadIds = w, this.approvedAt = O, this.approvedBy = C, this.createdAt = D, this.updatedAt = M;
  }
  get isApproved() {
    return this.approvedAt !== null;
  }
  static fromObject(e) {
    return new La(
      s.parseField(e.company, J),
      s.parseField(e.id, ln),
      s.parseField(e.frequency, ui),
      s.parseField(e.fromDate, Date),
      s.parseField(e.untilDate, Date),
      s.parseField(e.teams, Fe),
      s.parseField(e.pipelines, ts),
      s.parseField(e.role, Si),
      s.parseField(e.prompts, Vi),
      s.parseField(e.recipients, ee),
      s.parseField(e.status, jt),
      s.parseField(e.originalContent),
      s.parseField(e.modifiedContent),
      s.parseField(e.threadIds),
      s.parseField(e.approvedAt, Date),
      s.parseField(e.approvedBy, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class ka extends s {
  constructor(e, i, a, n, l, u, h, c, p) {
    super();
    o(this, "entrypoint", "ai/report/rules");
    o(this, "fromObject", (e) => ka.fromObject(e));
    this.company = e, this.id = i, this.frequencies = a, this.teams = n, this.pipelines = l, this.role = u, this.recipients = h, this.createdAt = c, this.updatedAt = p;
  }
  static fromObject(e) {
    return new ka(
      s.parseField(e.company, J),
      s.parseField(e.id, xr),
      s.parseField(e.frequencies, Rt),
      s.parseField(e.teams, Fe),
      s.parseField(e.pipelines, ts),
      s.parseField(e.role, Si),
      s.parseField(e.recipients, ee),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class un extends A {
}
class ja extends s {
  constructor(e, i, a, n, l, u, h, c, p, m) {
    super();
    o(this, "entrypoint", "email/credentials");
    o(this, "fromObject", (e) => ja.fromObject(e));
    this.id = e, this.imapHostName = i, this.imapPort = a, this.smtpHostName = n, this.smtpPort = l, this.username = u, this.password = h, this.team = c, this.createdAt = p, this.updatedAt = m;
  }
  static fromObject(e) {
    return new ja(
      s.parseField(e.id, un),
      s.parseField(e.imapHostName),
      s.parseField(e.imapPort),
      s.parseField(e.smtpHostName),
      s.parseField(e.smtpPort),
      s.parseField(e.username),
      s.parseField(e.password),
      s.parseField(e.team, Fe),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class vd extends A {
}
class Ed extends A {
}
class Zs extends s {
  constructor(e, i, a, n, l) {
    super();
    o(this, "entrypoint", "email/to");
    o(this, "fromObject", (e) => Zs.fromObject(e));
    this.id = e, this.emailAddress = i, this.name = a, this.createdAt = n, this.updatedAt = l;
  }
  static fromObject(e) {
    return new Zs(
      s.parseField(e.id, Ed),
      s.parseField(e.emailAddress),
      s.parseField(e.name),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class wd extends A {
}
class Xs extends s {
  constructor(e, i, a, n, l) {
    super();
    o(this, "entrypoint", "email/from");
    o(this, "fromObject", (e) => Xs.fromObject(e));
    this.id = e, this.emailAddress = i, this.name = a, this.createdAt = n, this.updatedAt = l;
  }
  static fromObject(e) {
    return new Xs(
      s.parseField(e.id, wd),
      s.parseField(e.emailAddress),
      s.parseField(e.name),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Sd extends A {
}
class _s extends s {
  constructor(e, i, a, n, l) {
    super();
    o(this, "entrypoint", "email/sender");
    o(this, "fromObject", (e) => _s.fromObject(e));
    this.id = e, this.emailAddress = i, this.name = a, this.createdAt = n, this.updatedAt = l;
  }
  static fromObject(e) {
    return new _s(
      s.parseField(e.id, Sd),
      s.parseField(e.emailAddress),
      s.parseField(e.name),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Fd extends A {
}
class er extends s {
  constructor(e, i, a, n, l) {
    super();
    o(this, "entrypoint", "email/reply_to");
    o(this, "fromObject", (e) => er.fromObject(e));
    this.id = e, this.emailAddress = i, this.name = a, this.createdAt = n, this.updatedAt = l;
  }
  static fromObject(e) {
    return new er(
      s.parseField(e.id, Fd),
      s.parseField(e.emailAddress),
      s.parseField(e.name),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class tr extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w) {
    super();
    o(this, "entrypoint", "email/sender");
    o(this, "fromObject", (e) => tr.fromObject(e));
    this.id = e, this.subject = i, this.inReplyTo = a, this.body = n, this.unseen = l, this.draft = u, this.answered = h, this.to = c, this.from = p, this.sender = m, this.replyTo = b, this.sendAt = v, this.createdAt = g, this.updatedAt = w;
  }
  static fromObject(e) {
    return new tr(
      s.parseField(e.id, vd),
      s.parseField(e.subject),
      s.parseField(e.inReplyTo),
      s.parseField(e.body),
      s.parseField(e.unseen),
      s.parseField(e.draft),
      s.parseField(e.answered),
      s.parseField(e.to, Zs),
      s.parseField(e.from, Xs),
      s.parseField(e.sender, _s),
      s.parseField(e.replyTo, er),
      s.parseField(e.sendAt, Date),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Ad extends A {
}
class qa extends s {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "entrypoint", "email/sent_flow_emails");
    o(this, "fromObject", (e) => qa.fromObject(e));
    this.id = e, this.email = i, this.lead = a, this.phase = n, this.openedAt = l, this.clickedAt = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromObject(e) {
    return new qa(
      s.parseField(e.id, Ad),
      s.parseField(e.email, tr),
      s.parseField(e.lead, ri),
      s.parseField(e.phase, is),
      s.parseField(e.openedAt, Date),
      s.parseField(e.clickedAt, Date),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Sh extends S {
  constructor(t, e, i, a, n, l, u, h) {
    super(), this.id = t, this.imapHostName = e, this.imapPort = i, this.smtpHostName = a, this.smtpPort = n, this.username = l, this.password = u, this.teamId = h;
  }
  get validationSchema() {
    return f({
      id: un.validationSchema.required(),
      imapHostName: d(),
      imapPort: d(),
      smtpHostName: d(),
      smtpPort: d(),
      username: d(),
      password: d(),
      teamId: ve.validationSchema.required()
    });
  }
  get requestPath() {
    return "/email/credentials";
  }
  get requestMethod() {
    return F.POST;
  }
  async parseRequest(t) {
    return {
      ...await super.parseRequest(t),
      id: t.id.toString(),
      teamId: t.teamId.toString()
    };
  }
}
class Fh extends S {
  constructor(t, e, i, a, n, l, u, h) {
    super(), this.id = t, this.imapHostName = e, this.imapPort = i, this.smtpHostName = a, this.smtpPort = n, this.username = l, this.password = u, this.teamId = h;
  }
  get validationSchema() {
    return f({
      id: un.validationSchema.required(),
      imapHostName: d(),
      imapPort: d(),
      smtpHostName: d(),
      smtpPort: d(),
      username: d(),
      password: d(),
      teamId: ve.validationSchema.required()
    });
  }
  get requestPath() {
    return `/email/credentials/${this.id.toString()}/change`;
  }
  async parseRequest(t) {
    return {
      ...t,
      id: t.id.toString(),
      teamId: t.teamId.toString()
    };
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class ir extends s {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "entrypoint", "flow/assets");
    o(this, "fromObject", (e) => ir.fromObject(e));
    this.id = e, this.file = i, this.fileName = a, this.fileSize = n, this.fileType = l, this.url = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromObject(e) {
    return new ir(
      s.parseField(e.id, Cr),
      s.parseField(e.file),
      s.parseField(e.fileName),
      s.parseField(e.fileSize),
      s.parseField(e.fileType),
      s.parseField(e.url),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Ah extends A {
}
let dn = class extends A {
};
class yl extends A {
}
class yd extends A {
}
const z = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: z.ACTION, label: "Actie" },
      { value: z.CANCEL, label: "Annuleren" },
      { value: z.CONDITIONAL, label: "Conditioneel" },
      { value: z.END, label: "Stoppen" },
      { value: z.INPUT, label: "Invoer" },
      { value: z.MERGE, label: "Samenvoegen" },
      { value: z.WAIT, label: "Wachten" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return z.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      z.ACTION,
      z.CANCEL,
      z.CONDITIONAL,
      z.END,
      z.INPUT,
      z.MERGE,
      z.WAIT
    ];
  }
};
let Xe = z;
o(Xe, "ACTION", new z("action")), o(Xe, "CANCEL", new z("cancel")), o(Xe, "CONDITIONAL", new z("conditional")), o(Xe, "END", new z("end")), o(Xe, "INPUT", new z("input")), o(Xe, "MERGE", new z("merge")), o(Xe, "WAIT", new z("wait"));
class St extends N {
  constructor(e, i, a, n, l, u, h) {
    super();
    o(this, "fromObject", (e) => St.fromObject(e));
    this.flow = e, this.id = i, this.type = a, this.options = n, this.pages = l, this.createdAt = u, this.updatedAt = h;
  }
  toNodeData() {
    return {
      id: this.id.value,
      type: this.type.value,
      options: this.options,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }
  static fromObject(e) {
    return new St(
      s.parseField(e.flow, Dr),
      s.parseField(e.id, yd),
      s.parseField(e.type, Xe),
      s.parseField(e.options),
      s.parseField(e.pages, cn),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class sr extends s {
  constructor(e, i, a, n, l, u, h, c, p, m) {
    super();
    o(this, "entrypoint", "flow/pages");
    o(this, "fromObject", (e) => sr.fromObject(e));
    this.flow = e, this.id = i, this.title = a, this.slug = n, this.content = l, this.mainCss = u, this.sectionCss = h, this.nodes = c, this.createdAt = p, this.updatedAt = m;
  }
  static fromObject(e) {
    return new sr(
      s.parseField(e.flow, Dr),
      s.parseField(e.id, yl),
      s.parseField(e.title),
      s.parseField(e.slug),
      s.parseField(e.content),
      s.parseField(e.mainCss),
      s.parseField(e.sectionCss),
      s.parseField(e.nodes, St),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const cn = sr;
class Od extends A {
}
class Qi extends N {
  constructor(e, i, a, n, l, u, h) {
    super();
    o(this, "fromObject", (e) => Qi.fromObject(e));
    this.flow = e, this.id = i, this.from = a, this.to = n, this.condition = l, this.createdAt = u, this.updatedAt = h;
  }
  toTransitionData() {
    return {
      id: this.id.value,
      fromNodeId: this.from.id.value,
      toNodeId: this.to.id.value,
      condition: this.condition,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }
  static fromObject(e) {
    return new Qi(
      s.parseField(e.flow, Dr),
      s.parseField(e.id, Od),
      s.parseField(e.from, St),
      s.parseField(e.to, St),
      s.parseField(e.condition),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Cd extends A {
}
const le = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: le.REALWORKS_AGENDA, label: "Realworks Agenda" },
      { value: le.REALWORKS_TAAK, label: "Realworks Taak" },
      { value: le.REALWORKS_RELATIE, label: "Realworks Relatie" },
      { value: le.REALWORKS_KENMERK, label: "Realworks Kenmerk" },
      { value: le.REALWORKS_BIRTHDAY, label: "Realworks Verjaardag" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return le.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      le.REALWORKS_AGENDA,
      le.REALWORKS_TAAK,
      le.REALWORKS_RELATIE,
      le.REALWORKS_KENMERK,
      le.REALWORKS_BIRTHDAY
    ];
  }
};
let Ct = le;
o(Ct, "REALWORKS_AGENDA", new le("realworks-agenda")), o(Ct, "REALWORKS_TAAK", new le("realworks-taak")), o(Ct, "REALWORKS_RELATIE", new le("realworks-relatie")), o(Ct, "REALWORKS_KENMERK", new le("realworks-kenmerk")), o(Ct, "REALWORKS_BIRTHDAY", new le("realworks-birthday"));
class Ji extends N {
  constructor(e, i, a, n, l, u) {
    super();
    o(this, "fromObject", (e) => Ji.fromObject(e));
    this.flow = e, this.id = i, this.type = a, this.options = n, this.createdAt = l, this.updatedAt = u;
  }
  toTriggerData() {
    return {
      id: this.id.value,
      type: this.type.value,
      options: this.options,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }
  static fromObject(e) {
    return new Ji(
      s.parseField(e.flow, Dr),
      s.parseField(e.id, Cd),
      s.parseField(e.type, Ct),
      s.parseField(e.options),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class rr extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b, v, g, w, O, C) {
    super();
    o(this, "entrypoint", "flow/flows");
    o(this, "fromObject", (e) => rr.fromObject(e));
    this.company = e, this.id = i, this.name = a, this.brand = n, this.teams = l, this.startNode = u, this.active = h, this.triggers = c, this.nodes = p, this.transitions = m, this.pages = b, this.autoDeleteEnabled = v, this.autoDeleteAfterQuantity = g, this.autoDeleteAfterUnit = w, this.createdAt = O, this.updatedAt = C;
  }
  static fromObject(e) {
    return new rr(
      s.parseField(e.company, J),
      s.parseField(e.id, dn),
      s.parseField(e.name),
      s.parseField(e.brand, Jt),
      s.parseField(e.teams, Fe),
      s.parseField(e.startNode, St),
      s.parseField(e.active),
      s.parseField(e.triggers, Ji),
      s.parseField(e.nodes, St),
      s.parseField(e.transitions, Qi),
      s.parseField(e.pages, cn),
      s.parseField(e.autoDeleteEnabled),
      s.parseField(e.autoDeleteAfterQuantity),
      s.parseField(e.autoDeleteAfterUnit),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const Dr = rr;
class Id extends A {
}
const Ve = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: Ve.IMAGE, label: "Afbeelding" },
      { value: Ve.VIDEO, label: "Video" },
      { value: Ve.YOUTUBE, label: "YouTube" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return Ve.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      Ve.IMAGE,
      Ve.VIDEO,
      Ve.YOUTUBE
    ];
  }
};
let di = Ve;
o(di, "IMAGE", new Ve("image")), o(di, "VIDEO", new Ve("video")), o(di, "YOUTUBE", new Ve("youtube"));
class ar extends N {
  constructor(e, i, a, n, l, u) {
    super();
    o(this, "fromObject", (e) => ar.fromObject(e));
    this.id = e, this.order = i, this.src = a, this.type = n, this.createdAt = l, this.updatedAt = u;
  }
  static fromObject(e) {
    return new ar(
      s.parseField(e.id, Id),
      s.parseField(e.order),
      s.parseField(e.src),
      s.parseField(e.type, di),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class nr extends N {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "fromObject", (e) => nr.fromObject(e));
    this.price = e, this.icon = i, this.shortDescription = a, this.longDescription = n, this.usps = l, this.media = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromObject(e) {
    return new nr(
      s.parseField(e.price),
      s.parseField(e.icon),
      s.parseField(e.shortDescription),
      s.parseField(e.longDescription),
      s.parseField(e.usps),
      s.parseField(e.media, ar),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Ua extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b) {
    super();
    o(this, "entrypoint", "flow/templates");
    o(this, "fromObject", (e) => Ua.fromObject(e));
    this.company = e, this.id = i, this.name = a, this.active = n, this.triggers = l, this.nodes = u, this.transitions = h, this.pages = c, this.templateInfo = p, this.createdAt = m, this.updatedAt = b;
  }
  static fromObject(e) {
    return new Ua(
      s.parseField(e.company, J),
      s.parseField(e.id, dn),
      s.parseField(e.name),
      s.parseField(e.active),
      s.parseField(e.triggers, Ji),
      s.parseField(e.nodes, St),
      s.parseField(e.transitions, Qi),
      s.parseField(e.pages, cn),
      s.parseField(e.templateInfo, nr),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const q = class extends I {
  get comparisonDescription() {
    var t;
    return ((t = [
      { value: q.TODAY, label: "vergeleken met gisteren" },
      { value: q.YESTERDAY, label: "vergeleken met eergisteren" },
      { value: q.THIS_WEEK, label: "vergeleken met vorige week" },
      { value: q.LAST_WEEK, label: "vergeleken met voorgaande periode" },
      { value: q.LAST_2_WEEKS, label: "vergeleken met voorgaande periode" },
      { value: q.LAST_3_WEEKS, label: "vergeleken met voorgaande periode" },
      { value: q.LAST_4_WEEKS, label: "vergeleken met voorgaande periode" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get label() {
    var t;
    return ((t = [
      { value: q.TODAY, label: "vandaag" },
      { value: q.YESTERDAY, label: "gisteren" },
      { value: q.THIS_WEEK, label: "deze week" },
      { value: q.LAST_WEEK, label: "vorige week" },
      { value: q.LAST_2_WEEKS, label: "laatste 2 weken" },
      { value: q.LAST_3_WEEKS, label: "laatste 3 weken" },
      { value: q.LAST_4_WEEKS, label: "laatste 4 weken" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return q.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      q.TODAY,
      q.YESTERDAY,
      q.THIS_WEEK,
      q.LAST_WEEK,
      q.LAST_2_WEEKS,
      q.LAST_3_WEEKS,
      q.LAST_4_WEEKS
    ];
  }
};
let dt = q;
o(dt, "TODAY", new q("today")), o(dt, "YESTERDAY", new q("yesterday")), o(dt, "THIS_WEEK", new q("this-week")), o(dt, "LAST_WEEK", new q("last-week")), o(dt, "LAST_2_WEEKS", new q("last-2-weeks")), o(dt, "LAST_3_WEEKS", new q("last-3-weeks")), o(dt, "LAST_4_WEEKS", new q("last-4-weeks"));
class ei extends N {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "fromObject", (e) => ei.fromObject(e));
    this.newFlowsCount = e, this.activeFlowsCount = i, this.successfulFlowsCount = a, this.sentEmailsCount = n, this.openedEmailsCount = l, this.clickedEmailsCount = u, this.openedEmailsPercentage = h, this.clickedEmailsPercentage = c;
  }
  static fromObject(e) {
    return new ei(
      s.parseField(e.newFlowsCount),
      s.parseField(e.activeFlowsCount),
      s.parseField(e.successfulFlowsCount),
      s.parseField(e.sentEmailsCount),
      s.parseField(e.openedEmailsCount),
      s.parseField(e.clickedEmailsCount),
      s.parseField(e.openedEmailsPercentage),
      s.parseField(e.clickedEmailsPercentage)
    );
  }
}
class lr extends N {
  constructor(e, i) {
    super();
    o(this, "fromObject", (e) => lr.fromObject(e));
    this.current = e, this.previous = i;
  }
  static fromObject(e) {
    return new lr(
      s.parseField(e.current, ei),
      s.parseField(e.previous, ei)
    );
  }
}
class or extends N {
  constructor(e, i, a, n) {
    super();
    o(this, "fromObject", (e) => or.fromObject(e));
    this.current = e, this.dataScale = i, this.data = a, this.previous = n;
  }
  static fromObject(e) {
    return new or(
      s.parseField(e.current, ei),
      s.parseField(e.dataScale),
      e.data,
      s.parseField(e.previous, ei)
    );
  }
}
class Oh extends S {
  constructor(t, e, i) {
    super(), this.companyId = t, this.id = e, this.file = i;
  }
  get validationSchema() {
    return f({
      companyId: pe.validationSchema.required(),
      id: Cr.validationSchema.required(),
      file: ut().required()
    });
  }
  get requestPath() {
    return "/flow/assets";
  }
  get requestMethod() {
    return F.POST;
  }
  async parseRequest(t) {
    const e = new FormData();
    return e.append("companyId", t.companyId), e.append("id", t.id), e.append("file", t.file), e;
  }
  async parseResponse(t) {
    return ir.fromObject(t);
  }
  get contentType() {
    return "multipart/form-data";
  }
}
class Ch extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromFlow(t) {
    return new this(
      t.id.value
    );
  }
  get validationSchema() {
    return f({ id: d().required() });
  }
  get requestPath() {
    return `/flow/flows/${this.id}/activate`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class Ih extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromFlow(t) {
    return new this(
      t.id.value
    );
  }
  get validationSchema() {
    return f({ id: d().required() });
  }
  get requestPath() {
    return `/flow/flows/${this.id}/deactivate`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class Th extends S {
  constructor(t, e, i, a, n, l, u, h, c, p, m, b) {
    super(), this.id = t, this.name = e, this.brandId = i, this.teamIds = a, this.active = n, this.startNodeId = l, this.triggers = u, this.nodes = h, this.transitions = c, this.autoDeleteEnabled = p, this.autoDeleteAfterQuantity = m, this.autoDeleteAfterUnit = b;
  }
  static fromFlow(t) {
    return new this(
      t.id.value,
      t.name,
      t.brand.id.value,
      t.teams.map((e) => e.id.value),
      t.active,
      t.startNode.id.value,
      t.triggers.map((e) => e.toTriggerData()),
      t.nodes.map((e) => e.toNodeData()),
      t.transitions.map((e) => e.toTransitionData()),
      t.autoDeleteEnabled,
      t.autoDeleteAfterQuantity,
      t.autoDeleteAfterUnit
    );
  }
  get validationSchema() {
    return f({
      id: d().required(),
      name: d().required(),
      brandId: Pt.validationSchema.required(),
      teamIds: R().of(ve.validationSchema).required(),
      active: y().required(),
      startNodeId: d().required(),
      triggers: R().of(f({
        id: d().required(),
        type: d().required(),
        options: f().required(),
        createdAt: U().required(),
        updatedAt: U().required()
      })).required(),
      nodes: R().of(f({
        id: d().required(),
        type: d().required(),
        options: f().required(),
        createdAt: U().required(),
        updatedAt: U().required()
      })).required(),
      transitions: R().of(f({
        id: d().required(),
        fromNodeId: d().required(),
        toNodeId: d().required(),
        condition: d().nullable(),
        createdAt: U().required(),
        updatedAt: U().required()
      })).required(),
      autoDeleteEnabled: y(),
      autoDeleteAfterQuantity: _().nullable(),
      autoDeleteAfterUnit: d().nullable()
    });
  }
  get requestPath() {
    return `/flow/flows/${this.id}/change`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class xh extends S {
  constructor(t, e) {
    super(), this.id = t, this.name = e;
  }
  static fromFlow(t) {
    return new this(
      t.id.value,
      t.name
    );
  }
  get validationSchema() {
    return f({
      id: d().required(),
      name: d().required()
    });
  }
  get requestPath() {
    return `/flow/flows/${this.id}/change_name`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class Dh extends S {
  constructor(t, e) {
    super(), this.userId = t, this.message = e;
  }
  static create(t, e) {
    return new this(
      t.toString(),
      e
    );
  }
  get validationSchema() {
    return f({
      userId: se.validationSchema.required(),
      message: d().required()
    });
  }
  get requestPath() {
    return "/flow/templates/request_custom";
  }
  get requestMethod() {
    return F.POST;
  }
}
class Rh extends S {
  constructor(t, e, i, a, n, l) {
    super(), this.id = t, this.title = e, this.slug = i, this.content = a, this.mainCss = n, this.sectionCss = l;
  }
  static fromPage(t) {
    return new this(
      t.id.value,
      t.title,
      t.slug,
      t.content,
      t.mainCss,
      t.sectionCss
    );
  }
  get validationSchema() {
    return f({
      id: yl.validationSchema.required(),
      title: d().required(),
      slug: d().required(),
      content: d().required(),
      mainCss: d(),
      sectionCss: d()
    });
  }
  get requestPath() {
    return `/flow/pages/${this.id}/change`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class Nh extends S {
  constructor(t, e, i, a, n, l, u, h, c, p, m, b, v) {
    super(), this.templateId = t, this.companyId = e, this.flowId = i, this.name = a, this.brandId = n, this.teamIds = l, this.options = u, this.active = h, this.autoDeleteEnabled = c, this.autoDeleteAfterQuantity = p, this.autoDeleteAfterUnit = m, this.createdAt = b, this.updatedAt = v;
  }
  get validationSchema() {
    return f({
      templateId: d().required(),
      companyId: pe.validationSchema.required(),
      flowId: d().required(),
      name: d().required(),
      brandId: Pt.validationSchema.required(),
      teamIds: R().of(ve.validationSchema).required(),
      options: f().optional(),
      active: y().nullable(),
      autoDeleteEnabled: y().nullable(),
      autoDeleteAfterQuantity: _().nullable(),
      autoDeleteAfterUnit: d().nullable(),
      createdAt: d().nullable(),
      updatedAt: d().nullable()
    });
  }
  get requestPath() {
    return `/flow/templates/${this.templateId}/create_flow`;
  }
  get requestMethod() {
    return F.POST;
  }
}
class Ph extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromFlow(t) {
    return new this(
      t.id.value
    );
  }
  get validationSchema() {
    return f({ id: d().required() });
  }
  get requestPath() {
    return `/flow/flows/${this.id}/can_delete`;
  }
  async parseResponse(t) {
    return t.canDelete;
  }
}
class Mh extends S {
  constructor(t) {
    super(), this.id = t;
  }
  static fromFlow(t) {
    return new this(
      t.id.value
    );
  }
  get validationSchema() {
    return f({ id: d().required() });
  }
  get requestPath() {
    return `/flow/flows/${this.id}`;
  }
  get requestMethod() {
    return F.DELETE;
  }
}
class Lh extends S {
  constructor(t, e, i) {
    super(), this.recipient = t, this.subject = e, this.html = i;
  }
  get validationSchema() {
    return f({
      recipient: si.validationSchema.required(),
      subject: d().required(),
      html: d().required()
    });
  }
  get requestPath() {
    return "/flow/send_test_mail";
  }
  get requestMethod() {
    return F.POST;
  }
}
class kh extends S {
  constructor(t) {
    super(), this.range = t;
  }
  get validationSchema() {
    return f({ range: d().required() });
  }
  get requestPath() {
    return `/flow/statistics?range=${this.range.value}`;
  }
  get requestMethod() {
    return F.GET;
  }
  async parseResponse(t) {
    return lr.fromObject(t);
  }
}
class jh extends S {
  constructor(t, e) {
    super(), this.flowId = t, this.range = e;
  }
  get validationSchema() {
    return f({
      flowId: dn.validationSchema.required(),
      range: d().required()
    });
  }
  get requestPath() {
    const t = new URLSearchParams({ range: this.range.value });
    return `/flow/flows/${this.flowId.value}/statistics?${t.toString()}`;
  }
  get requestMethod() {
    return F.GET;
  }
  async parseResponse(t) {
    return or.fromObject(t);
  }
}
class qh extends S {
  constructor(t) {
    super(), this.id = t;
  }
  get validationSchema() {
    return f({ id: A.validationSchema.required() });
  }
  get requestPath() {
    return `/flow/executions/${this.id.toString()}/cancel`;
  }
  get requestMethod() {
    return F.PATCH;
  }
}
class Uh extends S {
  constructor(t, e = !0) {
    super(), this.contactId = t, this.optOut = e;
  }
  get validationSchema() {
    return f({
      contactId: A.validationSchema.required(),
      optOut: y().nullable()
    });
  }
  get requestPath() {
    return "/flow/executions/cancel-for-contact";
  }
  get requestMethod() {
    return F.POST;
  }
}
class Td extends A {
}
class ur extends N {
  constructor(e, i, a, n, l) {
    super();
    o(this, "fromObject", (e) => ur.fromObject(e));
    this.id = e, this.users = i, this.teams = a, this.createdAt = n, this.updatedAt = l;
  }
  static fromObject(e) {
    return new ur(
      s.parseField(e.id, Td),
      s.parseField(e.users),
      s.parseField(e.teams),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class xd extends A {
}
class dr extends N {
  constructor(e, i, a, n) {
    super();
    o(this, "fromObject", (e) => dr.fromObject(e));
    this.id = e, this.aiEmployees = i, this.createdAt = a, this.updatedAt = n;
  }
  static fromObject(e) {
    return new dr(
      s.parseField(e.id, xd),
      s.parseField(e.aiEmployees),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class hn extends A {
}
class Dd extends A {
}
class cr extends N {
  constructor(e, i, a, n, l, u, h, c, p) {
    super();
    o(this, "fromObject", (e) => cr.fromObject(e));
    this.id = e, this.users = i, this.contacts = a, this.brands = n, this.premiumFlows = l, this.aiEmployees = u, this.phoneSupport = h, this.createdAt = c, this.updatedAt = p;
  }
  static fromObject(e) {
    return new cr(
      s.parseField(e.id, Dd),
      s.parseField(e.users),
      s.parseField(e.contacts ?? null),
      s.parseField(e.brands),
      s.parseField(e.premiumFlows),
      s.parseField(e.aiEmployees),
      s.parseField(e.phoneSupport),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class hr extends s {
  constructor(e, i, a, n, l, u, h, c, p, m) {
    super();
    o(this, "entrypoint", "subscription/plans");
    o(this, "fromObject", (e) => hr.fromObject(e));
    this.id = e, this.name = i, this.description = a, this.price = n, this.slug = l, this.keyvuePlanAddon = u, this.winckPlanAddon = h, this.askNoaPlanAddon = c, this.createdAt = p, this.updatedAt = m;
  }
  static fromObject(e) {
    return new hr(
      s.parseField(e.id, hn),
      s.parseField(e.name),
      s.parseField(e.description),
      s.parseField(e.price),
      s.parseField(e.slug),
      s.parseField(e.keyvuePlanAddon, ur),
      s.parseField(e.winckPlanAddon, cr),
      s.parseField(e.askNoaPlanAddon, dr),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
const fi = class extends I {
  get label() {
    var t;
    return ((t = [
      { value: fi.MONTHLY, label: "Maandelijks" }
    ].find((e) => this.equals(e.value))) == null ? void 0 : t.label) ?? this.value;
  }
  get schemaConfig() {
    return fi.validationSchema;
  }
  static get validationSchema() {
    return d().oneOf(this.values.map((t) => t.value));
  }
  static get values() {
    return [
      fi.MONTHLY
    ];
  }
};
let fs = fi;
o(fs, "MONTHLY", new fi("monthly"));
class Rd extends A {
}
class pr extends N {
  constructor(e, i, a, n, l) {
    super();
    o(this, "fromObject", (e) => pr.fromObject(e));
    this.id = e, this.users = i, this.teams = a, this.createdAt = n, this.updatedAt = l;
  }
  static fromObject(e) {
    return new pr(
      s.parseField(e.id, Rd),
      s.parseField(e.users),
      s.parseField(e.teams),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class rs extends A {
}
class Nd extends A {
}
class mr extends N {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "fromObject", (e) => mr.fromObject(e));
    this.id = e, this.users = i, this.contacts = a, this.brands = n, this.premiumFlows = l, this.aiEmployees = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromObject(e) {
    return new mr(
      s.parseField(e.id, Nd),
      s.parseField(e.users),
      s.parseField(e.contacts),
      s.parseField(e.brands),
      s.parseField(e.premiumFlows),
      s.parseField(e.aiEmployees),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Pd extends A {
}
class fr extends N {
  constructor(e, i, a, n, l, u) {
    super();
    o(this, "fromObject", (e) => fr.fromObject(e));
    this.id = e, this.amount = i, this.startDate = a, this.endDate = n, this.createdAt = l, this.updatedAt = u;
  }
  static fromObject(e) {
    return new fr(
      s.parseField(e.id, Pd),
      s.parseField(e.amount),
      s.parseField(e.startDate, Date),
      s.parseField(e.endDate, Date),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Md extends A {
}
class br extends N {
  constructor(e, i, a, n) {
    super();
    o(this, "fromObject", (e) => br.fromObject(e));
    this.id = e, this.aiEmployees = i, this.createdAt = a, this.updatedAt = n;
  }
  static fromObject(e) {
    return new br(
      s.parseField(e.id, Md),
      s.parseField(e.aiEmployees),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class $a extends s {
  constructor(e, i, a, n, l, u, h, c, p, m, b) {
    super();
    o(this, "entrypoint", "subscription/subscriptions");
    o(this, "fromObject", (e) => $a.fromObject(e));
    this.id = e, this.plan = i, this.discount = a, this.keyvueSubscriptionAddon = n, this.winckSubscriptionAddon = l, this.askNoaSubscriptionAddon = u, this.billingCycle = h, this.startDate = c, this.endDate = p, this.createdAt = m, this.updatedAt = b;
  }
  static fromObject(e) {
    return new $a(
      s.parseField(e.id, rs),
      s.parseField(e.plan, hr),
      s.parseField(e.discount, fr),
      s.parseField(e.keyvueSubscriptionAddon, pr),
      s.parseField(e.winckSubscriptionAddon, mr),
      s.parseField(e.askNoaSubscriptionAddon, br),
      s.parseField(e.billingCycle, fs),
      s.parseField(e.startDate, Date),
      s.parseField(e.endDate, Date),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class $h extends S {
  constructor(t, e) {
    super(), this.id = t, this.planId = e;
  }
  get validationSchema() {
    return f({
      id: rs.validationSchema.required(),
      planId: hn.validationSchema.required()
    });
  }
  get requestPath() {
    return `/subscription/subscriptions/${this.id}/change_plan`;
  }
  get requestMethod() {
    return F.PATCH;
  }
  async parseRequest(t) {
    return super.parseRequest({
      id: t.id.value,
      planId: t.planId.value
    });
  }
}
class Bh extends S {
  constructor(t, e, i, a, n, l) {
    super(), this.id = t, this.users = e, this.contacts = i, this.brands = a, this.premiumFlows = n, this.aiEmployees = l;
  }
  get validationSchema() {
    return f({
      id: rs.validationSchema.required(),
      users: _(),
      contacts: _(),
      brands: _(),
      premiumFlows: _(),
      aiEmployees: _()
    });
  }
  get requestPath() {
    return `/subscription/subscriptions/${this.id}/change_winck_subscription_addon`;
  }
  get requestMethod() {
    return F.PATCH;
  }
  async parseRequest(t) {
    return super.parseRequest({
      ...t,
      id: t.id.value
    });
  }
}
class Vh extends S {
  constructor(t, e) {
    super(), this.id = t, this.aiEmployees = e;
  }
  get validationSchema() {
    return f({
      id: rs.validationSchema.required(),
      aiEmployees: _()
    });
  }
  get requestPath() {
    return `/subscription/subscriptions/${this.id}/change_ask_noa_subscription_addon`;
  }
  get requestMethod() {
    return F.PATCH;
  }
  async parseRequest(t) {
    return super.parseRequest({
      ...t,
      id: t.id.value
    });
  }
}
class Hh extends S {
  constructor(t, e, i, a = null, n = null) {
    super(), this.companyId = t, this.id = e, this.planId = i, this.discountAmount = a, this.discountEndDate = n;
  }
  get validationSchema() {
    return f({
      companyId: pe.validationSchema.required(),
      id: rs.validationSchema.required(),
      planId: hn.validationSchema.required(),
      discountAmount: _().nullable(),
      discountEndDate: U().nullable()
    });
  }
  get requestPath() {
    return "/subscription/subscriptions";
  }
  get requestMethod() {
    return F.POST;
  }
  async parseRequest(t) {
    return super.parseRequest({
      ...t,
      companyId: t.companyId.value,
      id: t.id.value,
      planId: t.planId.value
    });
  }
}
class Gh extends S {
  constructor(t) {
    super(), this.uid = t;
  }
  get validationSchema() {
    return f({ uid: pe.validationSchema });
  }
  get requestPath() {
    return "/beefree/token";
  }
  async parseResponse(t) {
    if (!("token" in t))
      throw new Error("Invalid response");
    return t.token;
  }
}
class Ld extends A {
}
class Ba extends s {
  constructor(e, i, a, n, l, u, h, c) {
    super();
    o(this, "entrypoint", "services/crawler/crawl_results");
    o(this, "fromObject", (e) => Ba.fromObject(e));
    this.id = e, this.brand = i, this.markdown = a, this.websiteUrl = n, this.externalId = l, this.crawledAt = u, this.createdAt = h, this.updatedAt = c;
  }
  static fromObject(e) {
    return new Ba(
      s.parseField(e.id, Ld),
      s.parseField(e.brand, Jt),
      s.parseField(e.markdown),
      s.parseField(e.websiteUrl),
      s.parseField(e.externalId),
      s.parseField(e.crawledAt, Date),
      s.parseField(e.createdAt, Date),
      s.parseField(e.updatedAt, Date)
    );
  }
}
class Wh extends S {
  constructor(t, e, i) {
    super(), this.killedBy = t, this.reason = e, this.killedAt = i;
  }
  get validationSchema() {
    return f({
      killedBy: f().required(),
      reason: d().nullable(),
      killedAt: U().nullable()
    }).strict(!0);
  }
  async parseRequest(t) {
    return {
      ...t,
      killedBy: t.killedBy.id.id
    };
  }
  get requestPath() {
    return "/services/openai/kill_switches";
  }
  get requestMethod() {
    return F.POST;
  }
}
class zh extends S {
  constructor(t) {
    super(), this.resurrectedAt = t;
  }
  get requestPath() {
    return "/services/openai/kill_switches/resurrect";
  }
  get requestMethod() {
    return F.PATCH;
  }
  get validationSchema() {
    return f({ resurrectedAt: U().nullable() });
  }
}
class kd extends A {
}
class Va extends s {
  constructor(e, i, a, n, l) {
    super();
    o(this, "entrypoint", "services/openai/kill_switches");
    o(this, "fromObject", (e) => Va.fromObject(e));
    this.id = e, this.killedBy = i, this.reason = a, this.killedAt = n, this.resurrectedAt = l;
  }
  static fromObject(e) {
    return new Va(
      s.parseField(e.id, kd),
      s.parseField(e.killedBy, ee),
      s.parseField(e.reason),
      s.parseField(e.killedAt, Date),
      s.parseField(e.resurrectedAt, Date)
    );
  }
  isResurrected() {
    return this.resurrectedAt !== null;
  }
}
export {
  ch as AIRange,
  Si as AIRole,
  on as AIRoleId,
  Ma as AISettings,
  Nn as AIStatistics,
  jt as AIStatus,
  Yc as ActivateAssistentCommand,
  Ch as ActivateFlowCommand,
  ah as ActivateGoalCommand,
  nh as ActivateSystemGoalCommand,
  wt as Address,
  pi as AnswerLength,
  Dn as Appointment,
  fl as AppointmentId,
  qt as AppointmentStatus,
  It as AppointmentType,
  ph as ApproveReportCommand,
  dr as AskNoaPlanAddon,
  xd as AskNoaPlanAddonId,
  br as AskNoaSubscriptionAddon,
  Md as AskNoaSubscriptionAddonId,
  ir as Asset,
  Ah as AssetId,
  ki as Assignee,
  Yu as AssigneeId,
  El as Assistent,
  $s as AssistentDocument,
  hd as AssistentDocumentId,
  Mt as AssistentId,
  Gt as AssistentRole,
  ls as AssistentStatus,
  ys as Attachment,
  Qu as AttachmentId,
  wh as AvailableAIRole,
  Hs as Avatar,
  Jc as AvatarId,
  ft as AvatarVariant,
  vl as Behavior,
  rn as BehaviorId,
  fs as BillingCycle,
  Jt as Brand,
  Pt as BrandId,
  ya as Brochure,
  Or as BrochureId,
  Ni as BuildType,
  kc as CanDeleteBrandCommand,
  Ph as CanDeleteFlowCommand,
  ic as CanDeleteTeamCommand,
  Bc as CanDeleteUserCommand,
  qh as CancelExecutionCommand,
  Uh as CancelExecutionsForContactCommand,
  mh as ChangeAISettingsCommand,
  Vh as ChangeAskNoaSubscriptionAddonCommand,
  zc as ChangeAssistentCommand,
  Lc as ChangeBrandCommand,
  nc as ChangeContactAddressCommand,
  lc as ChangeContactBirthDateCommand,
  oc as ChangeContactEmailCommand,
  uc as ChangeContactFutureAddressCommand,
  dc as ChangeContactFutureAddressStartingDateCommand,
  cc as ChangeContactGenderCommand,
  hc as ChangeContactMobilePhoneNumberCommand,
  pc as ChangeContactNameCommand,
  mc as ChangeContactPhoneNumberCommand,
  Fh as ChangeCredentialsCommand,
  Ic as ChangeDocumentTemplateCommand,
  Th as ChangeFlowCommand,
  xh as ChangeFlowNameCommand,
  Fl as ChangeGoalCommand,
  wl as ChangeNoteCommand,
  Rh as ChangePageCommand,
  fh as ChangeReportContentCommand,
  bh as ChangeRuleCommand,
  $h as ChangeSubscriptionPlanCommand,
  Al as ChangeSystemGoalCommand,
  sc as ChangeTeamBrandCommand,
  rc as ChangeTeamSocialMediaCommand,
  Wd as ChangeTemplateCommand,
  Vc as ChangeUserKeyflowRoleCommand,
  Bh as ChangeWinckSubscriptionAddonCommand,
  Ut as Channel,
  nn as Chat,
  Da as ChatConnectGoal,
  yi as ChatConnectGoalId,
  mi as ChatConnectGoalStatus,
  Ra as ChatConnectSystemGoal,
  Tr as ChatConnectSystemGoalId,
  Ks as ChatContactData,
  fd as ChatContactDataId,
  gd as ChatEmail,
  Sl as ChatEmailId,
  Mi as ChatEmailType,
  ss as ChatId,
  ot as ChatStyle,
  Ud as Client,
  S as Command,
  Os as Comment,
  Ju as CommentId,
  vt as CommentOrigin,
  He as CommentVisibility,
  J as Company,
  pe as CompanyId,
  Wu as CompanyLogo,
  _a as CompanyLogoId,
  xt as Contact,
  Ge as ContactDataField,
  Ce as ContactId,
  Zc as CountChatsCommand,
  Gc as CountLeadsCommand,
  Ba as CrawlResult,
  Ld as CrawlResultId,
  Rc as CreateAppointmentCommand,
  Oh as CreateAssetCommand,
  Wc as CreateAssistentCommand,
  Mc as CreateBrandCommand,
  Bd as CreateBrochureCommand,
  Uc as CreateCompanyLogoCommand,
  fc as CreateContactCommand,
  Sh as CreateCredentialsCommand,
  vc as CreateDocumentCommand,
  Ac as CreateDocumentLogoCommand,
  Tc as CreateDocumentTemplateCommand,
  Nh as CreateFlowFromTemplateCommand,
  rh as CreateGoalCommand,
  ec as CreateLogoCommand,
  vh as CreateRuleCommand,
  Hh as CreateSubscriptionCommand,
  Pc as CreateTaskCommand,
  ac as CreateTeamCommand,
  Kd as CreateTemplateCommand,
  ja as Credentials,
  un as CredentialsId,
  Qc as DeactivateAssistentCommand,
  Ih as DeactivateFlowCommand,
  lh as DeactivateGoalCommand,
  oh as DeactivateSystemGoalCommand,
  Kc as DeleteAssistentCommand,
  qc as DeleteBrandCommand,
  Vd as DeleteBrochureCommand,
  $c as DeleteCompanyLogoCommand,
  bc as DeleteContactCommand,
  wc as DeleteDocumentCommand,
  Oc as DeleteDocumentLogoCommand,
  xc as DeleteDocumentTemplateCommand,
  Mh as DeleteFlowCommand,
  uh as DeleteGoalCommand,
  Eh as DeleteRuleCommand,
  Qd as DeleteTemplateCommand,
  fr as Discount,
  Pd as DiscountId,
  Hc as Document,
  Gi as DocumentId,
  ks as DocumentLogo,
  _t as DocumentLogoId,
  Ot as DocumentRenderStatus,
  od as DocumentTemplate,
  Xt as DocumentTemplateId,
  $t as DocumentType,
  Hd as DownloadBrochureCommand,
  Fc as DownloadDocumentCommand,
  si as Email,
  vd as EmailId,
  Gs as EmailRouting,
  gl as EmailRoutingId,
  Dt as EstimateOffsetType,
  Bs as Faq,
  pd as FaqId,
  th as FavoriteChatCommand,
  ye as FeatureFieldName,
  Us as Features,
  sn as FeaturesId,
  js as Filter,
  Ht as FilterMode,
  kt as FilterType,
  Dr as Flow,
  dn as FlowId,
  Ua as FlowTemplate,
  zt as Formality,
  Xc as ForwardChatCommand,
  eh as ForwardChatEmailCommand,
  ui as Frequency,
  Xs as From,
  wd as FromId,
  Tt as Gender,
  Gh as GetBeefreeTokenCommand,
  hh as GetStatisticsForAssistentCommand,
  kh as GetStatisticsForCompanyCommand,
  jh as GetStatisticsForFlowCommand,
  go as GetTokensCommand,
  an as Goal,
  V as GoalFieldName,
  F as HttpMethod,
  zs as Interaction,
  md as InteractionId,
  oi as InteractionOrigin,
  li as InteractionType,
  hi as KeyflowRole,
  ur as KeyvuePlanAddon,
  Td as KeyvuePlanAddonId,
  pr as KeyvueSubscriptionAddon,
  Rd as KeyvueSubscriptionAddonId,
  Wh as KillOpenAICommand,
  Va as KillSwitch,
  kd as KillSwitchId,
  Ls as Layout,
  Ir as LayoutId,
  Bi as LayoutSize,
  ri as Lead,
  Ai as LeadId,
  Ta as LeadPermission,
  dd as LeadPermissionId,
  ad as Logo,
  Cr as LogoId,
  ar as Media,
  Id as MediaId,
  di as MediaType,
  Qt as Name,
  St as Node,
  yd as NodeId,
  Xe as NodeType,
  ji as Origin,
  Zu as OriginId,
  cn as Page,
  yl as PageId,
  wr as Password,
  Wt as Personality,
  is as Phase,
  ct as PhaseCategory,
  sd as PhaseId,
  vi as PhoneNumber,
  ts as Pipeline,
  ie as PipelineCategory,
  zi as PipelineId,
  hr as Plan,
  hn as PlanId,
  de as Position,
  Gd as PreviewBrochureCommand,
  Sc as PreviewDocumentCommand,
  Dc as PreviewDocumentTemplateCommand,
  Zd as PreviewTemplateCommand,
  Wi as Project,
  td as ProjectId,
  Vi as Prompt,
  Li as PromptType,
  tn as QuickOption,
  Rn as QuickOptionId,
  dt as Range,
  Ei as Reason,
  rd as ReasonId,
  qi as Referrer,
  _u as ReferrerId,
  vo as RefreshTokensCommand,
  Nc as RegisterLeadViewedCommand,
  ld as RenderStatus,
  er as ReplyTo,
  Fd as ReplyToId,
  La as Report,
  ln as ReportId,
  Dh as RequestCustomFlowTemplateCommand,
  dh as RequestNewFunctionalityCommand,
  s as Resource,
  A as ResourceId,
  zh as ResurrectOpenAICommand,
  zu as Role,
  ka as Rule,
  Rt as RuleFrequency,
  xr as RuleId,
  Xi as SchemaObject,
  ni as Score,
  Lh as SendTestEmailCommand,
  _s as Sender,
  Sd as SenderId,
  qa as SentFlowEmail,
  Ad as SentFlowEmailId,
  Cs as Source,
  Xu as SourceId,
  ei as Statistics,
  Js as StatisticsForAssistent,
  lr as StatisticsForCompany,
  or as StatisticsForFlow,
  Is as Status,
  xa as StatusSettings,
  cd as StatusSettingsId,
  Ui as Subject,
  ed as SubjectId,
  $a as Subscription,
  rs as SubscriptionId,
  Ys as Tag,
  bd as TagId,
  Ki as Task,
  bl as TaskId,
  gt as TaskStatus,
  Ke as TaskType,
  Fe as Team,
  ve as TeamId,
  bt as TeamType,
  nd as Template,
  Zt as TemplateId,
  nr as TemplateInfo,
  Ia as Text,
  ud as TextId,
  bi as ThirdPartySource,
  Zs as To,
  Ed as ToId,
  tr as TrackedEmail,
  $i as Transaction,
  id as TransactionId,
  Qi as Transition,
  Od as TransitionId,
  Ji as Trigger,
  Cd as TriggerId,
  Ct as TriggerType,
  sh as UnfavoriteChatCommand,
  ee as User,
  se as UserId,
  Ri as UserType,
  I as ValueObject,
  We as Variant,
  Ye as Voice,
  Yi as Widget,
  en as WidgetId,
  wi as WidgetType,
  cr as WinckPlanAddon,
  Dd as WinckPlanAddonId,
  mr as WinckSubscriptionAddon,
  Nd as WinckSubscriptionAddonId
};
